import React from 'react';
import ReactDOM from 'react-dom';
import Config from '../Config';
import AjaxRemoteUtil from '../utils/AjaxRemoteUtil';
import RecordsUtil from '../utils/RecordsUtil';
import AuthorityUtil from '../utils/AuthorityUtil';
import ToolBarUtil from '../utils/ToolBarUtil';
import QueryUtil from '../utils/QueryUtil';
import GOTUtil from '../utils/GOTUtil';
import GOT from '../utils/GOT';
import StringUtil from '../utils/StringUtil';
import FormResourceUtil from '../utils/FormResourceUtil';
import FormItemUtil from '../utils/FormItemUtil';
import CommandResolver from '../utils/CommandResolver';
import Warning from '../utils/Warn';
import GOTPropertiesUtil from '../utils/GOTPropertiesUtil';

import FormDataSources from './FormDataSources';
import CommandHelper from '../remote/CommandHelper';
import Command from '../remote/Command';
import GongqiDataType from '../remote/GongqiDataType';
import ServiceHelper from '../remote/ServiceHelper';
import QueryOrderByType from '../query/remote/QueryOrderByType';
import RecordsActions from '../actions/RecordsActions';
import CommandActions from '../actions/CommandActions';
import QueryActions from '../actions/QueryActions';
import UtilActions from '../actions/UtilActions';
import ToolBarActions from '../actions/ToolBarActions';
import FocusController from '../components/FocusController';
import FormDataSourceGroupArg from '../forms/sys/datasource/FormDataSourceGroupArg';
import FormDataSourceGroupResult from '../forms/sys/datasource/FormDataSourceGroupResult';
import RecordCondition from '../forms/sys/remote/RecordCondition';
import RecordConditionTask from '../forms/sys/remote/RecordConditionTask';
import Attachment from '../components/attachment/Attachment';
import QueryTable from '../query/remote/QueryTable';
import QueryOrderByItem from '../universalView/remote/QueryOrderByItem';
import QueryWhereItem from '../universalView/remote/QueryWhereItem';

import {DataGridUserChangeStore,RecordAutoSaveStore,RecordNextStore,RecordNextPageStore,RecordPrevStore,RecordPrevPageStore,RecordFirstStore,RecordLastStore,RecordRefreshStore,RecordFetchAllStore,RecordNewStore} from '../stores/RecordsStore';
import {CmdExecuteQueryStore} from '../stores/CmdTypeStore';
import {SelectAllRecordsStore} from '../stores/CommandStore';

import FormItemDateDisplay from '../formItem/display/FormItemDateDisplay';
import FormItemTimeDisplay from '../formItem/display/FormItemTimeDisplay';
import FormItemDecimalDisplay from '../formItem/display/FormItemDecimalDisplay';
import FormDataSourceAuthorityType from './FormDataSourceAuthorityType';

import ExportTable from '../export/ExportTable';
import Fade from '../utils/Fade';

import Warn from "../utils/Warn";

import LayerManager from '../manager/LayerManager';

import CurrentRecordInfo from '../currentRecordInfo/CurrentRecordInfo';
import FocusActions from '../actions/FocusActions';
import { func } from 'react/lib/ReactPropTypes';

import DataSetUtil from '../universalView/dataSet/DataSetUtil';
import PivotExportDialog from '../components/pivotExport/PivotExportDialog';

export default class FormDataSourceGroup
{
	constructor(groupAlias,mainSource,formDataSources,forLookup = false)
	{
		this.formDataSources = formDataSources;
		this.groupAlias = groupAlias;
    window.groupActiveRecordStateObj[this.groupAlias] = {};
    window.lastEditedDataFields[this.groupAlias] = {};
		this.mainSource = mainSource;
    this.tableName = this.mainSource.tableName;
		this.isTempTable = mainSource.isTempTable;
		this.linkType = mainSource.joinType;
		this.startPosition = mainSource.startPosition;
		this.allowExternalJoin = mainSource.allowExternalJoin;
		this.sources = [mainSource];
		this.linkGroup = null;
    this.forLookup = forLookup;
    this.lockedRecNew = false;
    this.externalJoinGroupAlias = null;
    this.records = [];
    this.currentRecord = null;
    this.autoJoinParent = true;
    this.queryChanged = false;
    this.ds_AllowAdd = true;
    this.ds_AllowDelete = true;
    this.ds_AllowExport = true;
    this.ds_AllowSave = true;
    this.ds_AllowAttachment = true;
    this.ds_AllowQuery = true;
    this.ds_AllwEdit = true;

    this.dataPageSize = Config.dataPageSize;
      
    this.aggreateTableFields = [];
    this.aggreateDimTableFiels = [];
    this.mapRecId = {};
    this.recordsBak = {};

    this.afterRecordConditionTask=[];

    let formStoreKey = FormItemUtil.getFormStoresKey(this.formDataSources.formModule.menuItemId,this.formDataSources.formModule.formId);
    let formStore = window.parent.window[formStoreKey];
    let mapQueryTable = formStore?formStore.mapQueryTable:null;
    let queryTableKey = this.formDataSources.formModule.formId+"_"+this.mainSource.xml.id;
    var queryTemplate = {
      qname:"Query",nextInnerId:10000,Properties:{
        Title:{V:""},Status:{V:"Open"},Literals:{V:"forcePlaceholders"},UseCache:{V:true},FetchType:{V:"List"},
        CreatedDate:{V:""},CreatedTime:{V:""},CreatedBy:{V:""},ModifiedDate:{V:""},ModifiedTime:{V:""},ModifiedBy:{V:""},
      }
    };
    let queryTable;
    if(mapQueryTable && mapQueryTable[queryTableKey])
    {
      if(this.mainSource.isTempTable == true)
      {
        this.hasTempDefaultQuery = true;
      }
    
      queryTable = QueryUtil.convertQueryTable2XML(mapQueryTable[queryTableKey], queryTemplate);
      if(window.isDataSetView == true)
      {
        this.dataSetQueryTable = mapQueryTable[queryTableKey];
        this.initDataSetQueryTable =JSON.stringify(mapQueryTable[queryTableKey]);
      }
    }
    else
    {
      queryTable = QueryUtil.buildBaseQueryTable(this.mainSource.xml,this.formDataSources.xml);  
    }

    //queryTable = QueryUtil.buildBaseQueryTable(this.mainSource.xml,this.formDataSources.xml); 
    queryTemplate.QueryTable = queryTable;
    this.baseQuery = queryTemplate;
    this.fieldCache = {};
    this.initAliasList();
		this.unsubscribeCmdExcuteQueryStore = 
			CmdExecuteQueryStore.listen(this.onExecuteQuery.bind(this));	
    this.unsubscribeRecordsStore = 
      DataGridUserChangeStore.listen(this.onDataGridUserChanged.bind(this));
    if(!this.forLookup)
      this.unsubscribeRecordAutoSaveStore = 
        RecordAutoSaveStore.listen(this.onRecordAutoSave.bind(this));
    this.unsubscribeRecordNextStore = 
      RecordNextStore.listen(this.onRecordNext.bind(this));
    this.unsubscribeRecordNextPageStore = 
      RecordNextPageStore.listen(this.recordNextPage.bind(this));
    this.unsubscribeRecordPrevPageStore = 
      RecordPrevPageStore.listen(this.recordPrevPage.bind(this));
    this.unsubscribeRecordPrevStore = 
      RecordPrevStore.listen(this.onRecordPrev.bind(this));
    this.unsubscribeRecordFirstStore = 
      RecordFirstStore.listen(this.recordFirst.bind(this));
    this.unsbuscribeRecordLastStore = 
      RecordLastStore.listen(this.recordLast.bind(this));
    this.unsubscribeRecordNewStore = 
      RecordNewStore.listen(this.onRecordNew.bind(this));
    this.unsubscribeRecordFetchAllStore = RecordFetchAllStore.listen(this.recordFetchAll.bind(this));
    this.unsubscribeRecordRefreshStore = 
      RecordRefreshStore.listen(this.recordRefresh.bind(this));
    this.unsubscribeSelectAllRecordsStore = 
      SelectAllRecordsStore.listen(this.onSelectAllRecords.bind(this));
    //this.unsubscribeCurrentRecordChangeStore = 
    //  CurrentRecordChangeStore.listen(this.onCurrentRecordChanged.bind(this));
	}

  componentWillUnmount()
  {
    this.unsubscribeCmdExcuteQueryStore();
    this.unsubscribeRecordsStore();
    if(!this.forLookup)
      this.unsubscribeRecordAutoSaveStore();
    this.unsubscribeRecordNextStore();
    this.unsubscribeRecordNextPageStore();
    this.unsubscribeRecordPrevPageStore();
    this.unsubscribeRecordPrevStore();
    this.unsubscribeRecordFirstStore();
    this.unsbuscribeRecordLastStore();
    this.unsubscribeRecordNewStore();
    this.unsubscribeRecordFetchAllStore();
    this.unsubscribeRecordRefreshStore();
    this.unsubscribeSelectAllRecordsStore();
  }

  tempDataMethodField = {};
  tempDataMethodFieldType = {};
  addTempDataMethodField(_key,_field,type)
  {
    this.tempDataMethodField[_key] = _field;
    this.tempDataMethodFieldType[_key] = type;  
  }
  
  getTempDataMethodField()
  {
    return this.tempDataMethodField;
  }
  
  isTempDataMethodField(_field1,_field2 = null)
  {
    let fvalue;
    if(_field2 != null)
      fvalue = _field1 + "." + _field2;
    else
      fvalue = _field1;
    return this.tempDataMethodField.hasOwnProperty(fvalue);
  }

  deleteRecordTempDataMethodField(record)
  {
    var tempDataMethodField = this.getTempDataMethodField();
    for(var _field in tempDataMethodField)
    {
      if(record.hasOwnProperty(_field))
      {
        delete record[_field];
      }
    }
  }

  getCurRecVersion(record)
  { 
    if(!record)
      record = this.currentRecord;
    if(!record)
      return -2;
    var recVersion = record[this.groupAlias+".recVersion"];
    return recVersion;
  }

  reverseSelectedRecords(records)
  {
    let _selectRecordsKeys = [];let formModule = this.formDataSources.formModule;
    CommandActions.getSelectRecordsKey(_selectRecordsKeys,this.groupAlias,formModule.menuItemId,formModule.formId,formModule.instanceUUId);
    if(_selectRecordsKeys.length == 0)
      return false;

    if(this.mainSource.isTempTable == true && this.tempRecordsFilter)
    {
      if(this.tempRecordsFilter.length != records.length)
      {
        let tempRecordsFilterRecIdMap = {};
        for(let i = 0;i<this.tempRecordsFilter.length;i++)
        {
          let __record = this.tempRecordsFilter[i];
          let _recId = __record[this.groupAlias+".recId"];
          tempRecordsFilterRecIdMap[_recId] = true;
        }
        let records2 = [];
        for(let i = 0;i<records.length;i++)
        {
          let record = records[i];
          let _recId = record[this.groupAlias+".recId"];
          if(!tempRecordsFilterRecIdMap.hasOwnProperty(_recId))
            continue;
          records2.push(record);
          for(let k = 0;k<_selectRecordsKeys.length;k++)
          {
            let dataField = _selectRecordsKeys[k];
            record[dataField] = !record[dataField];
          }
        }
        CommandActions.reverseSelectedRecords(this.groupAlias);
        return true;
      }

    }
      
    
    for(let i = 0;i<records.length;i++)
    {
      let record = records[i];
      for(let k = 0;k<_selectRecordsKeys.length;k++)
      {
        let dataField = _selectRecordsKeys[k];
        record[dataField] = !record[dataField];
      }
    }
    CommandActions.reverseSelectedRecords(this.groupAlias);
    return true;
  }

  selectRecords(value,records)
  {
    let _selectRecordsKeys = [];let formModule = this.formDataSources.formModule;
    CommandActions.getSelectRecordsKey(_selectRecordsKeys,this.groupAlias,formModule.menuItemId,formModule.formId,formModule.instanceUUId);
    if(_selectRecordsKeys.length == 0)
      return false;

    if(this.mainSource.isTempTable == true && this.tempRecordsFilter)
    {
      if(this.tempRecordsFilter.length != records.length)
      {
        let tempRecordsFilterRecIdMap = {};
        for(let i = 0;i<this.tempRecordsFilter.length;i++)
        {
          let __record = this.tempRecordsFilter[i];
          let _recId = __record[this.groupAlias+".recId"];
          tempRecordsFilterRecIdMap[_recId] = true;
        }
        let records2 = [];
        for(let i = 0;i<records.length;i++)
        {
          let record = records[i];
          let _recId = record[this.groupAlias+".recId"];
          if(!tempRecordsFilterRecIdMap.hasOwnProperty(_recId))
            continue;
          records2.push(record);
          for(let k = 0;k<_selectRecordsKeys.length;k++)
          {
            let dataField = _selectRecordsKeys[k];
            record[dataField] = value;
          }
        }
        CommandActions.selectRecords2(value,this.groupAlias,null,records);
        return true;
      }

    }
      
    
    for(let i = 0;i<records.length;i++)
    {
      let record = records[i];
      for(let k = 0;k<_selectRecordsKeys.length;k++)
      {
        let dataField = _selectRecordsKeys[k];
        record[dataField] = value;
      }
    }
    CommandActions.selectRecords2(value,this.groupAlias,null,records);
    return true;
  }

  onSelectAllRecords(value,groupAlias,moduleInstanceId)
  {
    if(this.groupAlias != groupAlias)
      return;
    let formModule = this.formDataSources.formModule;
    if(moduleInstanceId != formModule.instanceUUId)
      return;
    let _selectRecordsKeys = [];
    CommandActions.getSelectRecordsKey(_selectRecordsKeys,this.groupAlias,formModule.menuItemId,formModule.formId,formModule.instanceUUId);
    if(_selectRecordsKeys.length == 0)
      return;
    let records = this.records;
    if(this.mainSource.isTempTable == true && this.tempRecordsFilter)
    {
      if(this.tempRecordsFilter.length != records.length)
      {
        let tempRecordsFilterRecIdMap = {};
        for(let i = 0;i<this.tempRecordsFilter.length;i++)
        {
          let __record = this.tempRecordsFilter[i];
          let _recId = __record[this.groupAlias+".recId"];
          tempRecordsFilterRecIdMap[_recId] = true;
        }

        for(let i = 0;i<records.length;i++)
        {
          let record = records[i];
          let _recId = record[this.groupAlias+".recId"];
          if(!tempRecordsFilterRecIdMap.hasOwnProperty(_recId))
            continue;
          for(let k = 0;k<_selectRecordsKeys.length;k++)
          {
            let dataField = _selectRecordsKeys[k];
            record[dataField] = value;
          }
        }
        return;
      }

    }
   
    for(let i = 0;i<records.length;i++)
    {
      let record = records[i];
      for(let k = 0;k<_selectRecordsKeys.length;k++)
      {
        let dataField = _selectRecordsKeys[k];
        record[dataField] = value;
      }
    }
  }

  doRecordNew(sync=false)
  {

    if(this.linkGroup)
      if(this.linkGroup.isCurrentRecordModified() && !isWorkFlow)
      {
        Warning.show({text:"请先保存关联记录"});
        return;
      }

    var arg = new FormDataSourceGroupArg();
    arg.groupAlias = this.groupAlias;arg.aliasList=null;arg.argType=0;arg.arg=null;
    if(!this.getAuthorityFinal("test",FormDataSourceAuthorityType.Add,this.currentRecord))
      return;
    var result = this.onRecordAutoSave(this.groupAlias);
    if(result && (result.remoteFail || window.rowChangeAutoSaveFail))
    {
      window.rowChangeAutoSaveFail=false;
      return;
    }
    

    if(!this.mainSource.isTempTable && this.linkGroup!=null && this.linkGroup.currentRecord!=null)
    {
        var list = GOTUtil.getQueryRelationItemByPropertyQuery(this.formQuery,"dataField");

        if(list.length>=1)
        {
          var array = [];//["OBJTYPE:java.lang.Object[]"];
          for(let i = 0;i<list.length;i++)
          {
            var obj = list[i];
            let parent = obj.parent;
            let item = obj.item;
            var key = item.Properties.Field.V;
            var value = item.Properties.FieldValue.V;
              
            for(let k = 0;k<parent.Items.length;k++)
            {
              let qri = parent.Items[k];
              let relatedFieldPro = qri.Properties.RelatedField || qri.Properties.ParentField;
              if(qri.Properties.Field.V == key && relatedFieldPro.V != "")
              {
                var keyValue = {remoteClass:"java.util.HashMap"};
                keyValue[relatedFieldPro.V] = value; 
                array.push(keyValue);
              }
            }
          }
          arg.arg = array; 
        }
    }
    
    var mi = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".initRecord",window.menuItemId,window.formId);
    if(mi == null)
    {
      mi = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".beforeInitRecord",window.menuItemId,window.formId)
            || FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".afterInitRecord",window.menuItemId,window.formId);
      if(mi == null)
      {
        mi = {groups:"current(3)",editors:null,joinGroup:null,fetchOption:true};
      }
    }
    var commandArg = CommandResolver.getSendCmd(this.formDataSources.formModule, this.groupAlias, mi);
    var command = CommandHelper.createFormInstance(this.formDataSources.formModule.formName, "doRecordNew").appendArg(commandArg, "CommandArg").appendArg(arg, "FormDataSourceGroupArg");
    var _resultHandler = this.rpc_result_doRecordNew.bind(this);
    ServiceHelper.addTokenWithCommand({command:command,resultFunction:_resultHandler,sync:sync});
  }

  rpc_result_doRecordNew(data)
  {
    var result = data.result;
    //var finalDatas = RecordsUtil.getOneLevelDatas(result,this.groupAlias);
    this.formatFormDataSourceGroupResult(result);
    var finalDatas = result.dataResult;
    if(finalDatas.length>0)
    {
      var newRecord = finalDatas[0];

      var _recId = newRecord[this.mainSource.alias+".recId"];
      if(this.mapRecId.hasOwnProperty(_recId))
        throw new Error("already in when new record:" + _recId);
      this.mapRecId[_recId] = newRecord;
      this.recordsBak[_recId] = Object.assign({},newRecord);;

      let index = this.getNewRecordIndex();
      this.records.splice(index, 0, newRecord);
      let _records = this.records;
      if(this.tempRecordsFilter)
      {
        this.tempRecordsFilter.splice(index, 0, newRecord);
        _records = this.tempRecordsFilter;
      }
     
      RecordsActions.recordsCmp(_records,this.groupAlias,this);
      this.setCurrentRecord(newRecord,false,{focus:false});
      this.formDataSources.formModule.focusController.setFocusAfterNewRecord(this);

      CommandResolver.resolve(data.result.commandResult.tasks);
    }
    else
    {
      alert("新增失败，返回null");
    }
   

    
  }

  rpc_result_doRecordNew2(data)
  {
    var result = data.result;
    //result.recordCounts = result.dataResult.length;
    //var finalDatas = RecordsUtil.getOneLevelDatas(result,this.groupAlias);
    this.formatFormDataSourceGroupResult(result);
    var finalDatas = result.dataResult;
    if(finalDatas.length>0)
    {
      try
      {
        let newRecords = [];
        for(let i =0;i<finalDatas.length;i++)
        {
          var newRecord = finalDatas[i];
  
          var _recId = newRecord[this.mainSource.alias+".recId"];
          
          //如果原来该记录存在
          if(this.mapRecId.hasOwnProperty(_recId))
          {
            this.replaceRecord3(newRecord);
            this.mapRecId[_recId] = newRecord;
            this.recordsBak[_recId] = Object.assign({},newRecord);
            continue;
          }
          this.mapRecId[_recId] = newRecord;
          this.recordsBak[_recId] = Object.assign({},newRecord);
            //throw new Error("already in when new record:" + _recId);
          newRecords.push(newRecord);
         
        }
        /*var newRecords = Object.keys(newRecordsObj).map(
          function(key)
          {
            return newRecordsObj[key];
          }
        );*/
        let index = this.getNewRecordIndex(data.location);
        this.records.splice(index, 0, ...newRecords);
        this.currentRecord = newRecord;
        
        RecordsActions.recordsCmp(this.records,this.groupAlias,this);
        this.activeCurrentRecord(true,undefined,false);
        this.formDataSources.formModule.focusController.setFocusAfterNewRecord(this);
      }
      catch(e)
      {
        Warning.show({text:"clientRecordAdd命令传入的参数可能不正确"});
      }
     
    }
    else
    {
      alert("新增失败，返回null");
    }

    
  }

  onRecordNew(groupAlias,moduleInstanceId)
  { //TODO 留作DataGrid向下键新增交互
    if(groupAlias == this.groupAlias && this.formDataSource.formModule.instanceUUId == moduleInstanceId)
      return this.doRecordNew();
  }

  getNewRecordIndex(insertType)
  {
    if(this.records == null)
        return -1;

    var index = 0;  //add at first or last有区别
    if(!insertType)
      insertType = this.mainSource.xml.Properties.InsertAt.Value;
    
    if(insertType == "First")
    {
      index = 0;
    }
    else if(insertType == "Last")
    {
      index = this.records.length;
    }
    else
    {
      var currentIndex;
      if(this.currentRecord == null)
      {
        currentIndex = 0;
      }
      else
      {
        currentIndex = this.records.indexOf(this.currentRecord);
        if(currentIndex == -1)
          currentIndex = 0;
      }
      
      if(insertType == "Prev")
        index = currentIndex;
      else
        index = currentIndex + 1;
    }
    
    if(index < 0)
      index = 0;
    if(index > this.records.length)
      index = this.records.length;
    
    return index;
  }

  onRecordNext(groupAlias,moduleInstanceId)
  {
      if(this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId)
        return;
      this.doRecordNext();
  }

  doRecordNext()
  {
    if(window.lookupShowing)
        return;
    if(this.records==null || this.records.length==0)
    {
      this.setCurrentRecord(null);      
      return;
    }
    
    var oldIndex = this.records.indexOf(this.currentRecord);
    var index = 0;
    //alert(oldIndex);
    if(this.currentRecord==null)
    {
      index = 0;
    }
    else
    {
      index = oldIndex + 1;
    }
    
    var findex = Math.min(index,this.records.length-1);
    this.setCurrentRecord(this.records[findex]);
  }

  onRecordPrev(groupAlias,moduleInstanceId)
  {
    if(this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId != moduleInstanceId)
      return;
    this.doRecordPrev();
  }

  doRecordPrev()
  {
    if(window.lookupShowing)
        return;
    if(this.records==null || this.records.length==0)
    {
      this.currentRecord = null;
      return;
    }
    
    var oldIndex = this.records.indexOf(this.currentRecord);
    
    var index = 0;
    if(this.currentRecord==null)
    {
      index = 0;
    }
    else
    {
      index = oldIndex - 1;
    }
    
    if(index<0)
    {
      index = 0;
    }
    this.setCurrentRecord(this.records[index]);
  }

  onDataGridUserChanged(record,groupAlias,gridId,moduleInstanceId,delay = true)
  {

    if(this.groupAlias == groupAlias && moduleInstanceId == this.formDataSources.formModule.instanceUUId)
    {
       
      //alert("setCurrentRecord");
      this.currentRecord = record;
      //alert("当前记录更改");
      //this.currentRecordBak = Object.assign({},this.currentRecord);
      //RecordsActions.currentRecordChanged(record,groupAlias,gridId);
      /*if(delay == false)
      {
        window.groupActiveRecordStateObj[this.groupAlias].activingRecord=true;
      }*/ 
      this.activeCurrentRecord(true,gridId,delay,false,{},true);
      /*if(result == "FormLookup")
      {
        window.groupActiveRecordStateObj[this.groupAlias].activingRecord=false;
        return;
      }
      if(delay == false)
      {
        var mi = FormResourceUtil.getCommandArgMethodInfo(this.mainSource.alias+".activeRecord",this.forLookup?"FormLookup":window.menuItemId,this.formDataSources.formModule.props.formId);
        if(!mi || mi.prefetch == true)
        {
          window.groupActiveRecordStateObj[this.groupAlias].activingRecord=false;
        }
      }*/
    }
  }

  isGlobalForehandGroup()
  {
    var _parentWindow = window.parent.window;
    return (_parentWindow && _parentWindow.isCurrentWindow && _parentWindow.isCurrentWindow(window) && this == this.formDataSources.currentGroup)
  }
  
  isSelfForehandGroup()
  {
    return (this == this.formDataSources.currentGroup)
  }

  activeRecordRemote(sync = null,onIcheckOnlyOne=false)
  {
    // if(window.laterOperateFunction){
    //   window.laterOperateFunction();
    // }
    // console.log("active",this.aliasList[0]);
    LayerManager.executeLayerMethod(this.formDataSources.formModule,this,"activeRecord");
    /*let _parentWindow = window.parent.window;
    if(_parentWindow)
    {
      let layerLevels = _parentWindow.layerLevelConfig;
      let formModule = this.formDataSources.formModule;
      for(let i = layerLevels.length-1;i>-1;i--)
      {
        let layerName = layerLevels[i].name;
        let layerConfig = _parentWindow.layerConfigs[layerName];
        if(layerConfig)
        {
          let clsName = CommonUtil.getLayerDataSourceName(formModule.formName,this.mainSource.alias);
          if(layerConfig.hasOwnProperty(clsName))
          {
            let classConfig = layerConfig[clsName];
            let _cls = classConfig.classDef;
            let cmdResult;
            let mathodInfo = {fetchOption:true,groups:"all(cr,sr,ar,fq,cq)",editors:"all",joinGroup:"yes"};
            if(typeof(_cls) == "function")
            {
              let instance = new _cls();
              let commandArg = CommandResolver.getSendCmd(formModule, this.groupAlias, mathodInfo);
              CommandArgFuncUtil.bindCommandArgFunc(commandArg);
              cmdResult = instance.activeRecord(commandArg);
            }
            else if(typeof(_cls == "Object"))
            {
              let instance = _cls;
              let commandArg = CommandResolver.getSendCmd(formModule, this.groupAlias, mathodInfo);
              cmdResult = instance.activeRecord(commandArg);
            }
            if(cmdResult)
            {
              CommandResolver.resolve(cmdResult.tasks,formModule,this);
            }
            break;
          }
        }
      }

    }*/
    var mi = FormResourceUtil.getCommandArgMethodInfo(this.mainSource.alias+".activeRecord",this.forLookup?"FormLookup":window.menuItemId,this.formDataSources.formModule.props.formId);
    if(mi)
    {
      window.activeRemoting =true;
      let formModule = this.formDataSources.formModule;
      if(mi.prefetch==true)
      {
        window.activeRemoting =false;
        CommandResolver.resolve(mi.commandResult.tasks, formModule, this);
      }
      else
      {
        var arg = CommandResolver.getSendCmd(formModule, this.groupAlias, mi);
        var command = CommandHelper.createFormInstance(formModule.formName,"doActiveRecord","CommandResult");
        command.appendArg(this.groupAlias, "String")
          .appendArg(arg,"CommandArg");
        window.groupActiveRecordStateObj[this.groupAlias].activingRecord = true;
        if(sync){
          if(onIcheckOnlyOne){
            ServiceHelper.addTokenWithCommand({command:command,
              resultFunction:this.doActiveRecordRemoteResultHandlerActive.bind(this),
              faultFunction:this.doActiveRecordRemoteFaultHandler.bind(this),
              sync:true
          });
          }else{
            ServiceHelper.addTokenWithCommand({command:command,
                resultFunction:this.doActiveRecordRemoteResultHandler.bind(this),
                faultFunction:this.doActiveRecordRemoteFaultHandler.bind(this),
                sync:true
            });
          }
        }else{
          ServiceHelper.addTokenWithCommand({command:command,
            resultFunction:this.doActiveRecordRemoteResultHandler.bind(this),
            faultFunction:this.doActiveRecordRemoteFaultHandler.bind(this),
            sync:false
          });
        }
      }
    }else{
      window.activeRemoting =false;
    }
  }

  doActiveRecordRemoteFaultHandler(data)
  {
    window.activeRemoting = false;
    if(data && data.successButNot0)
    {
      Warning.show({text:data.errText,title:"远程调用失败"});
    }
    else
    {
      Warning.show({text:"请检查网络是否正常",title:"切换记录时远程调用失败"});
    }
    window.groupActiveRecordStateObj[this.groupAlias].activingRecord = false;
    window.groupActiveRecordStateObj[this.groupAlias].cutClickEnter = false;

  }

  doActiveRecordRemoteResultHandlerActive(data){
    CommandResolver.resolve(data.result.tasks, this.formDataSources.formModule, this);
    window.groupActiveRecordStateObj[this.groupAlias].activingRecord = false;
    
    FocusActions.afterActiveRecord(this.groupAlias);
    window.activeRemoting = false;
    if(window.laterOperateFunction){
      window.laterOperateFunction();
    }
  }

  doActiveRecordRemoteResultHandler(data)
  {
    CommandResolver.resolve(data.result.tasks, this.formDataSources.formModule, this);
    window.groupActiveRecordStateObj[this.groupAlias].activingRecord = false;
    
    FocusActions.afterActiveRecord(this.groupAlias);
    window.activeRemoting =false;
    if(window.laterOperateFunction){
      window.laterOperateFunction();
    }
  }

  activeCurrentRecord(updateRelated,causeId,delay=true,updateRelatedPart=false,parms={},doIcheckOnlyOneTime=false)
  {
    
    var lookupAlias = this.formDataSources.formModule.classAlias;
    if(lookupAlias == "FormLookup")
    {
      //万能视图 等 自动生成的下拉框 不需要根据activeRecord去更新toolbar
      return "FormLookup";
      /*var _parentWindow = window.parent.window;
      if(!_parentWindow.setToolBar)
        return "FormLookup";
      let _toolBarObject = this.formDataSources.formModule.toolBarObject;
      //let _toolBarObject = ToolBarUtil.createToolBarObj_Form_FormLookup();
      ToolBarUtil.setObjectQueryRemove(_toolBarObject,this.queryChanged);
      _parentWindow.setToolBar(_toolBarObject);
      UtilActions.updateInnerToolBar(_toolBarObject);
      return "FormLookup";*/
    }
    var _activeCurrentRecordSlow = this.activeCurrentRecordSlow.bind(this);
    var _currentRecord = this.currentRecord;
    if(delay)
    {
      var timerId = setTimeout(
        function(){_activeCurrentRecordSlow(_currentRecord,updateRelated,causeId,lookupAlias,true,updateRelatedPart,parms,doIcheckOnlyOneTime);clearTimeout(timerId)},400
      );  
    }
    else
    {
      _activeCurrentRecordSlow(_currentRecord,updateRelated,causeId,lookupAlias,false,updateRelatedPart,parms,doIcheckOnlyOneTime);
    }
  }

  activeRecordLocal()
  {
    //TODO 对于prefetch是true 后台貌似会固定返回方法签名信息 且commandResult为null
    var mi = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".clientActiveRecord",this.forLookup?"FormLookup":window.menuItemId,this.formDataSources.formModule.formId);
    if(mi)
    {
      if(mi.prefetch==true && mi.commandResult)
      {
        CommandResolver.resolve(mi.commandResult.tasks,this.formDataSources.formModule,this);
      }
    }
    
    this.countGroup();
    return "doActiveRecordLocal";
  }

  countGroup()
  {
    let _parentWindow = window.parent.window;
    if(!_parentWindow.userSettingEntry.showBottomSum)
      return;
    let filterRecords = arguments[0];
    $("#ActiveRecordCount", parent.document).text("");
    if(this.formDataSources.formModule && this.formDataSources.formModule.classAlias == "FormModule")
    {
      var numofdecimalses = [];
      var _numofdecimals;
      var _text =[];
      var RecordCount = 0;
      var DataField = [];
      var textRestult = [];
      for (var key in FormItemUtil.formItemControlsForFor) 
      {
        let item = FormItemUtil.formItemControlsForFor[key];
        if (item.xml && item.xml.type == "DecimalEditor" && item.groupAlias == this.groupAlias && item.getProperty_AutoSum()) 
        {
          let dataField = item.getDataField();
          DataField.push(dataField);
          _numofdecimals = item.properties.NumOfDecimals;
          if (_numofdecimals == -1)
             _numofdecimals = 0;
          numofdecimalses.push(_numofdecimals);
          let text =  item.properties.Label + ":";
          _text.push(text);
          
          //if(DataField.length == 3)
          //  break;
          // resultKeyArr.push(dataField);
        } 
        else if (item.xml && item.xml.type == "LongEditor" && item.groupAlias == this.groupAlias && item.getProperty_AutoSum()) //item.xml.Properties.AutoSum.Value == "true") 
        {
          let dataField = item.getDataField();
          DataField.push(dataField);
          //_numofdecimals = item.properties.NumOfDecimals;
          //if (_numofdecimals == -1)
          //   _numofdecimals = 0;
          numofdecimalses.push(_numofdecimals);
          let text =  item.properties.Label;
          _text.push(text);
          
            
          //if(DataField.length == 3)
          //  break;
          // resultKeyArr.push(dataField);
        }
      }
      var StatusBar = {
        tongjiObject: {
          sum: true,
          sel:true
        }
      }
      var TotalNum = [];
      var collection;
      if(this.mainSource.isTempTable == true)
      {
        collection = filterRecords?filterRecords:this.tempRecordsFilter;
        if(!collection)
            collection = this.records;
      }
      else
      {
        collection = this.records;
      }
      //var collection = filterRecords?filterRecords:this.records; //H5中的this.records
      if (!collection || collection.length < 1)
        return;
      var totalnum = 0;
      RecordCount = collection.length;
      for (var i = 0; i < DataField.length; i++) 
      {
        totalnum = 0;
        collection.map((item) => {
          if(item[DataField[i]]){
            var value = item[DataField[i]];
            var num = parseFloat(value);
            totalnum += num;
          }
          else
            totalnum += 0;
        });
        TotalNum.push(totalnum);
      }
      if (StatusBar.tongjiObject.sum) 
      {
        for(var i = 0 ; i<_text.length ; i ++)
        {
          let _textresult = _text[i] + "[求和=" + TotalNum[i].toFixed(numofdecimalses[i]) + "]";
          textRestult.push(_textresult);
        }
      }
      
      if (StatusBar.tongjiObject.sel) {
        var _selectedRecords = [];
        CommandActions.getSelectRecords(_selectedRecords,this.groupAlias,this.formDataSources.formModule.instanceUUId);
        if(_selectedRecords.length == 0 && this.currentRecord)
          _selectedRecords.push(this.currentRecord);

        if(_selectedRecords.length>1){
          RecordCount = _selectedRecords.length;
          TotalNum = [];
          textRestult = [];
          totalnum = 0;
          for(var j = 0; j < DataField.length; j++){
            totalnum = 0;
            for (var i = 0; i < _selectedRecords.length; i++) {
              var item = _selectedRecords[i];
              var value = item[DataField[j]];
              var num = parseFloat(value);
              totalnum += num;
            }
            TotalNum.push(totalnum);
          }
          if (StatusBar.tongjiObject.sum){
            // _text += " 求和(选中)=" + totalnum.toFixed(_numofdecimals);
            for (var i = 0; i < _text.length; i++) {
              let _textresult =  _text[i] + "[求和=" + TotalNum[i].toFixed(numofdecimalses[i]) + "]";
              textRestult.push(_textresult);
            }
          }

        }
      }

      var footertext = "计数=" + RecordCount + " " ;
      for(var i = 0 ; i < textRestult.length ; i ++){
        footertext += textRestult[i] + " ";
      }
      $("#ActiveRecordCount", parent.document).text(footertext);
      this.formDataSources.formModule.lastAutoSumInfo = footertext;
    }
  }

  activeCurrentRecordSlow(baseRecord,updateRelated,causeId,lookupAlias,delay=true,updateRelatedPart=false,parms={},onIcheckOnlyOne=false)
  {
    if(this.currentRecord == baseRecord)
    {
      //TODO_yl  当同时 执行 selectRecords 命令时 不执行当前
      if(this.doSelectRecords){
        this.doSelectRecords = undefined;
        return;
      }
      RecordsActions.groupCurrentRecordChanged(this.records,this.currentRecord,this.groupAlias,this.formDataSources.formModule.instanceUUId,causeId,this,parms);
      
      if(lookupAlias == "FormModule")
        this.activeToolBarByRecord(this.currentRecord);
      var recordlocal = this.activeRecordLocal();
      if(lookupAlias == "FormModule" && ToolBarUtil.getObjectAttachment(window.toolBarObject))
        this.activeAttachment(this.currentRecord);
      if(updateRelated)
      {
        var _parentWindow = window.parent.window;
        if(_parentWindow)
        {
          //alert("更新关联");
          _parentWindow.linkGroupActiveJoin(this,window.formModuleInstanceuuId,delay,updateRelatedPart);
        }
      }
      if(recordlocal){
        this.activeRecordRemote(true,onIcheckOnlyOne);
      }else{
        this.activeRecordRemote(false,onIcheckOnlyOne);
      }
    }
    else
    {
      
    }
  }

  doLinkActive()
  {
    var formModule = this.formDataSources.formModule;
    var formId = formModule.props.formId;
    var mi = FormResourceUtil.getCommandArgMethodInfo(this.mainSource.alias+".linkActive",this.forLookup?"FormLookup":window.menuItemId,this.formDataSources.formModule.props.formId);
    if(mi!=null)
    {
      if(mi.prefetch==true)
      {
        if(mi.commandResult)
          CommandResolver.resolve(mi.commandResult.tasks,formModule,this);
      }
      else
      {
        var arg = CommandResolver.getSendCmd(formModule, this.groupAlias, mi);
        var command = CommandHelper.createFormInstance(formModule.formName,"doLinkActive","CommandResult");
        command.appendArg(this.groupAlias, "String")
          .appendArg(arg,"CommandArg");
        
        ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.doLinkActiveResultHandler.bind(this),sync:false});
      }
    }
  }

  doLinkActiveResultHandler(data)
  {
    CommandResolver.resolve(data.result.tasks, this.formDataSources.formModule, this);
  }

  activeAttachment(record = null)
  {
    if(this.mainSource.isTempTable == true)
      return;
    
    if(record == null)
      record = this.currentRecord;
    
    /*TODO activeCurrentRecord若要支持Attachment 则setState var attachmentaukey = "3_" + window.menuItemId + "." + this.mainSource.xml.id;
    if(record == null)
    {
      Attachment.Instance.refresh(null, null, attachmentaukey,this);
      return;
    }*/
    
    if(this.isGlobalForehandGroup())
    {

      if(record == null)
      {
        let _parentWindow = window.parent.window;
        if(_parentWindow)
        {
          _parentWindow.updateAttachmentNum(0);
        }
        window.updateAttachmentNum(0);
        this._lastAttachmentNum = 0;
        return;
      }

      var tableId = GOTUtil.getProperty(this.mainSource.xml,"Table").refentityid;
      var tableName = this.mainSource.xml.name;
      var recId = record[tableName+".recId"];
      //Attachment.Instance.refresh(tableId,recId,attachmentaukey,this);
      var command = Command.createService("gongqi.erp.gotmodel.services.AttachmentService", "sizeOfAttachments", "int");
      
      command.appendArg(tableId+"/"+recId);
      let _rpc_result_getAttachmentHandler = this.rpc_result_getAttachmentHandler.bind(this);
      ServiceHelper.addTokenWithCommand({command:command,
        resultFunction:function(data){_rpc_result_getAttachmentHandler(data,record);},
        faultFunction:null,sync:false,autoLock:false,autoUnlock:false});
    }
  }

  _lastAttachmentNum = undefined;
  rpc_result_getAttachmentHandler(data,baseRecord)
  {
    if((baseRecord==this.currentRecord) && this.isGlobalForehandGroup())
    {
      let length = data.result;
      let _parentWindow = window.parent.window;
      if(_parentWindow)
      {
        _parentWindow.updateAttachmentNum(length);
      }
      if(window.updateAttachmentNum)window.updateAttachmentNum(length);
      this._lastAttachmentNum = length;
    }

  }

  activeToolBarByRecord(record)
  {
    if(window.isDataSetView == true)
    {
      var _parentWindow = window.parent.window;
      var toolBarObject = window.toolBarObject;

      if(this.dataSetQueryTable.queryOrderBy.length>0 || this.dataSetQueryTable.queryWhere.length>0){
        toolBarObject.QueryRemove = true;
      }else{
        toolBarObject.QueryRemove = false;
      }

      _parentWindow.setToolBar(toolBarObject);
      UtilActions.updateInnerToolBar(toolBarObject);

      ToolBarActions.updateGridToolBar({add:false,
                                    del:false,
                                    save:false,
                                    query:true,
                                    fatchAll:false,
                                    groupAlias:this.groupAlias});

      return;
    }

    if(!this.isSelfForehandGroup())
        return;
    if(record == undefined)
      record = this.currentRecord;
    //if(record == undefined || record == null)
    //  return;
    var toolBarObject = window.toolBarObject;
    
    ToolBarUtil.setObjectSave(toolBarObject,this.getAuthorityFinal("test",FormDataSourceAuthorityType.Save,record));
    var queryEnable = this.getAuthorityFinal("test",FormDataSourceAuthorityType.Query,record);
    ToolBarUtil.setObjectQuery(toolBarObject,queryEnable);
    if(this.mainSource.isAggreateTable == true)
      ToolBarUtil.setObjectRestore(toolBarObject,false);
    if(queryEnable)
    {
      ToolBarUtil.setObjectQueryRemove(toolBarObject,this.queryChanged);
    }
    ToolBarUtil.setObjectExport(toolBarObject,this.getAuthorityFinal("test",FormDataSourceAuthorityType.Export,record));
    if(!window.hasPrint())
      ToolBarUtil.setObjectPrint(toolBarObject,false);
    
    ToolBarUtil.setObjectDelete(toolBarObject,this.getAuthorityFinal("test",FormDataSourceAuthorityType.Delete,record));
    
    
    ToolBarUtil.setObjectNew(toolBarObject,this.getAuthorityFinal("test",FormDataSourceAuthorityType.Add,record));
    var attachment = this.ds_AllowAttachment;
    if(attachment == true)
    {
      var mainSource = this.mainSource.xml;
      var allow = mainSource.Properties.AllowAttachment.Value;
      attachment = allow=="true";
    }
    ToolBarUtil.setObjectAttachment(toolBarObject,attachment);
    ToolBarActions.updateGridToolBar({add:ToolBarUtil.getObjectNew(toolBarObject),
                                      del:ToolBarUtil.getObjectDelete(toolBarObject),
                                      save:ToolBarUtil.getObjectSave(toolBarObject),
                                      query:ToolBarUtil.getObjectQuery(toolBarObject),
                                      groupAlias:this.groupAlias});
    if(this.isGlobalForehandGroup())
    {
      var _parentWindow = window.parent.window;
      _parentWindow.setToolBar(toolBarObject);
      UtilActions.updateInnerToolBar(toolBarObject);
    }
    
  }

  getCurrentRecordAuthorityGOT(formDataSourceName, authorityType, record)
  {
    //见FormDataSourceAuthority枚举类
    //int表示权限类型 visible export等
    //
    if(record == null)
    {
      if(authorityType == FormDataSourceAuthorityType.Save
        || authorityType == FormDataSourceAuthorityType.Edit
        || authorityType == FormDataSourceAuthorityType.Delete
      )
        return false;
    }
    return this.getCurrentRecordAuthorityByXML(authorityType);
  }

  getCurrentRecordAuthorityByXML(type)
  {
    var value;
    if(type == FormDataSourceAuthorityType.Add)
    {
      value = this.mainSource.xml.Properties.AllowAdd.Value;
    }
    else if(type == FormDataSourceAuthorityType.Delete)
    {
      value = this.mainSource.xml.Properties.AllowDelete.Value;
    }
    else if(type == FormDataSourceAuthorityType.Edit)
    {
      value = this.mainSource.xml.Properties.AllowEdit.Value;
    }
    else if(type == FormDataSourceAuthorityType.Export)
    {
      value = this.mainSource.xml.Properties.AllowExport.Value;
    }
    else if(type == FormDataSourceAuthorityType.Query)
    {
      value = this.mainSource.xml.Properties.AllowQuery?this.mainSource.xml.Properties.AllowQuery.Value
                                                :this.mainSource.xml.Properties.AllowChangeQuery.Value
    }
    else if(type == FormDataSourceAuthorityType.Save)
    {
      value = this.mainSource.xml.Properties.AllowSave.Value;
    }
    
    if(value == "true" || value==true)
      return true;
    return false;
  }

  consOnedimensionalGridColByAnlysis(_group = null)
  {
    if(_group == null)
      _group = this;
    
    if(_group.sources.length > 1)
      var isNeedTableName = true;
    else 
      isNeedTableName = false;
    
    var resultArr = [];
    var tmp = [];
    var focusableItemsQue1 = window.formModuleInstance.focusController.focusableItemsQue1;
    for(let i = 0;i<focusableItemsQue1.length;i++)
    {
      let focusableItem = focusableItemsQue1[i];
      let formItem = FormItemUtil.getFormItemControl(
                FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,focusableItem.id));
      
                if(window.isDataSetView){
                  this.dataSetQueryTable.allQueryFields = [];
                  this.getAllQueryFieldssForDataSetView(this.dataSetQueryTable);
          
                  for(let k in this.dataSetQueryTable.allQueryFields){
                    if((this.dataSetQueryTable.allQueryFields[k].fieldAliasName && this.dataSetQueryTable.allQueryFields[k].fieldAliasName == formItem.dataSource_Field)
                    ||StringUtil.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[k].fieldName) == formItem.dataSource_Field){
                      formItem.dataField = this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName;
                      formItem.dataSource_Alias = this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName.substr(0,this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName.lastIndexOf("."));
                      var tableXML = GOT.getTable(this.dataSetQueryTable.allQueryFields[k].refEntityId);
                      var tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
                      formItem.comDataSetLabel = tableLabel;
                    }
                  }
          
                }
      if(formItem.group == _group&&formItem.dataSource_Alias!=""&&formItem.dataSource_Field != "")
      {
        var fe = formItem;
        if(fe.classAlias == "FormItemTimeEditorControl")
          continue;
        if(fe.classAlias == "FormItemStringEditorControl" && fe.isDataAnlysFilter())
          continue;
        
        var oneddatafield;
        if(fe.dataSource_Field.indexOf(".")==-1)
        {
          oneddatafield = fe.dataSource_Alias + "-" + StringUtil.convertToFirstLowerCase(fe.dataSource_Field);
        }
        else
        {
          var _array = fe.dataSource_Field.split(".");
          oneddatafield = fe.dataSource_Alias + "-" + StringUtil.convertToFirstLowerCase(_array[0]) + "-" +StringUtil.convertToFirstLowerCase(_array[1]);
        }
        if(!fe.isDataMethodField)
        {
          var fieldObj = this.getFormDataSourceField(fe.dataSource_Field,fe.dataSource_Alias);
          var dataSourceFieldXML = fieldObj.field;
          if(dataSourceFieldXML == null)
            continue;
          this.saveFieldCache(dataSourceFieldXML,oneddatafield); 
        }
        if(tmp.indexOf(oneddatafield)!=-1)
          continue;
        tmp.push(oneddatafield);
        if(!fe.getProperty_Visible_Final())
          continue;
        var _type = fe.xml.type;
        var _fieldType = _type.substr(0,_type.length-"Editor".length);
        var item = {};
        item.fieldType = _fieldType;
        item.dataField = oneddatafield;
        if(fe.classAlias == "FormItemDecimalEditorControl")
          item.numOfDecimals = fe.getProperty_NumOfDecimals();
        var _label = formItem.getProperty_Label(false);
        var _totalLabel;
        if(isNeedTableName)
        {
          var sourceName = formItem.dataSource_Alias;
          for(let i = 0;i<_group.sources.length;i++)
          {
            var source = _group.sources[i];
            if(source.alias == sourceName)
              break;

          }
          if(!window.isDataSetView){
            if(source.alias != sourceName)
              continue;
              var tableName = GOTUtil.getPropertyValue(source.xml,"Table");
              var tableXML = GOT.getTable(tableName);
              var tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
              _totalLabel = tableLabel + "." + _label;
          }else{
            _totalLabel = formItem.comDataSetLabel+"."+_label;
          }
        }
        else
        {
          _totalLabel = _label;
        }
        item.headerText = _totalLabel;
        resultArr.push(item);
      }
    }
    
    return resultArr;
  }

  dataAnlys(filter,flag=null)
  {
    if(!this.getAuthorityByXML(FormDataSourceAuthorityType.exportStr))
      return;
    if(!this.records || this.records.length <= 0)
    {
      Warning.show({text:"当前无记录 无法进行数据分析",state:"info"});
      return;
    }
    var focusableItemsQue1 = window.formModuleInstance.focusController.focusableItemsQue1;
    for(let i = 0;i<focusableItemsQue1.length;i++)
    {
      let focusableItem = focusableItemsQue1[i];
      let formItem = FormItemUtil.getFormItemControl(
                FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,focusableItem.id));
      if(formItem.group == this && 
         formItem.dataSource_Alias!="" &&　
         formItem.dataSource_Field != "" 
      )
      {
        let fe = formItem;
        let oneddatafield;
        if(fe.dataSource_Field.indexOf(".")==-1)
        {
          oneddatafield = fe.dataSource_Alias + "-" + StringUtil.convertToFirstLowerCase(fe.dataSource_Field);
        }
        else
        {
          var _array = fe.dataSource_Field.split(".");
          oneddatafield = fe.dataSource_Alias + "-" + StringUtil.convertToFirstLowerCase(_array[0]) + "-" +StringUtil.convertToFirstLowerCase(_array[1]);
        }
        if(!this.fieldCache.hasOwnProperty(oneddatafield))
        {
          if(!fe.isDataMethodField)
          {
            var fieldObj = this.getFormDataSourceField(fe.dataSource_Field,fe.dataSource_Alias);
            var dataSourceFieldXML = fieldObj.field;
          
            if(!dataSourceFieldXML)
              continue;
            this.saveFieldCache(dataSourceFieldXML,oneddatafield); 
          }
        }
      }
    }
    let _records = this.records;
    if(this.mainSource.isTempTable == true && this.tempRecordsFilter)
    {
      _records = this.tempRecordsFilter;
    }
    var ac = this.convertToOnedimensional1(_records,filter);
    var headerInfo = this.consOnedimensionalGridColByAnlysis();
    for(let i = 0;i<headerInfo.length;i++)
    {
      var _column = headerInfo[i];
      _column.visible = true;
    }
    var key = window.formId + "_" + this.mainSource.xml.id + "." + window.menuItemId;
    if(window.isDataSetView == true)
    {
      let strac = JSON.stringify(ac);
      let jsonac = JSON.parse(strac);
      if(window.isDataSetView){
        for(let kk = 0;kk<jsonac.length;kk++)
        {
          let dsItem = jsonac[kk];
          for(let k in dsItem)
          {
            for(let i in this.dataSetQueryTable.allQueryFields){
              if((this.dataSetQueryTable.allQueryFields[i].fieldAliasName && this.groupAlias+"-"+this.dataSetQueryTable.allQueryFields[i].fieldAliasName == k)
              ||(this.groupAlias+"-"+StringUtil.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[i].fieldName)) == k){
                dsItem[this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.replace(".","-")] = dsItem[k];
                if(this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.indexOf(this.groupAlias) == -1){
                  delete dsItem[k];
                }
              }
            }  
          }
        }
      }
      let columsCount=0;
      for(let i in headerInfo){
        let item = headerInfo[i];
        if(item.visible){
          columsCount++;
        }
      }
      if(columsCount*jsonac.length >=800000){
        ReactDOM.render( <PivotExportDialog  parent={this} />,document.getElementById('pivotExportModal'));
      }else{
        this.exportToPivot_test(headerInfo,jsonac,key);
      }
    } 
    else
    {
      var extrals = this.getExtralExportFields1(headerInfo,filter);
      for(let i = 0;i<extrals.length;i++)
      {
        let item = extrals[i];
        item.visible = false;
      }
      headerInfo = headerInfo.concat(extrals);
      let columsCount=0;
      for(let i in headerInfo){
        let item = headerInfo[i];
        if(item.visible){
          columsCount++;
        }
      }
      if(columsCount*ac.length >=800000){
        ReactDOM.render( <PivotExportDialog  parent={this} />,document.getElementById('pivotExportModal'));
      }else{
        this.exportToPivot_test(headerInfo,ac,key,flag);
      }
      // this.exportToPivot_test(headerInfo,ac,key,flag);
    }
    /*var extrals = this.getExtralExportFields1(headerInfo,filter);
    for(let i = 0;i<extrals.length;i++)
    {
      let item = extrals[i];
      item.visible = false;
    }
    headerInfo = headerInfo.concat(extrals);
    var key = window.formId + "_" + this.mainSource.xml.id + "." + window.menuItemId;
    this.exportToPivot_test(headerInfo,ac,key);*/
  }

  exportToPivot_test(header,ac,_configKey,flag=null)
  {
    var tmp = {};
    tmp["rows"] = [];
    tmp["cols"] = [];
    var s2 = JSON.stringify(tmp);

    var s3 = "{}";var json = {};
    if(true)
    {
      var args = {};json["args"] = args;var columns = [];
      json["columns"] = columns;var numDecimals = {};json["numDecimals"] = numDecimals;
      var _parentWindow = window.parent.window;
      json["config"] = {
        configKey:_configKey,
        userId:_parentWindow.userInfos.userId,dataArea:_parentWindow.userInfos.subSysId,
        serviceURL:_parentWindow.userInfos.pivotURL
      };
      if(flag=='drop'){
        window.parent.window.toolbarPivotDrop(json["config"])
        return;
      }

      
      //循环datagrid字段名
      for(let i = 0;i<header.length;i++)
      { 
        var field = header[i];let column = {};
        column["id"] = field.dataField;
        column["label"] = field.headerText || field.totalLabel || field.label;
        column["type"] = field.fieldType;
        column["visible"] = field.visible;
        if(column["type"]=="Decimal")
        {
          column["concept"] = "Value";
          numDecimals[field.dataField] = field.numOfDecimals;
        }
        else if(column["type"]=="Date")
        {
          column["concept"] = "Date";
        }
        else
        {
          column["concept"] = "Dim";
        }
        columns.push(column);
        
        if(column.type == "Date")
        {
          var extralColumn = {};
          extralColumn.id = column.id+"-year";
          extralColumn.label = column.label+"(年)";
          extralColumn.type = "ExtralYear";
          extralColumn.concept = "Dim";
          extralColumn.visible = true;
          columns.push(extralColumn);
          
          extralColumn = {};
          extralColumn.id = column.id+"-month";
          extralColumn.label = column.label+"(月)";
          extralColumn.type = "ExtralMonth";
          extralColumn.concept = "Date";
          extralColumn.visible = true;
          columns.push(extralColumn);
        }
      }
      columns.push({id:"recordNum",label:"记录条数",type:"Decimal",concept:"Value",visible:true});
      numDecimals[field.dataField] = 0;
      var arr = [];var key;
      for(let i = 0;i<ac.length;i++)
      {
        let tmp1 = ac[i];var obj = {};
        for(let k = 0;k<columns.length;k++)
        {
          let column = columns[k];
          if(column.type == "ExtralYear")
          {
            var dateValue = tmp1[key];
            if(!dateValue||dateValue=="null")
            {
              var dateValueNext = "";
            }
            else
            {
              var temparray = dateValue.split("-");
              dateValueNext = temparray[0];
            }
            
            obj[key+"-year"] = dateValueNext;
          }
          else if(column.type == "ExtralMonth")
          {
            dateValue = tmp1[key];
            if(!dateValue||dateValue=="null")
            {
              dateValueNext = "";
            }
            else
            {
              temparray = dateValue.split("-");
              dateValueNext = temparray[0]+"-"+temparray[1];
            }
            obj[key+"-month"] = dateValueNext; 
          }
          else
          {
            key = column.id;
            if(key == "recordNum")
            {
              obj[key] = 1; 
            }
            else
            {
              var tempkey = tmp1[key];
              if(typeof(tempKey) === "string")
                tempkey = tempkey.replace(/\"/g,"");
              obj[key] = tempkey;
            }
          }

        }
        
        
        for(var keyloop in tmp1)
        {
          if(!obj.hasOwnProperty(keyloop))
          {
            var _value = tmp1[keyloop];
            if(typeof(_value) === "string")
              obj[keyloop] = _value.replace(/\"/g,"");
          }
        }
          
        arr.push(obj);
        
      }
      json["lines"] = arr;
      
      //s3 = JSON.stringify(json);
      //var pattern = new RegExp("\\\\","g");
      //s3 = s3.replace(pattern,"\\\\\\\\");
    }
    

    sessionStorage.setItem("pivot_rowscols", tmp);
    //sessionStorage.setItem("jsondata", s3);
    sessionStorage.setItem("subSysId",window.parent.window.userInfos.subSysId);
    window.parent.window.addDBPivotData({id:'tmp',data:{pivot_rowscols:tmp,jsondata:json}});


    if(!window.parent.window.didomain){
      if(flag && flag !='drop'){
        window.open("pivot/pivot.html?initpivot="+flag.fileName+"&user="+flag.user);
      }else{
        window.open("pivot/pivot.html?");
      }
    }else{
      let url = window.parent.window.parent.pivotUrl
      if (!url) {
        alert("请先安装图表分析器APP");
        return;
      }
      let record = {
        url: url + '?dataFrom=zxbg',
        icon: '../images/pivot.svg',
        suffix: '.gongqi',
        gongQiFileId: new Date().getTime()+ '-', 
        win_title: '图表分析器',
        name: '图表分析器',
        office: false,
        pageURL: url + '?dataFrom=zxbg',
        dsOpenType: 'pivot',
      }
      window.parent.window.parent.openWindowByFileManage(record)
    }
    

    //var _result = ExternalInterface.call("openPivotTable", s2, s3);
    
  }

  getSpecExportData(ac)
  {
    if(!this.getAuthorityByXML("export"))
    {
      return;
    } 
    var _key = window.formId + "_" + this.mainSource.xml.id  + (window.menuItemId?"."+window.menuItemId:"");
    var columns;
    var userDefaultExport = FormDataSources.getUserDefaultExportList(_key);
    if(userDefaultExport)
    {
      columns = this.consOnedimensionalGridColBySetting(userDefaultExport);
    }
    else
    {
      columns = this.consOnedimensionalGridColByView();
    }
    if(!columns || columns.length == 0)
      return;
    var filter = [];
    for(let key in FormItemUtil.formItemControlsForFor)
    {
      let control = FormItemUtil.formItemControlsForFor[key];
      if(control && control.classAlias == "FormItemStringEditorControl")
      {
        if(control.getDisplayAsPassword())
          filter.push(control.getDataField())
      }
    }

    var _ac = this.convertToOnedimensional(ac,filter);
    if(!_ac)_ac = [];
    var headerInfo = [];

    for(let i = 0;i<columns.length;i++)
    {
      let col = columns[i];
    
      let item = {dataField:col.dataField,headerText:col.headerText,fieldType:col.fieldType};
      /*if(col.fieldType == "Decimal")
      {
        let control = FormItemUtil.formItemControls[window.menuItemId+"."+window.formId+"."+col.formItemId];
        if(control && control.classAlias == "FormItemDecimalEditorControl")
        {
          item.numOfDecimals = control.getProperty_NumOfDecimals();
        }
      }*/
      headerInfo.push(item);
      
    }

    var rowCount=_ac.length;
    var data="";
    var fieldSeparator="\t";
    var lineSeparator="\n";
    var fields=[];
    //循环表头数据
   
    for(var i=0;i<headerInfo.length;i++)
    {
      var filed=headerInfo[i];
      fields.push(filed.dataField);
      data += (filed.headerText + fieldSeparator);
      if(i==headerInfo.length-1){
        data+=lineSeparator;
      }
    }

    //循环行数据
    for(var i=0;i<rowCount;i++)
    {
      var record=_ac[i];
      for(var j=0;j<fields.length;j++)
      {
        let field_ = fields[j];
        data+=record[field_]+fieldSeparator;
      }
      data+=lineSeparator;
    }

    return data;

  }

  getAuthorityByXML(type)
  {
    var _parentWindow = window.parent.window;
    if(_parentWindow.userInfos.isAdmin==true)
      return true;
   
    var valueMainSource;
    var valueSources;
    
    valueMainSource = AuthorityUtil.getXmlType2SCacheItem((window.menuItemId&&window.menuItemId!="")?window.menuItemId:window.formXML.name,this.mainSource.xml.id,type);
    var finalValue = true;
    var isForbidden = false;
    var finalValueSetted = false;
    if(valueMainSource["isDefault"] == false)
    {
      finalValue = valueMainSource["result"];
      finalValueSetted = true;
      isForbidden = valueMainSource["isForbidden"];
    }
    
    if(isForbidden)
      return false;
    
    valueSources = AuthorityUtil.getXmlType2SCacheItem((window.menuItemId&&window.menuItemId!="")?window.menuItemId:window.formXML.name,this.formDataSources.xml.id,type);
    
    if(valueSources["isDefault"] == false)
    {
      if(!finalValueSetted)
      {
        finalValue = valueSources["result"];
        finalValueSetted = true;
      }
      isForbidden = valueSources["isForbidden"];
    }
    
    if(finalValueSetted)
    {
      return finalValue && !isForbidden;
    }
    
    if(
      window.getIsQueryOnlyFromMenuItem() == true 
      &&
      (
        type == FormDataSourceAuthorityType.newStr
        || type == FormDataSourceAuthorityType.saveStr
        || type == FormDataSourceAuthorityType.delStr
      )
    )
      return false;

    
    return true;
    
    
  }

  /**
   * 查询权限始终跟当前记录无关 若是获得查询权限 record请传入null
   * **/
  getAuthorityFinal(formDataSourceName,autype,record)
  {
    if(this.forLookup && autype != FormDataSourceAuthorityType.Query)
      return false;
    if(autype == FormDataSourceAuthorityType.Save
      || autype == FormDataSourceAuthorityType.Delete
      || autype == FormDataSourceAuthorityType.Add
    )
    {
      if(this.mainSource.isAggreateTable == true)
      {
          return false;
      }

      if(window.getIsQueryOnlyFromMenuItem() == true)
        return false;

    }

    if(autype == FormDataSourceAuthorityType.Delete)
    {
      if(record)
      {
        if(record["recVersion"] == -1 || record[this.groupAlias+".recVersion"] == -1)
        {
          return true;
        }
      }
    }
    
    var cmdName = FormDataSourceAuthorityType.getDSName(autype);
    var cmd = this[cmdName];
    
    if(cmdName && this.hasOwnProperty(cmdName) && cmd == false)
      return false;
    var xmltype = FormDataSourceAuthorityType.getXMLName(autype);
    var result = this.getAuthorityByXML(xmltype)&&this.getCurrentRecordAuthorityGOT(formDataSourceName,autype,record);
    if(result == false)
      return false;
    
    if(autype == FormDataSourceAuthorityType.Save || autype == FormDataSourceAuthorityType.Delete || autype == FormDataSourceAuthorityType.Add)
    {
      var _isCurrentRecordLocked = this.isCurrentRecordLocked(record); 
      if(autype == FormDataSourceAuthorityType.Add && !this.lockedRecNew && _isCurrentRecordLocked == true)
        _isCurrentRecordLocked = false;
      if(_isCurrentRecordLocked == true)
      {
        // var ff:FreeForm = this.formDataSources.formModule.parent as FreeForm;
        // if(ff)
        //   var ftitle:String = ff.title;
        // else
        //   ftitle = this.formDataSources.formModule.label;
        // if(autype == FormDataSourceAuthorityType.Save && ftitle.indexOf(FreeFormConst.MODIFIEDLABEL) != -1)
        // {
        //   _isCurrentRecordLocked = false;
        // }
      }
    }
    else
    {
      _isCurrentRecordLocked = false;
    }
    
    if(_isCurrentRecordLocked == true)
      return false;
    
    var extral = true;
    if(autype == FormDataSourceAuthorityType.Add)
    {
      if(this.isLinkGroupRecordNull())
          return false;
      extral = (!this.lockedRecNew)&&(!(this.mainSource.tableGroup=="SingleParm" && record != null));
    }

    return extral;
  }

  isLinkGroupRecordNull()
  {
    if(this.linkGroup)
    {
      var curVersion = this.linkGroup.getCurRecVersion();
      if(curVersion<0)
        return true;
    }
    
    return false;
  }

  isLinkGroup(sourceGroup,fromFormId)
  {
    if(this.linkGroup == sourceGroup)
    {
      //alert("1"+this.linkType);
      //暂时屏蔽同画面的处理
      if(this.linkType == "Passive" || this.linkType == "Delayed" || this.linkType == "Active")
        return false;
    }
   
    if(window.hasOwnProperty("argCaller"))
    {
        
        let argCaller = window.argCaller;
        //alert("2"+argCaller.callerType + "formId:"+formId+"callerId:"+argCaller.callerId);
        if(argCaller.callerType == "FormModule" && fromFormId == argCaller.callerId)
        {
          if(argCaller.joinGroupAlias == sourceGroup.groupAlias)
          {
            return true;
          }
        }

    }
    return false;
  }

  setFormDataSourceGroupArg(arg, opr=null)
  { 
    arg.aliasList = [];
   
    var tempDataMethodField = this.getTempDataMethodField();

    var selectedRecords = [];
    CommandActions.getSelectRecords(selectedRecords,this.groupAlias,this.formDataSources.formModule.instanceUUId,opr=="restore");

    //getSelectedRecords为了后台能解析复制记录并加入了remoteClass 所以先去掉这个异常情况的检测
    //TODO 某些二次开发会查询后直接保存 恢复等（不知道这样做是否合理) 此时FormITemDataGrid还没有更新(由于延迟换行)
    // 但是currentRecord已经在local定位中更新 此时会出现临时性的不一致 但是Group的currentRecord是即时同步更新的
    //所以当存在这种情况 以FormItemDataSourceGroup.currentRecord为准
    if(selectedRecords.length==1 && selectedRecords[0] != this.currentRecord)
    {
      //alert("FormDataSourceGroup -> setFormDataSourceGroupArg 当前记录与Grid选中记录不一致 currentRecord:"+
      //  JSON.stringify(this.currentRecord) + "       selectedRecords:"+JSON.stringify(selectedRecords[0]));
      selectedRecords = [this.currentRecord];
    }

    if(selectedRecords.length == 0)
    {
      selectedRecords.push(this.currentRecord);
    }

    var _count = 0;arg.arg = {};
    for(var i=0; i<selectedRecords.length; i++)
    {
      var fRecord = {};
      Object.assign(fRecord,selectedRecords[i]);
      this.deleteRecordTempDataMethodField(fRecord);
      var _record = RecordsUtil.getSecondaryRecord(fRecord,this.groupAlias);
      if(opr=="restore")
      {
        if(_record["recVersion"]!=-1)
        {
          arg.arg[_count] = _record;
          _count++; 
        }
      }
      else
      {
        arg.arg[_count] = _record;
        _count++;
      }
    }
    arg.aliasList.push(this.groupAlias);
    arg.recordCounts = _count;
  }

  onRecordAutoSave(groupAlias)
  {
    if(groupAlias == this.groupAlias)
      return this.doRecordSave(true,true);
  }


  deleteSelectedTempRecords(recIds)
  {
    if(this.mainSource.isTempTable == true && recIds.length>0)
    {
      var mainAlias = this.mainSource.alias;
      var locateNextRecId = "";
      var flag = 0;var length = this.records.length;var _records = [];var next;var pre;
      var dontLocate = false;

      if(this.tempRecordsFilter)
      {
        for(var i = 0;i<this.tempRecordsFilter.length;i++)
        {
          var record = this.tempRecordsFilter[i];
          var recId = record[mainAlias+".recId"];
          if(recIds.indexOf(recId) != -1)
            _records.push(record);
        }
      }
      else
      {
        for(var i = 0;i<this.records.length;i++)
        {
          var record = this.records[i];
          var recId = record[mainAlias+".recId"];
          if(recIds.indexOf(recId) != -1)
            _records.push(record);
        }
      }
      
      if(_records.indexOf(this.currentRecord)==-1)
      {
        dontLocate = true;
      }
      
      let thisRecord = this.tempRecordsFilter?this.tempRecordsFilter:this.records;

      for(var k = 0;k<_records.length;k++)
      { 
        var record = _records[k];
        var index = thisRecord.indexOf(record);
        if(locateNextRecId == "" && dontLocate == false)
        {
          if(index>0)
          {
            pre = thisRecord[index-1];
          }
          else
          {
            pre = null;
          }
          
          if(pre != null)
          {
            var preRecId = pre[mainAlias+".recId"];
            if(recIds.indexOf(preRecId) == -1)
              locateNextRecId = preRecId;
          }
          
          if(locateNextRecId == "")
          {
            if(index<length-1)
            {
              next = thisRecord[index+1];
            }
            else
            {
              next = null;
            }
            
            if(next != null)
            {
              var nextRecId = next[mainAlias+".recId"];
              if(recIds.indexOf(nextRecId) == -1)
                locateNextRecId = nextRecId;
            }
          }
        }
        
        thisRecord.splice(index,1);
        if(thisRecord == this.tempRecordsFilter)
        {
          let index2 = this.records.indexOf(record);
          this.records.splice(index2,1);
        }
        length --;
        flag++;
      }
      
      RecordsActions.recordsCmp(thisRecord,this.groupAlias,this);
      
      if(dontLocate == false)
      {
        var located = false;
        if(locateNextRecId=="")
        {
          this.setCurrentRecord(null);
          located = true;
        }
        else
        {
          for(var j=0; j<thisRecord.length; j++)
          {
            var r = thisRecord[j]; 
            if(r[mainAlias+".recId"]==locateNextRecId)
            {
              this.setCurrentRecord(this.records[j]);
              located = true;
              break;
            }
          }
        }
        
        if(located == false)
        {
          if(this.records.length>0)
            this.setCurrentRecord(this.dataProvider[0]);
          else
            this.setCurrentRecord(null);
        }
      }
    }
  }

  doRecordDelete(sync=false,prompt=true)
  {
    //TODO 如果要删除多条 每一条记录的删除权限都要判断？
   
    var arg = new FormDataSourceGroupArg();
    arg.argType = 0;//待定
    arg.groupAlias = this.groupAlias;
    this.setFormDataSourceGroupArg(arg);
    if(arg.recordCounts == 0)
      return;
    if(!this.currentRecord && this.records.length ==0)
      return;
    for(let _key in arg.arg)
    {
      let _r = arg.arg[_key];
      if(!this.getAuthorityFinal("test",FormDataSourceAuthorityType.Delete,_r))
        return;
    }
    if(this.mainSource.isTempTable == true)
    {
      var mi = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".deleteRecord",window.menuItemId,window.formId);
   
      if(mi == null)
      {
        mi = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".beforeDeleteRecord",window.menuItemId,window.formId)
              || FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".afterDeleteRecord",window.menuItemId,window.formId);
        if(mi == null)
        {
          mi = {groups:"current(3)",editors:null,joinGroup:null,fetchOption:true};
        }
      }
      
      //mi =  FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".validateDelete",window.menuItemId,window.formId);
      var commandArg = CommandResolver.getSendCmd(window.formModuleInstance, this.groupAlias, mi);
      
      ServiceHelper.addTokenWithCommand({
        command:CommandHelper.createFormInstance(this.formDataSources.formModule.formName, "doRecordDelete")
        .appendArg(commandArg, "CommandArg")
        .appendArg(arg, "FormDataSourceGroupArg"),
        resultFunction:this.rpc_result_tempRecordDelete.bind(this,arg),sync
      });
      return;
    }
    let _parentWindow = window.parent.window;
    if(_parentWindow.userSettingEntry.isDelPrompt && prompt)
    {
      var options = 
      {
        text:"确认要删除吗,删除后将无法恢复",
        interacdestroy:false,
        confirm:{isShow:true,event:this.requireDeleteRecords.bind(this,arg,sync)},
        cancel:{isShow:true,event:''}
      };
      Warning.show(options);  
    }
    else
    {
      this.requireDeleteRecords(arg,sync);
    }
    
  }
  rpc_result_doTempRecordDelete(arg)
  {
      var ids = [];
      if(Array.isArray(arg.arg))
      {
        for(var i = 0;i<arg.arg.length;i++)
        {
          var _record = arg.arg[i];
          var id;
          if(_record.hasOwnProperty("recId"))
          {
            id = _record["recId"];
          }
          else
          {
            id = _record[this.groupAlias+".recId"];
          }
          ids.push(id);
        }
      }
      else
      {
        for(let _key in arg.arg)
        {
          _record = arg.arg[_key]
          if(_record.hasOwnProperty("recId"))
          {
            id = _record["recId"];
          }
          else
          {
            id = _record[this.groupAlias+".recId"];
          }
          //id = _record["recId"] || _record[this.groupAlias+".recId"];
          ids.push(id);
        }
      }
      this.deleteSelectedTempRecords(ids);
  }
  rpc_result_tempRecordDelete(arg,data)
  {
    var fdsgr = data.result;
    var finalDatas = fdsgr.dataResult;
    //TODO_yl 临时表 删除记录触发result
    if(fdsgr && fdsgr.commandResult){
      CommandResolver.resolve(fdsgr.commandResult.tasks, this.formDataSources.formModule, this);   
    }
    if(finalDatas && finalDatas.length>0)
    {
        this.rpc_result_doTempRecordDelete(arg);
    }
    else
    {
      alert("删除失败");
    }
  }

  doDeleteVersionRecord(record)
  {
    let mainAlias = this.mainSource.alias;
    let locateNextRecId = "";
    let origRecord = this.currentRecord;
    var index = this.records.indexOf(origRecord);
    var pre = null;
    if(index>=1)
    {
      pre = this.records[index-1];
    }
    else
    {
      pre = null;
    }
    
    if(pre)
    { 
      locateNextRecId = pre[mainAlias+".recId"];
    }
    var next = null;
    if(locateNextRecId == "")
    {
      if(index<length-1)
      {
        next = this.records[index+1];
      }
      else
      {
        next = null;
      }
      
      if(next != null)
      {
        locateNextRecId = next[mainAlias+".recId"];
      }
    }
    
    if(index!=-1)
    {
      let recId = record["recId"]
      this.records.splice(index,1);
      delete this.mapRecId[recId];
      delete this.recordsBak[recId];
      RecordsActions.recordsCmp(this.records,this.groupAlias,this);
    }
    
    var ret = {flag:true, locateNextRecId:locateNextRecId};
    
    return ret;
  }

  requireDeleteRecords(arg,sync)
  {
    /*if(arg && arg.arg)
    {
      let keys = Object.keys(arg.arg);
      if(keys && keys.length==1)
      {
        let record = arg.arg[0];
        if(record && record.recVersion == -1)
        {
          var obj = this.doDeleteVersionRecord(record); 
          this.locationAfterDelete(obj);
          return;
        }
      }
      
    }*/

    var mi = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".deleteRecord",window.menuItemId,window.formId);
   
    if(mi == null)
    {
      mi = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".beforeDeleteRecord",window.menuItemId,window.formId)
            || FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".afterDeleteRecord",window.menuItemId,window.formId);
      if(mi == null)
      {
        mi = {groups:"current(3)",editors:null,joinGroup:null,fetchOption:true};
      }
    }

    let isDeleteAll = false;
    if(arg&&this.records&&arg.recordCounts==this.records.length)
      isDeleteAll = true;
    
    //mi =  FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".validateDelete",window.menuItemId,window.formId);
    var commandArg = CommandResolver.getSendCmd(window.formModuleInstance, this.groupAlias, mi);
    
    ServiceHelper.addTokenWithCommand({
      command:CommandHelper.createFormInstance(this.formDataSources.formModule.formName, "doRecordDelete")
      .appendArg(commandArg, "CommandArg")
      .appendArg(arg, "FormDataSourceGroupArg"),
      resultFunction:this.rpc_result_doRecordDelete.bind(this,isDeleteAll),sync
    });
  }

  doRefreshOnClient(result)
  {
    this.rpc_result_doRecordRestore({result:result},true,false);
  }

  deleteRecordOnClient(recIds)
  {
    var obj = this.local_deleteRecord(null,recIds,false); 
    this.locationAfterDelete(obj);
  }

  rpc_result_doRecordDelete(isDeleteAll,data)
  {
    var fdsgr = data.result;
    this.formatFormDataSourceGroupResult(fdsgr);

    var finalDatas = fdsgr.dataResult;//RecordsUtil.getOneLevelDatas(fdsgr,this.groupAlias);
    
    if(finalDatas && finalDatas.length>0)
    {
      var obj = this.local_deleteRecord(finalDatas); 
      //var flag = obj["flag"];
      this.locationAfterDelete(obj);

      if(fdsgr && fdsgr.commandResult)
        CommandResolver.resolve(fdsgr.commandResult.tasks, this.formDataSources.formModule, this);      
      
      if(isDeleteAll)
      {
        this.recordRefresh(this.groupAlias,this.formDataSources.formModule.instanceUUId);
      }
    }
    else
    {
      alert("删除失败");
    }
  }

  locationAfterDelete(obj)
  {
    var locateNextRecId = obj["locateNextRecId"];
    this.locateRecord(locateNextRecId);
  }
  //仅在删除后被调用
  locateRecord(recId)
  {
    if(!recId)
    {
      this.setCurrentRecord(null,false);
    }
    else
    {
      var length = this.records.length;
      for(var j=0; j<length; j++)
      {
        var r = this.records[j];
        if(r[this.mainSource.alias+".recId"]==recId)
        {
          this.setCurrentRecord(this.records[j],false);  
          //this.formDataSources.formModule.focusController.setFocusAfterNewRecord(this);
          break;
        }
      }
    }
  }

  local_deleteRecord(ac,recIds=null,fade = false)
  {
      var mainAlias = this.mainSource.alias;
      var locateNextRecId = "";
      var flag = 0;
      if(!recIds)
        var recordCounts = ac.length;
      else
        recordCounts = recIds.length;
      
      var length = this.records.length;
      
      
      var next;
      var pre;
      if(!recIds)
      {
        recIds = [];
        for(var i = 0;i<ac.length;i++)
        {
          var record = ac[i];
          recIds.push(record[mainAlias+".recId"]);
        }
      }
      
      if(fade)
        var indexes = [];

      var delRecords = [];
      for(var k = 0;k<recIds.length;k++)
      {
        var recId = recIds[k];
        var origRecord = this.mapRecId[recId];
        if(origRecord)
        {
          delRecords.push(origRecord);
          var index = this.records.indexOf(origRecord);
          if(index == -1)
          {
            alert("mapRecId and dataProvider is not Match");
            continue;
          }
          
          if(locateNextRecId == "")
          {
            if(index>=1)
            {
              pre = this.records[index-1];
            }
            else
            {
              pre = null;
            }
            
            if(pre != null)
            { 
              var preRecId = pre[mainAlias+".recId"];
              if(recIds.indexOf(preRecId) == -1)
                locateNextRecId = preRecId;
            }
            
            if(locateNextRecId == "")
            {
              if(index<length-1)
              {
                next = this.records[index+1];
              }
              else
              {
                next = null;
              }
              
              if(next != null)
              {
                var nextRecId = next[mainAlias+".recId"];
                if(recIds.indexOf(nextRecId) == -1)
                  locateNextRecId = nextRecId;
              }
            }
          }
          if(fade)
          {
            indexes.push(index);
          }
          else
          {
            this.records.splice(index,1);
            delete this.mapRecId[recId];
            delete this.recordsBak[recId];
            RecordsActions.recordsCmp(this.records,this.groupAlias,this);
          }
          
          length --;
          flag++;
          
        }
        else
        {
          alert("要删除的记录不存在");
          continue;
        }
      }
      
      var ret = {flag:flag, locateNextRecId:locateNextRecId};
      
      if(fade)
      {
        //TODO 客户端记录删除时要闪烁行
        /*for each(var fgrid:FormItem_DataGrid in formDataSources.formModule.formDesign.grids)
        {
          if(fgrid.group == this)
          {
            var grid:GongqiDataGrid = fgrid.grid as GongqiDataGrid;
            if(grid != null)
            {
              grid.changeRowsAlpha(indexes,deleteFadeEnd,this,[recIds,ret]);
            }
          }
        }*/
        return ret;
      }
      else
      {
        return ret;
      }
  }

  doRecordRestore(sync=false,updateRelated=true,showInfo=true)
  {
    if(this.mainSource.isTempTable)
    {
      if(window.remainTasks)
      {
        let tasks = window.remainTasks;
        window.remainTasks = null;
        let task = tasks.shift();
          if(task)
              CommandResolver.doResolveTask(task,this.formdataSources.formModule,tasks);         
      }
      return;
    }

    if(!this.currentRecord)
    {
      if(window.remainTasks)
      {
        let tasks = window.remainTasks;
        window.remainTasks = null;
        let task = tasks.shift();
          if(task)
              CommandResolver.doResolveTask(task,this.formdataSources.formModule,tasks);         
      }
      return;
    }
      
    if(!this.getAuthorityFinal("test",FormDataSourceAuthorityType.Query,this.currentRecord))
    {
      if(window.remainTasks)
      {
        let tasks = window.remainTasks;
        window.remainTasks = null;
        let task = tasks.shift();
          if(task)
              CommandResolver.doResolveTask(task,this.formdataSources.formModule,tasks);         
      }
      return;
    }
   
    var arg = new FormDataSourceGroupArg();
    arg.argType = 0;
    arg.groupAlias = this.groupAlias;
    this.setFormDataSourceGroupArg(arg, "restore");
    
    if(arg.recordCounts==0)
      return;
    
    if(this.formDataSources.formModule.classAlias == "FormLookup")
    {
      //TODO 自定义与自动生成下拉框 均在权限判断时被捕获
      return;
    }
    else
    {
      var _rpc_result_doRecordRestore = this.rpc_result_doRecordRestore.bind(this);
      let formModule = this.formDataSources.formModule;
      ServiceHelper.addTokenWithCommand({
        command:CommandHelper.createFormInstance(this.formDataSources.formModule.formName, "doRecordRestore").appendArg(arg, "FormDataSourceGroupArg"), 
        resultFunction:function(data){
            _rpc_result_doRecordRestore(data,updateRelated,showInfo);
            if(window.remainTasks)
            {
              let tasks = window.remainTasks;
              window.remainTasks = null;
              let task = tasks.shift();
              if(task)
                  CommandResolver.doResolveTask(task,formModule,tasks);         
            }
        },
        sync:sync
      });
    }
  }

  doRecordRefresh(){
    RecordsActions.RecordRefresh(this.groupAlias,this.formDataSources.formModule.instanceUUId);
  }
  doRecordFetchAll(){
    RecordsActions.RecordFetchAll(this.groupAlias,this.formDataSources.formModule.instanceUUId);
  }

  local_restoreRecord(ac)
  {
    var mainAlias = this.mainSource.alias;
    var recordCounts = ac.length;
    for(var i=0; i<recordCounts; i++)
    {
      var record = ac[i];
      
      var _recVersion = record[mainAlias+".recVersion"]; 
      
      if(_recVersion=="-1" || _recVersion == -1)
      {
        //什么都不做，保持客户端现状不动
      }
      else if(_recVersion=="-2" || _recVersion == -2)
      {
        let recId = record[mainAlias+".recId"];
        var origIndex = this.records.indexOf(this.mapRecId[recId]);
        this.records.splice(origIndex,1);
        this.mapRecId[recId] = null;
        delete this.mapRecId[recId];
        delete this.recordsBak[recId];
        recordCounts--;
        Fade.show("记录已被删除，无法恢复");
      }
      else
      {
        this.replaceRecord(record);
        let recId = record[mainAlias+".recId"];
        this.mapRecId[recId] = record;
        this.recordsBak[recId] = Object.assign({},record);
      }
    }
    
    return recordCounts;
  }
    

  rpc_result_doRecordRestore(data,updateRelated,showInfo)
  {
    var result = data.result;
    this.formatFormDataSourceGroupResult(result,'refresh');
    
    if(result.dataResult)
    {
      var currentIndex = this.records?this.records.indexOf(this.currentRecord):-1;
      if(!this.dynamicColumnsPre || (this.dynamicColumnsPre && (window.dynamicColumnsPreOldIndex == undefined||window.dynamicColumnsPreOldIndex==null))){
        var flag = this.local_restoreRecord(result.dataResult);
      }else{
        let lastRecord = this.records[window.dynamicColumnsPreOldIndex] ;
        for(let key in result.dataResult[0]){
          let k = result.groupAlias+"."+key;
          if(key.indexOf(".") != -1){
            k = key;
          }
          if(lastRecord[k]){
            lastRecord[k] = result.dataResult[0][key];
          }
        }
        window.dynamicColumnsPreOldIndex = null;
        // var flag = this.local_restoreRecord(result.dataResult);
        var flag = 1;
      }
      //TODO 此处在晨光项目中会出现this.currentRecord不在this.records中的情况 但是无法找到原因 所以通过recId来找先屏蔽掉该问题
      if(currentIndex == -1 && this.records && this.currentRecord)
      {
        for(let i = 0;i<this.records.length;i++)
        {
          let r = this.records[i];
          if(r[this.groupAlias+".recId"] == this.currentRecord[this.groupAlias+".recId"])
          {
            currentIndex = i;break;
          }
        }
      }
      this.currentRecord = this.records[currentIndex];

      //this.currentRecordBak = Object.assign({},this.currentRecord);
      RecordsActions.RecordsRestoreCmp(this.groupAlias,this.records,this.formDataSources.formModule.instanceUUId);
      RecordsActions.RenderUpdateModifiedTag(this.groupAlias,this.currentRecord);
      //RecordsActions.currentRecordChanged(this.currentRecord,this.groupAlias);
      this.activeCurrentRecord(updateRelated);
      if(showInfo)
        Fade.show({text:"已恢复"+flag+"条记录"});
    }
    else
    {
      Fade.show("恢复失败，返回null");
    }
  }

  doAttachMent(flag='')
  {
    if(!this.currentRecord)
    {
      Warning.show({text:"请先选中记录再进行附件操作",state:"info"});
      return;
    }
    if(this.getCurRecVersion() == -1){
      Warning.show({text:"请先保存选中记录再进行附件操作",state:"info"});
      return;
    }
    var record = this.currentRecord;
    var _recId = record[this.mainSource.alias+".recId"];
    var _tableId = this.mainSource.tableId;
    var _formId = window.formModuleInstance.formId;
    var _aukey = "3_"+window.menuItemId+"."+this.mainSource.xml.id;
    if(flag=='drop'){
      window.parent.window.toolbarAttachmentDrop(_tableId,_recId,_formId,_aukey)
      return;
    }
    var $attachmentModal = $("#attachmentModal");
    var modalDiv = $("<div>").addClass("modal").css("display","flex").css("align-items","center")
    .css("justify-content","center").appendTo($attachmentModal);
    ReactDOM.render(<Attachment tableId={_tableId} recId={_recId} formId={_formId} aukey={_aukey}/>,modalDiv[0]);
        
  }

  doTempTableRecordSave(arg,sync,autoSave)
  {
      var fdsgr = new FormDataSourceGroupResult();
      fdsgr.aliasList = arg.aliasList;
      fdsgr.groupAlias = arg.groupAlias;
      fdsgr.recordCounts = arg.recordCounts;
      var ac = [];
      var obj = arg.arg[0];
      obj["recVersion"]++;
      //TODO 是否还需要copy?
      ac.push(obj);
      fdsgr.dataResult = ac;

      var mi = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".saveRecord",window.menuItemId,window.formId);
      if(mi==null)
      {
        mi = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".beforeSaveRecord",window.menuItemId,window.formId)
              || FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".afterSaveRecord",window.menuItemId,window.formId);
        if(mi == null)
        {
          mi = {groups:"current(3)",editors:null,joinGroup:null,fetchOption:true};
        }
      }
      
      var commandArg = CommandResolver.getSendCmd(window.formModuleInstance, this.groupAlias, mi);
      
      var _thisRecordSaveFaultHandler = this.recordSaveFaultHandler.bind(this);
      //sucessIngnoreStatus非异常返回固定调用success(除返回码为2的情况)
      ServiceHelper.addTokenWithCommand({
        command:CommandHelper.createFormInstance(this.formDataSources.formModule.formName, "doRecordSave").appendArg(commandArg, "CommandArg").appendArg(arg, "FormDataSourceGroupArg"),
        resultFunction:this.rpc_result_doRecordSave.bind(this,[autoSave]),sync:sync,successIngnoreStatus:true,
        faultFunction:function(data)
        {
          window.rowChangeAutoSaveFail=true;result.remoteFail=true;
          _thisRecordSaveFaultHandler(data)
        }
      });
      return result;
     
      this.do_rpc_result_doRecordSave(fdsgr);
  }

  doRecordSave(sync=false,autoSave=false)
  {

    //TODO 是否需要权限判断？
    var result = {notModify:false,remoteFail:false};
    //if(!this.getAuthorityFinal("test",FormDataSourceAuthorityType.Save,this.currentRecord))
    //  return result;
    window.rowChangeAutoSaveFail=false;
    
    if(this.currentRecord == null || this.currentRecord == undefined)
      return result;
    let autoSaveBeforeResults = [];
    RecordsActions.autoSaveBefore(this.groupAlias,autoSaveBeforeResults);

    if(autoSaveBeforeResults && autoSaveBeforeResults.length>0)
    {
      for(let i = 0;i<autoSaveBeforeResults.length;i++)
      {
        if(autoSaveBeforeResults[i] == false)
          return;
      }
    }

    if(!this.getAuthorityFinal("test",FormDataSourceAuthorityType.Save,this.currentRecord))
      return result;
   
    if(!this.isCurrentRecordModified() && !this.isWorkFlow)
    {
      result.notModify = true;
      return result;
    }

    var arg = new FormDataSourceGroupArg();
    arg.argType = 0;//待定
    arg.groupAlias = this.groupAlias;
    this.setFormDataSourceGroupArg(arg);

    if(arg.recordCounts>1)
    {
      Warning.show({text:"目前不支持多条记录的保存",interacdestroy:false,cancel:{isShow:false,event:''}});
      return;
    }
    
    //if(this.mainSource.isTempTable == true
    //    || this.hasDynamicColumn == true)
    if(this.hasDynamicColumn == true)
    {
      var fdsgr = new FormDataSourceGroupResult();
      fdsgr.aliasList = arg.aliasList;
      fdsgr.groupAlias = arg.groupAlias;
      fdsgr.recordCounts = arg.recordCounts;
      var ac = [];
      var obj = arg.arg[0];
      obj["recVersion"]++;
      delete obj["remoteClass"];
      //TODO 是否还需要copy?
      ac.push(obj);
      fdsgr.dataResult = ac;
      this.do_rpc_result_doRecordSave(fdsgr);
      return;
    }
    
    
    var s = "";
    
    for(var key in FormItemUtil.formItemControlsForFor)
    {
      var item = FormItemUtil.formItemControlsForFor[key];
      if(item.xml && item.xml.type && item.xml.type.indexOf("Editor")!=-1 && item.group == this && item.getSelfNotNull())
      {
        var _result = item.validateNotNull();
        if(_result)
        {
          if(s==null)
            s = "值不能为空：" + _result
          else
            s += "\n" + "值不能为空：" + _result;
        }
      }
    }
    
    if(s!= "")
    {
      window.rowChangeAutoSaveFail=true;
      if(!window.rowrowChangeAutoSaveWarn){
        Warning.show({
          text:"保存操作由于以下原因未成功:\n"+s,
          interacdestroy:false,
          cancel:{isShow:false,event:''},
          rowrowChangeAutoSaveWarn:true
        });
        window.rowrowChangeAutoSaveWarn = true;
      }
      return;
    }
    
    var mi = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".saveRecord",window.menuItemId,window.formId);
    if(mi==null)
    {
      mi = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".beforeSaveRecord",window.menuItemId,window.formId)
            || FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".afterSaveRecord",window.menuItemId,window.formId);
      if(mi == null)
      {
        mi = {groups:"current(3)",editors:null,joinGroup:null,fetchOption:true};
      }
    }
    
    var commandArg = CommandResolver.getSendCmd(window.formModuleInstance, this.groupAlias, mi);
    
    var _thisRecordSaveFaultHandler = this.recordSaveFaultHandler.bind(this);
    //sucessIngnoreStatus非异常返回固定调用success(除返回码为2的情况)
    ServiceHelper.addTokenWithCommand({
      command:CommandHelper.createFormInstance(this.formDataSources.formModule.formName, "doRecordSave").appendArg(commandArg, "CommandArg").appendArg(arg, "FormDataSourceGroupArg"),
      resultFunction:this.rpc_result_doRecordSave.bind(this,autoSave),sync:sync,successIngnoreStatus:true,
      faultFunction:function(data)
      {
        window.rowChangeAutoSaveFail=true;result.remoteFail=true;
        _thisRecordSaveFaultHandler(data)
      }
    });
    return result;
  }

  rpc_result_doRecordSave(autoSave,data)
  {
      if(data.status != 0)
      {
        window.rowChangeAutoSaveFail=true;
        return;
      }
      var result = data.result;
      this.do_rpc_result_doRecordSave(result,autoSave); 
      
      if(result && result.commandResult)
        CommandResolver.resolve(result.commandResult.tasks, this.formDataSources.formModule, this);  
  }

  local_saveRecord(ac)
  {
    var currentIndex;
    var record;
    var origIndex;
    var recordCounts = ac.length;
    
    var flag = false;
    if(recordCounts==1 && this.mainSource.idGenerator=="Identity")
    {
      record = ac[0];
      var recVersion = record[this.mainSource.alias+".recVersion"];
      if(recVersion==0)
      {
        for(var key in this.mapRecId)
        {
          var o = this.mapRecId[key];
          if(o[this.mainSource.alias+".recVersion"]==-1)
          {
            origIndex = this.records.indexOf(o);
            currentIndex = origIndex;
            this.records[origIndex] = record;

            //更新临时表筛选记录 变更currentIndex以tempRecordsFilter为准
            if(this.mainSource.isTempTable == true && this.tempRecordsFilter)
            {
              origIndex = this.tempRecordsFilter.indexOf(o);
              currentIndex = origIndex;
              this.tempRecordsFilter[origIndex] = record;
            }
            
            delete this.mapRecId[o[this.mainSource.alias+".recId"]];
            this.mapRecId[record[this.mainSource.alias+".recId"]] = record;
            this.recordsBak[record[this.mainSource.alias+".recId"]] = Object.assign({},record);
            flag = true;
            break;
          }
        }
      }
      
      
    }
    
    if(flag==false)
    {
      for(var i=0; i<recordCounts; i++)
      {
        record = ac[i];
        var recId = record[this.mainSource.alias+".recId"];
        
        var origRecord = this.mapRecId[recId];
        
        if(origRecord==null)
          throw new Error("miss origRecord when save record:" + recId);
        origIndex = this.records.indexOf(origRecord);
        if(origIndex == -1)
        {
          for(var k=0; k<this.records.length; k++)
          {
            if(this.records[k] == origRecord)
            {
              origIndex = k;
              break;
            }
            
          }

        }
        if(i==0)
          currentIndex = origIndex;
        this.records[origIndex] = record;
        this.mapRecId[recId] = record;
        this.recordsBak[recId] = Object.assign({},record);

        //更新临时表筛选记录
        if(this.mainSource.isTempTable == true && this.tempRecordsFilter)
        {
          origIndex = this.tempRecordsFilter.indexOf(origRecord);
          if(origIndex == -1)
          {
            for(var k=0; k<this.tempRecordsFilter.length; k++)
            {
              if(this.tempRecordsFilter[k] == origRecord)
              {
                origIndex = k;
                break;
              }
              
            }

          }
          if(i==0)
            currentIndex = origIndex;
          this.tempRecordsFilter[origIndex] = record;
        }

      } 
    }

    return currentIndex;
  }

  do_rpc_result_doRecordSave(fdsgr,autoSave)
  {
    this.formatFormDataSourceGroupResult(fdsgr,"save");
    var finalDatas = fdsgr.dataResult;
    //RecordsUtil.getOneLevelDatas(fdsgr,this.groupAlias);
    var ac = finalDatas;
    if(!ac || ac.length==0)
    {
      alert("保存失败，返回null");
    }
    else
    {      
      var currentIndex = this.local_saveRecord(ac);
      if(this.mainSource.isTempTable == true && this.tempRecordsFilter)
      {
        this.currentRecord = this.tempRecordsFilter[currentIndex];
      }
      else
      {
        this.currentRecord = this.records[currentIndex];
      }
     

      //this.currentRecordBak = Object.assign({},this.currentRecord);
      RecordsActions.RecordAutoSaveCmp(this.groupAlias,this.currentRecord);
      RecordsActions.RenderUpdateModifiedTag(this.groupAlias,this.currentRecord);
      //RecordsActions.currentRecordChanged(this.currentRecord,this.groupAlias);
      // window.doIcheckOnlyOneTime = false;
    
      this.activeCurrentRecord(true,undefined,false,autoSave?true:false,{},false);
      

      //TODO 提示信息
    } 
  }

  recordSaveFaultHandler(message)
  {
    if(message && message.successButNot0)
    {
      message = message.errText;
    }
    else if(typeof(message)!="string")
    {
      Warning.show({text:"请检查网络是否正常或联系管理员",title:"记录保存失败"});
      return;
    }
   
    var faultString = message;
    if(message.indexOf("Duplicate entry") == 0 && this.currentRecord)
    {
      var key = message.substring(message.lastIndexOf(" ")+2,message.length-1);
      var tableXML = GOT.getTable(this.mainSource.tableId);
      if(tableXML)
      {
        var index = GOT.getTableIndex(tableXML,key);
        if(index)
        {
          var tableIndexItems = index.IndexItems;
          var fieldsLabel = "";
          var labelNum = 0;
          for(let i = 0;i<tableIndexItems.length;i++)
          {
            let tableIndexItem = tableIndexItems[i];
            let fieldPro = GOTUtil.getProperty(tableIndexItem,"Field");
            if(fieldPro.hasOwnProperty("innerid"))
            {
              let innerid = fieldPro.innerid;
              let tableField = GOT.getTableField(tableXML,innerid);
              if(tableField)
              {
                let label = GOTUtil.getFinalValue(tableField,tableXML,"Label");
                let dataFieldKey = this.mainSource.tableName+"."+StringUtil.convertToFirstLowerCase(tableField.name);
                if(!this.currentRecord.hasOwnProperty(dataFieldKey))continue;
                fieldsLabel += (label + ":" + this.currentRecord[dataFieldKey] + "\n");
                labelNum++;
              }
            }
          }
          faultString = "";
          faultString += fieldsLabel;
          if(labelNum > 1)
            faultString += "的组合";
          faultString += " 不唯一";
        }
      }
    }
    else if(message.indexOf("Row was updated or deleted by another transaction") == 0)
    {
      faultString = "当前记录状态已不是最新或者已被删除，请执行恢复记录操作"
    }
    else if(faultString && faultString.indexOf("#NotNull:") == 0)
    {
      faultString = "请填写以下必填项：\n"+faultString.substr(9);
    }
    if(!window.rowrowChangeAutoSaveWarn){
      window.rowrowChangeAutoSaveWarn = true;
      Warning.show({text:faultString,rowrowChangeAutoSaveWarn});
    }
  }

  rpcAutoSaveRecord(record)
  {
    
  }

  isCurrentRecordModified()
  {
    if(this.getCurRecVersion() == -1)
      return true;

    for(var key in this.currentRecord)
    {
      if(this.isCurrentDataFieldModified(this.currentRecord,key,false))
        return true;
    }

    return false;
  }

  isCurrentDataFieldModified(record,dataField,checkVersion=true)
  {
    if(checkVersion && record)
    {
      if(this.getCurRecVersion(record) == -1)
        return true;
    }
    if(record != this.currentRecord)
      return false;
    if(dataField && this.isTempDataMethodField(dataField))
      return false;
    let newValue = record[dataField];
    let _recId = record[this.groupAlias+".recId"];
    let currentRecordBak = this.recordsBak[_recId];
    var origValue = currentRecordBak[dataField];

    /*let _alias;
    if(dataField)
    {
      _alias = dataField.split(".")[0];
    }
    if(_alias)
    {
      var _fds
      for(let i in this.sources)
      {
        var tf = this.sources[i];
        if(tf.alias == _alias)
        {
          _fds = tf;
          break;
        }
      }
      if(_fds)
      {
        let _type = _fds.fieldType[dataField];
        if(_type == "Decimal")
        {
          try
          {
            return parseFloat(newValue) != parseFloat(origValue);
          }
          catch(e)
          {
    
          }
        }
      }
    }*/

    if(typeof(origValue) == "number")
    {
      try
      {
        return parseFloat(newValue) != parseFloat(origValue);
      }
      catch(e)
      {

      }
    }

    return (newValue+"")!=(origValue+"");
  }

  setCurrentRecord(record,delay=true,parms = {})
  {
    //TODO  如果为正式表 数据查询以后 为后台新返回 此处判断会判断到发生更改 从而执行activeCurrentRecord触发UI变更
    //如果为临时表 由于是客户端过滤 过滤之前选中的记录与过滤后的记录为同一引用 所以不会变更
    var bool = this.currentRecord!=record;
    if(this.mainSource.isTempTable == true)bool = true;
    if(parms&&parms.activeRecord == true)bool=true;
    this.currentRecord = record;
    //this.currentRecordBak = Object.assign({},this.currentRecord);
    //RecordsActions.currentRecordChanged(record,this.groupAlias);
    if(this.records && this.records.length>0 && this.records.indexOf(this.currentRecord) == -1)
    {
      var a = "string";
    }
    if(bool)this.activeCurrentRecord(true,undefined,delay,false,parms);
  }

  executeQuery(type,xml = null,onlyFecth = false,sync = false,tasks = null)
  {
    this.doExecuteQuery(type,xml,onlyFecth,sync,tasks);
  }

  reExecuteQuery(sync = false,tasks)
  {
    this.reSetCurrentQuery(this.currentQuery);
    //this.executeQuery(null,null,false,sync,tasks);
    
    if(this.forLookup)
    {
      this.doExecuteQuery(null,null,false,sync,tasks);
    }
    else
    {
      var result = this.onRecordAutoSave(this.groupAlias);

      if(result && !result.remoteFail)
      {
        this.doExecuteQuery(null,null,false,sync,tasks);
      }  
    }
    
  }
  
	onExecuteQuery(queryType,groupAlias,xml=null, onlyFetch=false)
  {
    alert("已废弃");
      //如果不是另外Form Link的情况 并且formId不同 说明是下拉画面与非下拉画面之间的传递
     // if(type != ExecuteType.LINK && formId != this.formDataSources.formId)
      //    return;
      
  		if(groupAlias != "all" && this.groupAlias != groupAlias)
  			return;
  		var sourceNames = [];
  		for(var i in this.sources)
  		{
  			var item = this.sources[i];
  			sourceNames.push(item.sourceName);
  		}
  		var postdata = {sources:JSON.stringify(sourceNames),filterVal:""};
	  	//验证同步调用在action中有效
	  	/*AjaxRemoteUtil.ajax('get','http://127.0.0.1:50508/GongqiERP/test','json',true,function(){console.log("第11111111111111111111111111111111111")});
	  	console.log("第2222222222222222222222222222222222");
	  	AjaxRemoteUtil.ajax('get','http://127.0.0.1:50508/GongqiERP/test','json',false,function(){console.log("第三3333333333333333333333333333")});*/
	  	//alert('2222222222222222222222222');
	  	AjaxRemoteUtil.ajaxPost('/web/GetData/getData?_dataarea=dynamic',postdata,'json',true,this.rpcExecuteQuery.bind(this));
  }

  appendWhereItemForFormModuleLookup(xml,fm)
  {
    var qwis = GOTUtil.getQueryWhereItemByPropertyValue(xml,"tag","autoAppendForFormModuleLookup");
    if(qwis.length>0)
      return;

    if(fm.lookupArg==null)
      return;
    
    var bf = fm.lookupArg["baseFilter"];
    if(bf==null || bf=="")
      return;
    
    if(bf.indexOf("*")==-1 && bf.indexOf("?")==-1)
      return;

    var qwi = {qname:"QueryWhereItem",name:"t",id:"",tag:"autoAppendForFormModuleLookup",
               Properties:{Field:{V:"",refentityid:"",refinnerid:""},
                           Value:{V:""},AndOr:{V:"And"},LeftBracket:{V:"None"},
                           RightBracket:{V:"None"},Label:{V:""},Status:{V:"Hide"},
                           Enabled:{V:true}
               }
    };
    var pName = qwi.Properties.Field;
    pName.refentityid = this.mainSource.tableId;
    pName.refinnerid = this.formDataSources.xml.Properties.ReturnField.refinnerid;
    if(pName.refinnerid=="" || pName.refinnerid==null)
      return;
    
    pName.V = fm.lookupArg["fieldName"];
    var pValue = qwi.Properties.Value;
    pValue.V = bf;
    
    var qw = xml.QueryWhere || xml.QueryTable.QueryWhere;
    qw.Items.push(qwi);
  }
    
  getCurrentQueryTable()
  {
    var _queryTable;
    ///try
    //{
      
        _queryTable = QueryUtil.convertXML2QueryTable(this.currentQuery);

     
    //}
    //catch(error)
    //{
    //  this.currentQuery = JSON.parse(JSON.stringify(this.formQuery));
    //  this.currentQuery.needRefresh = true;
    //  _queryTable = QueryUtil.convertXML2QueryTable(this.currentQuery);
    //  alert("QueryTable构造失败，已重置，请与管理员联系");
    //}
    
    return _queryTable;
  }

  analysisSingleRecord(item,_queryTable = null,isRightContext = false)
  {
    if(_queryTable != null)
    {
      if(!_queryTable.getSqlWhereStr)
        _queryTable.getSqlWhereStr = QueryTable.getSqlWhereStr;
      var ws = _queryTable.getSqlWhereStr();
      if(ws == "")
        return true;

      /*var wsa2 = ws.split(" ");
      var wsr = "";
      
      var wsa = [];
      var flag = true;
      var values = "";
      var flagHelper = true;
      var k = 0;
      for(let i=0;i<wsa2.length;i++)
      {
        let s2 = wsa2[i];
        if(flag && s2.indexOf("=\"") == -1)
        {
          if(k == (wsa2.length-1))
          {
            s2 = s2.replace("=\"","=");
            values+=(s2.substr(0,s2.length-1));
            break;
          }
          else
          {
            wsa.push(s2);
          }
          flag = false;
        }
        else
        {
          if(flagHelper)
          {
            s2 = s2.replace("=\"","=");
            k==wsa2.length-1?values+=(s2.substr(0,s2.length-1)):values+=(s2+" ");
            flagHelper = false;
          }
          else
          {
            if(k==wsa2.length-1)
            {
              values+=(s2.substr(0,s2.length-1));
            }
            else
            {
              values+=(s2+" ");
            }
          }
        }
        k++;
          
      }
      
      wsa.push(values);*/

      let wsa = [];let wsr = "";
      let fieldsTypes={};
      for(let k = 0;k<_queryTable.queryWhere.length;k++)
      {
        let queryWhereItem = _queryTable.queryWhere[k];
        if(k>0){wsa.push("and");}
        
        if(typeof(queryWhereItem.fieldValue)!="number" && !queryWhereItem.fieldValue){queryWhereItem.fieldValue=""}
        let fieldValues = [];
        if(queryWhereItem.fieldValue.indexOf && queryWhereItem.fieldValue.indexOf(",")!=-1)
          fieldValues = queryWhereItem.fieldValue.split(",");
        else 
          fieldValues = [queryWhereItem.fieldValue];

        if(fieldValues.length>1)
          wsa.push("(");
        for(let n = 0;n<fieldValues.length;n++)
        {
          let _fv = fieldValues[n];
          if(n>0)
          {
            wsa.push("or",(queryWhereItem.fieldName+"="+_fv));
          }
          else
          {
            wsa.push(queryWhereItem.fieldName+"="+_fv);
          }
        }
        if(fieldValues.length>1)
          wsa.push(")");

          fieldsTypes[queryWhereItem.fieldName] =queryWhereItem.fieldType;
      }
      
      for(let i = 0;i<wsa.length;i++)
      //for each(var s:String in wsa)
      {
        let s = wsa[i];
        if(s.indexOf("=") == -1)
        {
          wsr += s;
        }
        else
        {
          var fn = StringUtil.convertToEachFirstLowerCase(s.substring(0,s.indexOf("=")));
          var fv = s.substr(s.indexOf("=")+1);
          if(fn.indexOf(".") == -1)
          {
            var value = item[this.groupAlias+"."+fn];
          }
          else
          {
            value = item[this.groupAlias+"."+fn];
          }
          if(fieldsTypes[s.substring(0,s.indexOf("="))]=="TypeDecimal"){
            value=parseFloat(value);
          }
          //fv为表达式一定为string  而"true"==true解释器会判定为false 所以如果value是bool 则要转为字符串判断
          if(typeof(value) == "boolean")value+="";
          if(RecordsUtil.analysisValue(value,fv,false,isRightContext))
          {
            wsr+="1";
          }
          else
          {
            wsr+="0";
          }
        }
        
      }
      
      return StringUtil.evalLEString(StringUtil.trimThrough(wsr));
    }
    return true;
  }
    

  tmpQueryTable = null;

  getFormDataSourceFieldTypeByField(field)
  {
    if(this.sources)
    {
      for(let i = 0;i<this.sources.length;i++)
      {
        let source = this.sources[i];
        let fieldTypeObj = source.fieldType;
        if(fieldTypeObj && fieldTypeObj.hasOwnProperty(field))
          return fieldTypeObj[field];
      }
    }
    return null;
  }

  executeQueryOnClient(queryTable,tasks,isRightContext=false)
  {
    this.updateQueryRemove();
    
    if(this.records && this.records.length>0)
    {
      var oldCurrentIndex= this.records.indexOf(this.currentRecord);

      this.tmpQueryTable = queryTable;
      //TODO 临时表过滤 是否可依赖REACTDATAGRID本身的功能
      var _analysisSingleRecord = this.analysisSingleRecord.bind(this);
      var recordsFilter = this.records.filter(
                  function(item)
                  {
                    return _analysisSingleRecord(item,queryTable,isRightContext);
                  }
      );

      //this.dataProvider.filterFunction = qwiEqualsFilterFunc;
      var _groupAlias = this.groupAlias;
      var _getFormDataSourceFieldTypeByField = this.getFormDataSourceFieldTypeByField.bind(this);
      if(queryTable.queryOrderBy && queryTable.queryOrderBy.length>0)
      {
          recordsFilter.sort(function(a,b){
            for(let i = 0;i<queryTable.queryOrderBy.length;i++)
            {
              let qoi = queryTable.queryOrderBy[i];
              if(qoi.fieldName && qoi.fieldName != "")
              {
                let desc = qoi.orderBy == QueryOrderByType.DESC?true:false;
                let trueFieldName = StringUtil.convertToEachFirstLowerCase(qoi.fieldName);
                //var fieldtype = _mainSource.fieldType[trueFieldName];
                let _field = _groupAlias+"."+trueFieldName;
                let aValue = a[_field];
                let bValue = b[_field];
                let _type = _getFormDataSourceFieldTypeByField(trueFieldName);
                if( _type == "Decimal" 
                  || _type == "Long")
                {
                  if(typeof(aValue) == "string" || typeof(bValue) == "string")
                  {
                      try
                      {
                        let aValueNum = parseFloat(aValue);let bValueNum = parseFloat(bValue);
                        if(desc)
                          return bValueNum-aValueNum;//(aValueNum < bValueNum) ? 1 : -1;
                        else
                          return aValueNum-bValueNum;//(aValueNum > bValueNum) ? 1 : -1;
                      }
                      catch(e)
                      {

                      }
                    
                  }
                }

                if(aValue == bValue)
                  continue;
                if(desc)
                  return (aValue < bValue) ? 1 : -1;
                else
                  return (aValue > bValue) ? 1 : -1;
              }
            }
            return 0;
        });
      
      }

      

      //TODO 有风险this.records = recordsFilter;
      this.mapRecId = {};
      if(!this.records)
        return;
      
      var mainAlias = this.groupAlias;
      var record;
      for(let i = 0;i<this.records.length;i++)
      {
        record = this.records[i];
        let _recId = record[mainAlias+".recId"];
        this.mapRecId[_recId] = record;
        this.recordsBak[_recId] = Object.assign({},record);
      }



      RecordsActions.recordsCmp(recordsFilter,this.groupAlias,this);

      let sp = GOTUtil.getPropertyValue(this.mainSource.xml,"StartPosition");
      let newCurrentRecord = null;
      if(recordsFilter && recordsFilter.length>0)
      {
        if(sp == "First")
          newCurrentRecord = recordsFilter[0]
        else
          newCurrentRecord = recordsFilter[recordsFilter.length-1];
      }
      this.tempRecordsFilter = recordsFilter;
      
      //var newCurrentRecord = (recordsFilter&&recordsFilter.length>oldCurrentIndex)?recordsFilter[oldCurrentIndex]:null;
      this.setCurrentRecord(newCurrentRecord);
    }
    else
    {

    }
    this.after_rpc_result_executeQuery(false,tasks);
    // if(this.dataProvider==null || this.dataProvider.length==0)
    // {
    //   this.currentRecord = null;
    // }
    this.tempRecordsFilter = recordsFilter;
    if(recordsFilter && recordsFilter.length>0)
      this.countGroup(recordsFilter);
  }

  executeQueryAutoSaveStop(type,xml = null,onlyFetch = false,isOrder = false,isRightContext = false,arg={})
  {
    if(this.forLookup)
    {
      return this.doExecuteQuery(type,xml,onlyFetch);
    }
    else
    {
      var result = this.onRecordAutoSave(this.groupAlias);

      if(!result.remoteFail)
      {
        return this.doExecuteQuery(type,xml,onlyFetch,false,null,isOrder,isRightContext,arg);
      }  
    }
    
  }

  queryFilter(_dataField,value,isRightContext=false)
  {
    if(!this.getAuthorityFinal("test",FormDataSourceAuthorityType.Query,this.currentRecord))
    {
      Fade.show({text:"您所在的用户组没有该权限"});return;
    }
    
    if(window.isDataSetView){
      this.dataSetQueryTable.queryAllFields =[];
      this.getQueryFiledAllItemsForDataSetView(this.dataSetQueryTable);
      this.queryFilterForSetData(_dataField,"","",this.dataSetQueryTable,value); 
    }
    if(!window.isDataSetView){
      QueryUtil.findOrCreateWhereItem(_dataField,this.currentQuery,value);
      this.reSetCurrentQuery(this.currentQuery);
    }
    //xml = null,onlyFetch = false,isOrder = false
    this.executeQueryAutoSaveStop(null,null,false,false,isRightContext);
  }

  // queryFilterForSetData(xml,filed,value){
  //   var fiedArr = filed.split(".");
  //   var filedNameUp = fiedArr[1].substring(0,1).toUpperCase()+fiedArr[1].substring(1);
  //   for(let i=0;i<this.dataSetQueryTable.queryFields.length;i++){
  //     let queryItem = this.dataSetQueryTable.queryFields[i];
  //     if(queryItem.fieldName == filedNameUp){
  //       var queryWhereItem = new QueryWhereItem();
  //       queryWhereItem.tableId = this.dataSetQueryTable.tableId;
  //       queryWhereItem.fieldId = queryItem.refInnerId;
  //       queryWhereItem.fieldName = queryItem.fieldName;
  //       //queryWhereItem.fieldValue = queryItem.Properties.Value.V;
  //       queryWhereItem.value = value;
  //       let tableFiled = GOT.getTableFieldById(this.dataSetQueryTable.tableId,queryItem.refInnerId);
  //       if(tableFiled)queryWhereItem.fieldType = "Type"+tableFiled.type;
  //       queryWhereItem.andOr = "And";
  //       queryWhereItem.leftBracket = "None";
  //       queryWhereItem.rightBracket = "None";
  //       queryWhereItem.label = "";
  //       queryWhereItem.status = "Open";
  //       queryWhereItem.tag = "";
  //       this.dataSetQueryTable["queryWhere"].push(queryWhereItem)
  //     }
  //   }
  // }
  getQueryFiledAllItemsForDataSetView(query){
    if(this.dataSetQueryTable.queryAllFields == undefined)this.dataSetQueryTable.queryAllFields = [];
    for(let i=0;i<query.queryFields.length;i++){
      this.dataSetQueryTable.queryAllFields.push(query.queryFields[i]);
    }
    if(query.queryJoins.length>=1){
      for(let h in query.queryJoins){
        this.getQueryFiledAllItemsForDataSetView(query.queryJoins[h]);
      }
    }
  }

  getAllQueryFieldssForDataSetView(query){
    if(this.dataSetQueryTable.allQueryFields == undefined)this.dataSetQueryTable.allQueryFields = [];
    for(let i=0;i<query.queryFields.length;i++){
      let dataSourceName = query.aliasName.substr(query.aliasName.lastIndexOf("_")+1,query.aliasName.length);
      query.queryFields[i].dataSourceFliedName =dataSourceName+"."+StringUtil.convertToFirstLowerCase(query.queryFields[i].fieldName);
      this.dataSetQueryTable.allQueryFields.push(query.queryFields[i]);
    }
    if(query.queryJoins.length>=1){
      for(let h in query.queryJoins){
        this.getAllQueryFieldssForDataSetView(query.queryJoins[h]);
      }
    }
  }

  getQueryOrderByAllItemsForDataSetView(query){
    if(this.dataSetQueryTable.queryOrderByFields == undefined)this.dataSetQueryTable.queryOrderByFields = [];
    for(let i=0;i<query.queryOrderBy.length;i++){
      this.dataSetQueryTable.queryOrderByFields.push(query.queryOrderBy[i]);
    }
    if(query.queryJoins.length>=1){
      for(let h in query.queryJoins){
        this.getQueryOrderByAllItemsForDataSetView(query.queryJoins[h]);
      }
    }
  }

  queryFilterForSetData(tableField,field,alias,query,value = null)
	{
    var fiedArr = tableField.split(".");
    var filedNameUp = fiedArr[1].substring(0,1).toUpperCase()+fiedArr[1].substring(1);
    if(!this.dataSetQueryTable.queryAllFields){this.getQueryFiledAllItemsForDataSetView(this.dataSetQueryTable)}
    for(let i=0;i<this.dataSetQueryTable.queryAllFields.length;i++){
      let queryItem = this.dataSetQueryTable.queryAllFields[i];
      if((queryItem.fieldAliasName && queryItem.fieldAliasName ==fiedArr[1] )|| (StringUtil.convertToAllLowerCase(queryItem.fieldName) == StringUtil.convertToAllLowerCase(filedNameUp))){
        var queryWhereItem = new QueryWhereItem();
				queryWhereItem.qname= QueryWhereItem;
				queryWhereItem.tableId=queryItem.refEntityId;	//String
				queryWhereItem.fieldId=queryItem.refInnerId;	//String
        let tableFiled = GOT.getTableFieldById(queryItem.refEntityId,queryItem.refInnerId);
        if(tableFiled)queryWhereItem.fieldType = "Type"+tableFiled.type;
				queryWhereItem.fieldName=queryItem.fieldName;//String

				// if(value.indexOf(">=") != -1 || value.indexOf("<=") != -1  || value.indexOf("<>") != -1 ) {
				// 	value = value.slice(0,2)+"\'"+value.slice(2)+"\'"; 
				// }
				queryWhereItem.value=value;	//String
				queryWhereItem.andOr="And";	//String
				queryWhereItem.leftBracket="None";		//String	//QueryWhereLeftBracket
				queryWhereItem.rightBracket="None";	//String	//QueryWhereRightBracket
					
				queryWhereItem.label="";	//String
				queryWhereItem.status="Open";	//String			//QueryWhereStatus	//String	//QueryWhereFieldType
				queryWhereItem.tag="";	//String
        if(queryItem.type && queryItem.type == 'Expression'){
          queryWhereItem.fieldType='Expression';
        }
				//queryWhereItem.fieldValue = value;


				for(let i in query.queryWhere){
					if(query.queryWhere[i].tableId === query.tableId && query.queryWhere[i].fieldId === queryItem.refInnerId && query.queryWhere[i].andOr === "And"){
						if(query.queryWhere[i].fieldType == "TypeDate"){
							if((value.indexOf(">=") != -1 && query.queryWhere[i].value.indexOf(">=") != -1) 
							|| (value.indexOf("<=") != -1 && query.queryWhere[i].value.indexOf("<=") != -1) 
							||  (value.indexOf("<>") != -1 && query.queryWhere[i].value.indexOf("<>") != -1)){
								query.queryWhere.splice(i, 1);
							}
						}else{
							query.queryWhere.splice(i, 1);
						}
					}
				}
				if(query.tableId == queryItem.refEntityId){
					if(typeof(value)== 'string' && value.indexOf("<>") == -1){
						query.queryWhere.push(queryWhereItem);
					}else{
            query.queryWhere.push(queryWhereItem);
          }
				}else if(query.queryJoins.length>0){
					for(let h in query.queryJoins){
						query.queryJoins[h]["QueryInteraction"] = query.QueryInteraction;
						this.queryFilterForSetData(tableField,"",alias,query.queryJoins[h],value);
					}
				}
			}
		}
	}


  sort(dataField,sortType = null,byUser = false,cover = false)
  {
    //activeCurrentRecord已经触发 此时权限已经取得并反映到toolbarObject
    if(!this.getAuthorityFinal("test",FormDataSourceAuthorityType.Query,this.currentRecord))
    {
      if(!window.isDataSetView)
      {
        Fade.show({text:"您所在的用户组没有该权限"});return;
      }
    }
    
    if(window.isDataSetView){
      this.getQueryOrderByAllItemsForDataSetView(this.dataSetQueryTable);
      var fiedArr = dataField.split(".");
      var filedNameUp = fiedArr[1].substring(0,1).toUpperCase()+fiedArr[1].substring(1);
      for(let i=0;i<this.dataSetQueryTable.queryOrderByFields.length;i++){
        let queryItem = this.dataSetQueryTable.queryOrderByFields[i];
        for(let i=0;i<this.dataSetQueryTable.queryAllFields.length;i++){
          let query = this.dataSetQueryTable.queryAllFields[i];
          if(StringUtil.convertToAllLowerCase(query.fieldName) == StringUtil.convertToAllLowerCase(filedNameUp) || query.fieldAliasName ==filedNameUp){
            if(StringUtil.convertToAllLowerCase(queryItem.fieldName) == StringUtil.convertToAllLowerCase(query.fieldName)){
              if(queryItem.orderBy == "ASC"){
                sortType = "DESC";
              }else{
                sortType = "ASC";
              }
            }
            }
          }
        }
      this.reSetDataSetExecuteSort(null,this.dataSetQueryTable);
      this.dataSetQueryTable.queryAllFields =[];
      this.getQueryFiledAllItemsForDataSetView(this.dataSetQueryTable);
      this.sortForSetData(this.dataSetQueryTable,dataField,sortType,byUser,cover); 
    }else{
      QueryUtil.setCurrentQueryOrderByByDataField(dataField,this.currentQuery,sortType,byUser,cover);
      this.reSetCurrentQuery(this.currentQuery);
    }
    this.executeQueryAutoSaveStop(null,null,false,true);
  }
  //
  sortForSetData(query,filed,sortType,byUser,cover){
    var fiedArr = filed.split(".");
    var filedNameUp = fiedArr[1].substring(0,1).toUpperCase()+fiedArr[1].substring(1);
    this.dataSetQueryTable["queryOrderBy"] = [];
    var queryOrderByItem = new QueryOrderByItem();
    for(let i=0;i<this.dataSetQueryTable.queryAllFields.length;i++){
      let queryItem = this.dataSetQueryTable.queryAllFields[i];
      if(StringUtil.convertToAllLowerCase(queryItem.fieldName) == StringUtil.convertToAllLowerCase(filedNameUp) || queryItem.fieldAliasName ==filedNameUp){
        var queryOrderByItem = new QueryOrderByItem();
        queryOrderByItem.tableId = this.dataSetQueryTable.tableId;
        queryOrderByItem.fieldId = queryItem.refInnerId;
        queryOrderByItem.fieldName = queryItem.fieldName;
        queryOrderByItem.orderBy = sortType;
        queryOrderByItem.fieldType = queryItem.type;
        if(query.tableId == queryItem.refEntityId){
					query.queryOrderBy.push(queryOrderByItem);
				}else if(query.queryJoins.length>0){
					for(let h in query.queryJoins){
						query.queryJoins[h]["QueryInteraction"] = query.QueryInteraction;
						this.sortForSetData(query.queryJoins[h],filed,sortType,byUser,cover);
					}
				}
      }
    }
  }

  sortForLookup(dataField,sortType = null,byUser = false,cover = false)
  {
    QueryUtil.setCurrentQueryOrderByByDataField(dataField,this.currentQuery,sortType,byUser,cover);
    this.reSetCurrentQuery(this.currentQuery);
    this.executeQueryAutoSaveStop(null,null,false,true);
  }
    

  doQueryRemove()
  {
    this.reSetCurrentQuery(JSON.parse(JSON.stringify(this.formQuery)));
    this.executeQueryAutoSaveStop(null);
  }

  doDataSetExecuteQuery(arg,xml=null)
  {
    if(xml!=null)
    {
      this.reSetCurrentQuery(xml);
    }
    let type = arg.type;var fromFirst;var startIndex = 0;
    var size = 50;
    if(type=="FetchAll")
    {
      startIndex = 0;
      size =200000;
    }
    else
    {
      if(this.currentQuery.direction=="First")
      {
        fromFirst = true;
        if(this.records==null || this.currentQuery.needRefresh==true)
        {
          startIndex = 0;
        }
        else
        {
          if(type=="NextPage" || type=="Next" || type=="PrevPage") 
            startIndex = this.records.length;
        }
      }
      else
      {
        fromFirst = false;
        if(this.records==null || this.currentQuery.needRefresh==true)
        {
          startIndex = 0;
        }
        else
        {
          if(type=="PrevPage" || type=="Prev")
            startIndex = this.records.length;
        }
      }
      if(startIndex){
      }else{
        this.currentQuery.needRefresh=true;
      }
      // 暂时放开 20000

    }

    if(window.parent.dataSetPreviewFordataset){
      window.parent.dataSetPreviewFordataset.query.QueryTable = this.dataSetQueryTable;
    }
    // window.parent.window.didomain ="doMain_412";
    // if(window.parent.window.didomain){
      let queryTable = this.dataSetQueryTable;

      if(window.parent.dataSetPreviewFordataset){
        window.parent.dataSetPreviewFordataset.query.queryTable = queryTable;
      }

      var domain = queryTable.doMain;
      if(window.parent.window.dataSetPreviewForPrintApp){
        domain = window.parent.window.prientAppDomain;
      }
      if(!domain){
        domain  = window.parent.window.didomain;
      }
      //TODO 综合域暂时写死 MIX
      // var url = window.parent.window.osUrl+"/"+window.parent.window.didomain+"/web/apps/gongqi.tool.datasetDesign/dsDesign/executeQuery";
      var url = window.parent.window.osUrl+"/"+"MIX"+"/web/apps/gongqi.tool.datasetDesign/dsDesign/executeQuery";
      let _headers = {"Content-type":"application/json"};
      if(!window.parent.window.loginToken)
      {
        let _token = localStorage.getItem("userToken");
        if (_token){
          _headers.token = _token;
        }else{
          _headers.token = window.parent.localStorage.getItem("userToken");
        }
      }	
      var _that = this;
      var param = {
        "queryTable":queryTable,
        "stat":startIndex,
        "size":size,
        "init":false,
      }; 
      AjaxRemoteUtil.setRemoteDisable({lockText:'正在努力加载数据...',autoLock:true});
      $.ajax({
        type:'post',
        url:url,
        dataType:"json",
        headers: _headers,
        data:JSON.stringify(param),
        success:function(data){
          if(data.errcode == 0)
          {	
            AjaxRemoteUtil.setRemoteEnable({autoUnlock:true});
              data.result = JSON.parse(data.content);
              data.status = 0;
              _that.rpc_dsExecuteQuery_result(arg,data);            
          }
          else
          {
            AjaxRemoteUtil.setRemoteEnable({autoUnlock:true});
            let text = "查询失败："+data.errmsg;
            // var options = {state: 'error',text:text};
            // Fade.show(options);
            Warn.show({text:text,mutiLine:true});
          }

        },	
        error:function(data){
          let text = "查询失败";
          var options = {state: 'error',text:text};
          Fade.show(options);
        }
      })
    // }else{
    //     ServiceHelper.addTokenWithCommand({command:command,
    //       resultFunction:this.rpc_dsExecuteQuery_result.bind(this,arg)});
    // }
  }

  doExecuteQuery(type, xml=null, onlyFetch=false, sync=false, tasks=null,isOrder=false,isRightContext=false,arg={})
  {
    
    if(window.isDataSetView && !this.forLookup)
    {
      this.doDataSetExecuteQuery({type:type});
      return;
    }

    if(xml!=null)
    {
      this.reSetCurrentQuery(xml);
    }
    
    if(this.currentQuery==null)
      return;
   
    var command;
    var _queryTable;
    var fromFirst;
    var startIndex;
    
    if(this.mainSource.fetchAll==true)
      type = "FetchAll";
    
    var fmLookup;
    
    //****************  非FormLookup的下拉框
    if(this.forLookup)// && this.formDataSources.formModule.classAlias != "FormLookup")
    {
      if(arg && arg.appendFilter == true)
      {
        if(this.records==null || this.currentQuery.needRefresh==true)
        {
          this.appendWhereItemForFormModuleLookup(this.currentQuery, this.formDataSources.formModule);
        }
      }
      
    }
    //*********************
    
    
    if(this.mainSource.isTempTable == true || (isOrder && this.sortOnClient))
    {
      _queryTable = this.getCurrentQueryTable();
      _queryTable.queryRelations = null;
      this.executeQueryOnClient(_queryTable,tasks,isRightContext);
      return;
    }
    
    //TODO 初始化查询要异步 命令同步是通过栈实现的 此处判断不会影响到命令的执行 只会防止两个重复的异步查询
    //if(inRemotingExecuteQuery)
    //  return;
    
    if(this.flag_enterMainForm==true)
    {
      var mainTableWhereValues = window.argCaller.mainTableWhereValues;
      for(var i = 0;i<mainTableWhereValues.length;i++)
      {
        var kv = mainTableWhereValues[i];
        var _value = kv.value;
        if(_value=="")
          _value = null;
        
        QueryUtil.createWhereItemByField(
          kv.key,
          kv.key,
          this.mainSource.alias,
          this.currentQuery,
          _value
        );
        
      }
      this.flag_enterMainForm = false;
    }
    
    _queryTable = this.getCurrentQueryTable();
    
    /////
    if(this.currentQuery.direction=="Last")
    {
      QueryUtil.reverseOrderBy(_queryTable.queryOrderBy);
    }
    /////
    _queryTable.queryRelations = null;
    var commandArg;
    
    if(type=="FetchAll")
    {
      if(this.formDataSources.formModule.classAlias == "FormLookup")
      {
        fmLookup = this.formDataSources.formModule;
        
        if(fmLookup!=null && fmLookup.lookupArg!=null)
        {
          var formId = fmLookup.lookupArg["baseFormId"];
          if(formId)
          {
            var fieldName;
            if(fmLookup.lookupArg["groupAlias"]!=null)
            {
              fieldName = fmLookup.lookupArg["groupAlias"] + "." + "lookup_" + fmLookup.lookupArg["fieldName"];
            }
            else
            {
              fieldName = "lookup_" + fmLookup.lookupArg["filterFieldName"];
            }
            var cmdargInfo = FormResourceUtil.getCommandArgMethodInfo(fieldName,window.menuItemId,window.formId);
            if(cmdargInfo != null)
            {
              //TODO FormDataSourceGroup只作用于FormLookup及FormModule QueryForm Dialog Report的查询不使用该类
              // var fm:FormModule = fmLookup.lookupCaller as FormModule;
              // if(fm!=null)
              // {
                var defaultGroupAlias = fmLookup.lookupArg["groupAlias"];
                commandArg = CommandResolver.getSendCmd(window.formModuleInstance, defaultGroupAlias, cmdargInfo);
              // }
            }
          }
        }
        
        // if(fmLookup.lookupCaller is FormLookup 
        //   || fmLookup.lookupCaller is QueryForm
        //   || fmLookup.lookupCaller is ReportModule
        //   || fmLookup.lookupCaller is FormBaseModuleForDialog)  
        // {
        //   command = Command.createService( "gongqi.erp.gotmodel.services.GOTService", "doLookup", "FormDataSourceGroupResult")
        //     .appendArg(fmLookup.lookupArg["fieldName"], "String")
        //     .appendArg(fmLookup.lookupArg["filterFieldName"], "String")
        //     .appendArg(fmLookup.lookupArg["baseFilter"], "String")
        //     .appendArg(fmLookup.lookupArg["queryObject"], "Object")
        //     .appendArg(false.toString(), "boolean")
        //     .appendArg("0", "int")
        //     .appendArg("0", "int")
        //     .appendArg("false", "boolean");
        // }
        // else if(fmLookup.lookupCaller is FormModule)  //FormModule FormModuleLookup
        // {
        if(fmLookup.lookupArg.editorFormType == "Dialog")
        {
          command = Command.createService( "gongqi.erp.gotmodel.services.GOTService", "doLookup", "FormDataSourceGroupResult")
             .appendArg(fmLookup.lookupArg["fieldName"], "String")
             .appendArg(fmLookup.lookupArg["filterFieldName"], "String")
             .appendArg(fmLookup.lookupArg["baseFilter"], "String")
             .appendArg(fmLookup.lookupArg["queryObject"], "Object")
             .appendArg(false.toString(), "boolean")
             .appendArg("0", "int")
             .appendArg("0", "int")
             .appendArg("false", "boolean");
        }
        else
        {
          command = CommandHelper.createFormInstance(window.formModuleInstance.formName, "doLookup")
          .appendArg(commandArg, "CommandArg").appendArg(fmLookup.lookupArg["groupAlias"], "String")
          .appendArg(fmLookup.lookupArg["fieldName"], "String").appendArg(fmLookup.lookupArg["filterFieldName"], "String")
          .appendArg(fmLookup.lookupArg["baseFilter"], "String").appendArg(fmLookup.lookupArg["baseRecord"], "Object")
          .appendArg(fmLookup.lookupArg["queryObject"], "Object").appendArg("false", "boolean")
          .appendArg("0", "int").appendArg("0", "int").appendArg("false", "boolean");  
        }
        
        // }
        // else
        // {
        //   throw new Error("fmLookup.lookupCaller undefined");
        // }
      }
      else
      {
        var fieldName = this.groupAlias + ".beforeExecuteQuery";
        var fm = this.formDataSources.formModule;
        var cmdargInfo = FormResourceUtil.getCommandArgMethodInfo(fieldName,fm.classAlias=="FormModuleLookup"?"FormLookup":window.menuItemId,fm.props.formId);

        if(cmdargInfo == null)
        {
          cmdargInfo = 
                //FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".beforeExecuteQuery",fm.classAlias=="FormModuleLookup"?"FormLookup":window.menuItemId,fm.props.formId)
                FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".afterExecuteQuery",fm.classAlias=="FormModuleLookup"?"FormLookup":window.menuItemId,fm.props.formId);
          if(cmdargInfo == null)
          {
            cmdargInfo = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".executeQuery",fm.classAlias=="FormModuleLookup"?"FormLookup":window.menuItemId,fm.props.formId);
            if(cmdargInfo == null)
              cmdargInfo = {groups:"current(3)",editors:null,joinGroup:null,fetchOption:true};
          }
        }

        if(cmdargInfo!=null)
        {
          commandArg = CommandResolver.getSendCmd(this.formDataSources.formModule, this.groupAlias, cmdargInfo);
        }
        
        command = CommandHelper.createFormInstance(this.formDataSources.formModule.formName, "executeQuery")
          .appendArg(commandArg, "CommandArg").appendArg(this.groupAlias, "String").appendArg(_queryTable, "Object")
          .appendArg("false", "boolean").appendArg("0", "int").appendArg("0", "int").appendArg("false", "boolean");
      }
      
    }
    else
    {
      if(this.currentQuery.direction=="First")
      {
        fromFirst = true;
        if(this.records==null || this.currentQuery.needRefresh==true)
        {
          startIndex = 0;
        }
        else
        {
          if(type=="NextPage" || type=="Next")
            startIndex = this.records.length;
        }
        if(this.dynamicColumnsPre){
          startIndex = 0;
        }
      }
      else
      {
        fromFirst = false;
        if(this.records==null || this.currentQuery.needRefresh==true)
        {
          startIndex = 0;
        }
        else
        {
          if(type=="PrevPage" || type=="Prev")
            startIndex = this.records.length;
        }
      }
      
      
      
      if(this.formDataSources.formModule.classAlias == "FormLookup")
      {
        fmLookup = this.formDataSources.formModule;
        fmLookup.lookupArg["queryObject"] = _queryTable;
        
        if(fmLookup!=null && fmLookup.lookupArg!=null)
        {
          formId = fmLookup.lookupArg["baseFormId"];
          if(formId!=null)
          {

            if(fmLookup.lookupArg["groupAlias"]!=null)
            {
              fieldName = fmLookup.lookupArg["groupAlias"] + "." + "lookup_" + fmLookup.lookupArg["fieldName"];
            }
            else
            {
              fieldName = "lookup_" + fmLookup.lookupArg["filterFieldName"];
            }
            cmdargInfo = FormResourceUtil.getCommandArgMethodInfo(fieldName);
            defaultGroupAlias = fmLookup.lookupArg["groupAlias"];
            if(cmdargInfo != null)
            {
              // fm = fmLookup.lookupCaller as FormModule;
              // if(fm!=null)
              // {
                commandArg = CommandResolver.getSendCmd(window.formModuleInstance, defaultGroupAlias, cmdargInfo);
              // }
            }
            else
            {
              commandArg = CommandResolver.getSendCmd(window.formModuleInstance, defaultGroupAlias, 
                {groups:"current(3)",editors:null,joinGroup:null});
            }
          }
        }
        
        if(fmLookup.lookupArg.editorFormType == "Dialog")
        {
            command = Command.createService( "gongqi.erp.gotmodel.services.GOTService", "doLookup", "FormDataSourceGroupResult")
              .appendArg(fmLookup.lookupArg["fieldName"], "String")
              .appendArg(fmLookup.lookupArg["filterFieldName"], "String")
              .appendArg(fmLookup.lookupArg["baseFilter"], "String")
              .appendArg(fmLookup.lookupArg["queryObject"], "Object")
              .appendArg("true", "boolean")
              .appendArg(startIndex+"", "int")
              .appendArg(this.dataPageSize+"", "int")
              .appendArg(fromFirst+"", "boolean"); 
        }
        else
        {
            command = CommandHelper.createFormInstance(window.formModuleInstance.formName, "doLookup")
              .appendArg(commandArg, "CommandArg")
              .appendArg(fmLookup.lookupArg["groupAlias"], "String")
              .appendArg(fmLookup.lookupArg["fieldName"], "String")
              .appendArg(fmLookup.lookupArg["filterFieldName"], "String")
              .appendArg(fmLookup.lookupArg["baseFilter"], "String")
              .appendArg(fmLookup.lookupArg["baseRecord"], "Object")
              .appendArg(fmLookup.lookupArg["queryObject"], "Object")
              .appendArg("true", "boolean")
              .appendArg(startIndex+"", "int")
              .appendArg(this.dataPageSize+"", "int")
              .appendArg(fromFirst+"", "boolean");
        }
      }
      else
      {

        //TODO 暂时用来屏蔽由于最末条 滚动条通过编程方式到末尾时也会触发nextPage 而此时startIndex未定义
        if(startIndex == undefined)
          return;
        
        var fieldName = this.groupAlias + ".beforeExecuteQuery";
        var fm = this.formDataSources.formModule;

        var cmdargInfo = FormResourceUtil.getCommandArgMethodInfo(fieldName,
                                        fm.classAlias=="FormModuleLookup"?"FormLookup":window.menuItemId,
                                        fm.classAlias=="FormModuleLookup"?this.formDataSources.formModule.formId:window.formId);
        if(cmdargInfo == null)
        {
          cmdargInfo = //FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".beforeExecuteQuery",
                       //                                             fm.classAlias=="FormModuleLookup"?"FormLookup":window.menuItemId,
                       //                                             fm.classAlias=="FormModuleLookup"?this.formDataSources.formModule.formId:window.formId)
                       //|| 
                       FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".afterExecuteQuery",
                                                                    fm.classAlias=="FormModuleLookup"?"FormLookup":window.menuItemId,
                                                                    fm.classAlias=="FormModuleLookup"?this.formDataSources.formModule.formId:window.formId);
          if(cmdargInfo == null)
          {
            cmdargInfo = FormResourceUtil.getCommandArgMethodInfo(this.groupAlias+".executeQuery",
                                                                      fm.classAlias=="FormModuleLookup"?"FormLookup":window.menuItemId,
                                                                      fm.classAlias=="FormModuleLookup"?this.formDataSources.formModule.formId:window.formId);
            if(cmdargInfo == null)
              cmdargInfo = {groups:"current(3)",editors:null,joinGroup:null,fetchOption:true};
            else if(!cmdargInfo.groups)
              cmdargInfo.groups = "current(3)";

          }
        }
        if(cmdargInfo!=null)
        {
          commandArg = CommandResolver.getSendCmd(this.formDataSources.formModule, this.groupAlias, cmdargInfo);
        }
        
        command = CommandHelper.createFormInstance(this.formDataSources.formModule.formName, "executeQuery")
          .appendArg(commandArg, "CommandArg").appendArg(this.groupAlias, "String").appendArg(_queryTable, "Object")
          .appendArg("true", "boolean").appendArg(startIndex+"", "int").appendArg(this.dataPageSize+"", "int")
          .appendArg(fromFirst+"", "boolean");
      }
    }
    
    var _rpc_result_executeQuery = this.rpc_result_executeQuery.bind(this);
    var _this = this;
    if(command.methodName == "doLookup" && (window.parent.window.TableCheckDoMain || window.parent.window.lookupEditorDoMain)){
      let domain = window.parent.window.lookupEditorDoMain?window.parent.window.lookupEditorDoMain:window.parent.window.TableCheckDoMain;
      let url = window.parent.window.osUrl+"/GongqiERP/"+domain+"/ServiceController";
      return ServiceHelper.addTokenWithCommand2({command:command,lockText:"正在努力获取数据 请稍后",url,domain:domain,
      resultFunction:function(data)
      {
        _rpc_result_executeQuery(data, type, onlyFetch, tasks);
        //alert(JSON.stringify(data));
      },sync:sync,
      faultFunction:function(data)
      {
        //不管是何原因导致的错误 都认为可能是由于默认查询失效 使用正确的查询再试一次
        if(_this.fromDefaultSavedQuery)
        {
          Warning.show({text:"之前保存的默认查询已失效，已自动更正"});
          _this.fromDefaultSavedQuery = false;

          var key = _this.formDataSources.formModule.props.formId + "_" + _this.mainSource.id + "." + (_this.forLookup?"FormLookup":window.menuItemId);
          //delete QueryUtil.userQueryList[key];
          QueryUtil.deleteUserQueryList(key);
          _this.initFormQuery();
          _this.initCurrentQuery();
          _this.doExecuteQuery();
         
          return;
        }
        //如果第二次试验都不行 则进入正常错误处理流程
        if(data && data.successButNot0)
        {
          if(window.parent.document.getElementsByClassName("gongqi-warn") && window.parent.document.getElementsByClassName("gongqi-warn").length < 1){
            Warning.show({text:data.errText,title:"查询失败"});
          }
        }
        else
        {
           Warning.show({text:"请检查网络是否正常或联系管理员",title:"画面初始查询失败"});
        }
        window.groupActiveRecordStateObj[this.groupAlias].querying = false;
        //Warning.show({text:JSON.stringify(data)});
      }
    });

    }else{
      return ServiceHelper.addTokenWithCommand({command:command,lockText:"正在努力获取数据 请稍后",
      resultFunction:function(data)
      {
        _rpc_result_executeQuery(data, type, onlyFetch, tasks);
        //alert(JSON.stringify(data));
      },sync:sync,
      faultFunction:function(data)
      {
        //不管是何原因导致的错误 都认为可能是由于默认查询失效 使用正确的查询再试一次
        if(_this.fromDefaultSavedQuery)
        {
          Warning.show({text:"之前保存的默认查询已失效，已自动更正"});
          _this.fromDefaultSavedQuery = false;

          var key = _this.formDataSources.formModule.props.formId + "_" + _this.mainSource.id + "." + (_this.forLookup?"FormLookup":window.menuItemId);
          //delete QueryUtil.userQueryList[key];
          QueryUtil.deleteUserQueryList(key);
          _this.initFormQuery();
          _this.initCurrentQuery();
          _this.doExecuteQuery();
         
          return;
        }
        //如果第二次试验都不行 则进入正常错误处理流程
        if(data && data.successButNot0)
        {
          if(window.parent.document.getElementsByClassName("gongqi-warn") && window.parent.document.getElementsByClassName("gongqi-warn").length < 1){
            Warning.show({text:data.errText,title:"查询失败"});
          }
        }
        else
        {
           Warning.show({text:"请检查网络是否正常或联系管理员",title:"画面初始查询失败"});
        }
        window.groupActiveRecordStateObj[this.groupAlias].querying = false;
        //Warning.show({text:JSON.stringify(data)});
      }
    });
    }
    
  }

  updateQueryRemove()
  {
    var formQueryChild = this.formQuery.QueryTable;
    var currentQueryChild = this.currentQuery.QueryTable;
    
    this.queryChanged = JSON.stringify(formQueryChild) != JSON.stringify(currentQueryChild);
   
    if(this.isGlobalForehandGroup())
    {
       var toolBarObject = window.toolBarObject;
       if(this.currentQuery.QueryTable.queryWhere && this.currentQuery.QueryTable.queryWhere.Items.length>0){
         this.queryChanged=true;
        }
        ToolBarUtil.setObjectQueryRemove(toolBarObject,this.queryChanged);
       var _parentWindow = window.parent.window;
       _parentWindow.setToolBar(toolBarObject);
       UtilActions.updateInnerToolBar(toolBarObject);
    }
    
  }
  //record<=>newRecord
  replaceRecord3(record,replaceAttr = false)
  {
    var ac = this.records;
    if(!ac)
      throw new Error("ac==null");
    
    var mainAlias = this.groupAlias;
    var recId = record[mainAlias+".recId"];
    /*if(!this.mapRecId.hasOwnProperty(recId))
    {
     
      this.mapRecId[recId] = item;
      this.recordsBak[recId] = Object.assign({},record);
    }
      throw new Error("mapRecId中不存在" + recId);*/
    
    var origRecord = this.mapRecId[recId];
    if(replaceAttr)
    { 
      if(origRecord==null)
      {
        alert("origRecord null");
      }
      else if(record==null)
      {
        alert("record null when replaceRecord");
      }
      else
      {
        this.replaceRecordValue(record,origRecord);
      }
    }
    else
    {
      var index = ac.indexOf(origRecord);
      //alert("替换了第"+index+"条记录");
      if(index==-1)
        alert("index==-1  " + recId);
      ac[index] = record;

      if(this.tempRecordsFilter)
      {
        index = this.tempRecordsFilter.indexOf(origRecord);
        if(index!=-1)this.tempRecordsFilter[index] = record;
      }
    }
  }

  replaceRecord(record,replaceAttr = false)
  {
    var ac = this.records;
    if(!ac)
      throw new Error("ac==null");
    
    var mainAlias = this.groupAlias;
    var recId = record[mainAlias+".recId"];
    //TODO_YL  不存在的跳过
    if(!this.mapRecId.hasOwnProperty(recId))
      return;
      // throw new Error("mapRecId中不存在" + recId);
    var origRecord = this.mapRecId[recId];
    if(replaceAttr)
    { 
      if(origRecord==null)
      {
        alert("origRecord null");
      }
      else if(record==null)
      {
        alert("record null when replaceRecord");
      }
      else
      {
        this.replaceRecordValue(record,origRecord);
      }
    }
    else
    {
      var index = ac.indexOf(origRecord);
      if(index==-1)
        alert("index==-1  " + recId);
      ac[index] = record;
    }
  }

  replaceRecordValue(record,result)
  {
    if(record == null || result == null)
      return;
    
    for (var itemName in record)
    {
      var item = record[itemName];
      result[itemName] = item;
    }
  }

  resetMapRecId()
  {
    this.mapRecId = {};
    if(!this.records)
      return;
    
    var mainAlias = this.groupAlias;
    var record;
    for(let i = 0;i<this.records.length;i++)
    {
      record = this.records[i];
      let _recId = record[mainAlias+".recId"];
      this.mapRecId[_recId] = record;
      this.recordsBak[_recId] = Object.assign({},record);
    }
  }

  local_recordFirst(focus = true,parms = {})
  {
    if(!this.records || this.records.length==0)
    {
      this.setCurrentRecord(null,true,parms);
      return;
    }
    
    this.setCurrentRecord(this.records[0]);
    
    if(focus)
    {

    }
      //this.formDataSources.formModule.focusRecord();
  }

  local_recordNext(parms = {})
  {
    if(!this.records || this.records.length==0)
    {
      this.setCurrentRecord(null,true,parms);   
      return;
    }
    
    var oldIndex = this.records.indexOf(this.currentRecord);
    
    var index = 0;
    if(!this.currentRecord)
    {
      index = 0;
    }
    else
    {
      index = oldIndex + 1;
    }
    
    var findex = Math.min(index,this.records.length-1);

    this.setCurrentRecord(this.records[findex]);
    
  }

  recordFirst(groupAlias,moduleInstanceId)
  {
    if(this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId != moduleInstanceId)
      return;

    if(!this.currentQuery)
      return;
    
    if(this.currentQuery.direction=="First")
    {
      this.local_recordFirst();
    }
    else
    {
      if(this.currentQuery.toEnd==true)
      {
        this.local_recordFirst();
      }
      else
      {
        this.currentQuery.direction = "First";
        this.currentQuery.toEnd = false;
        this.currentQuery.needRefresh = true;
        
        this.executeQueryAutoSaveStop("First");
      }
    }
    
  }

  recordLast(groupAlias,moduleInstanceId)
  {
    if(this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId != moduleInstanceId)
      return;
    if(!this.currentQuery)
      return;
    
    if(this.currentQuery.direction=="First")
    {
      if(this.currentQuery.toEnd==true)
      {
          this.local_recordLast();
      }
      else
      {
        this.currentQuery.direction = "Last";
        this.currentQuery.toEnd = false;
        this.currentQuery.needRefresh = true;
        
        this.executeQueryAutoSaveStop("Last");
      }
    }
    else if(this.currentQuery.direction=="Last")
    {
        this.local_recordLast();
    }
    
  }

  local_recordLast(focus = true,parms = {})
  {
    if(!this.records || this.records.length==0)
    {
      this.setCurrentRecord(null,true,parms);
      return;
    }
        
    var _currentRecord = this.records[this.records.length-1];
    this.setCurrentRecord(_currentRecord);
    
    if(focus)
    {

    }
  }

  local_recordPrev(parms={})
  {
    if(!this.records || this.records.length==0)
    {
      this.setCurrentRecord(null,true,parms);
      return;
    }
    
    var oldIndex = this.records.indexOf(this.currentRecord);
    
    var index = 0;
    if(this.currentRecord==null)
    {
      index = 0;
    }
    else
    {
      index = oldIndex - 1;
    }
    
    if(index<0)
    {
      index = 0;
    }
    
    var _currentRecord = this.records[index];
    this.setCurrentRecord(_currentRecord);
  }
  
  recordNextPage(onlyFetch,groupAlias,moduleInstanceId)
  {
      if(this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId!=moduleInstanceId)
        return;

      if(!this.currentQuery)
        return;
      
      
      if(this.currentQuery.direction=="First")
      {
        if(this.currentQuery.toEnd==true)
        {
          if(onlyFetch==false)
            this.local_recordNextPage();
        }
        else
        {
          if(!this.records || this.records.length==0)
          {
            this.executeQueryAutoSaveStop("NextPage");
          }
          else
          {
            var oldIndex = this.records.indexOf(this.currentRecord);
            var index;
            var result = {};
            UtilActions.getGridInfos(this.groupAlias,result,this.formDataSources.formModule.instanceUUId);
            if(result.linesOnScreen)
            {
              index = result.verticalScrollPosition + Math.ceil(result.linesOnScreen);
            }
            else
            {
              index = oldIndex;
            }
            
            if(index+result.linesOnScreen*2>=this.records.length-1
              || oldIndex+result.linesOnScreen*2>=this.records.length-1)
            {
              this.executeQueryAutoSaveStop("NextPage", null, onlyFetch);
            }
            else
            {
              if(onlyFetch==false)
                this.local_recordNextPage();
            }
          }
        }
      }
      else
      {
        if(onlyFetch==false)
          this.local_recordNextPage();
        
      }
      
  }
 
  recordPrevPage(onlyFetch=false,groupAlias,moduleInstanceId)
  {
    if(groupAlias != this.groupAlias || this.formDataSources.formModule.instanceUUId != moduleInstanceId)
      return;
    if(this.currentQuery==null)
      return;
    //if(this.currentQuery.direction=="Last")
    //{
      if(this.currentQuery.toEnd==true)
      {
        //if(onlyFetch==false)
         // this.local_recordPrevPage();
      }
      else
      {
        if(!this.records || this.records.length==0)
        {
          this.executeQueryAutoSaveStop("PrevPage");
        }
        else
        {
          var index;
          var result = {};
          UtilActions.getGridInfos(this.groupAlias,result,this.formDataSources.formModule.instanceUUId);
          if(result.linesOnScreen)
          {
            index = result.verticalScrollPosition + Math.ceil(result.linesOnScreen);
          }
          else
          {
            index = oldIndex;
          } 
          if(onlyFetch 
            && result.linesOnScreen 
            && result.verticalScrollPosition==0
            && this.currentQuery.toEnd==false)
          {
            this.executeQueryAutoSaveStop("PrevPage", null, onlyFetch);
          }
          else
          {
            var oldIndex = this.records.indexOf(this.currentRecord);
            var index;
            if(result.linesOnScreen)
            {
              index = result.verticalScrollPosition;
            }
            else
            {
              index = oldIndex;
            }
            var d = oldIndex - index;

            if(d == 0)
            {
              if(onlyFetch==false)
                this.local_recordPrevPage();
              return;
            }

            if(result.linesOnScreen && d>=result.linesOnScreen)
              d = result.linesOnScreen-1;
            
            if(oldIndex-result.linesOnScreen*2-d<=0 )
            {
              this.executeQueryAutoSaveStop("PrevPage", null, onlyFetch);
            }
            else
            {
              if(onlyFetch==false)
                this.local_recordPrevPage();
            }
          }
        }
      }
    //}
    //else
    //{
    //  if(this.currentQuery.direction == "First")
    //    return;
    //  if(onlyFetch==false)
    //    this.local_recordPrevPage();
      
   // }
    
  }

  recordRefresh(groupAlias,moduleInstanceId)
  {
    if(this.groupAlias == groupAlias && this.formDataSources.formModule.instanceUUId == moduleInstanceId)
    {
      this.reSetCurrentQuery(this.currentQuery);
      this.executeQueryAutoSaveStop();  
    }
    //LogHelper.setUserOprLog("重新查询",this.formId,currentGroup.groupAlias);
  }

  recordFetchAll(groupAlias,moduleInstanceId)
  {
    if(this.groupAlias != groupAlias || this.formDataSources.formModule.instanceUUId != moduleInstanceId)
      return;
    if(!this.currentQuery)
      return;
    
    this.currentQuery.needRefresh = true;
    this.executeQueryAutoSaveStop("FetchAll");
    //LogHelper.setUserOprLog("全部获取",this.formDataSources.formModule.formId,this.groupAlias);
  }

  recordFetchAllForCmd(tasks)
  {
    if(!this.currentQuery)
    {
      CommandResolver.resolve(tasks,this.formDataSources.formModule);
      return;
    }
    this.currentQuery.needRefresh = true;

    if(this.forLookup)
    {
      this.doExecuteQuery("FetchAll",null,false,false,tasks);
    }
    else
    {
      var result = this.onRecordAutoSave(this.groupAlias);

      if(!result.remoteFail)
      {
        this.doExecuteQuery("FetchAll",null,false,false,tasks);
      }
      else
      {
        CommandResolver.resolve(tasks,this.formDataSources.formModule);
      }  
    }

  }

  local_recordNextPage(parms = {})
  {
    if(!this.records || this.records.length==0)
    {
      this.setCurrentRecord(null,true,parms);
      return;
    }
    
    var oldIndex = this.records.indexOf(this.currentRecord);
    
    var index;
    var result = {};
    UtilActions.getGridInfos(this.groupAlias,result,this.formDataSources.formModule.instanceUUId);
    if(result.linesOnScreen)
    {
      index = result.verticalScrollPosition + Math.ceil(result.linesOnScreen);
    }
    else
    {
      index = oldIndex;
    }
    index = Math.min(index,this.records.length-1);
    this.setCurrentRecord(this.records[index]);
  }

  local_recordPrevPage(parms = {})
  {
    if(!this.records || this.records.length==0)
    {
      this.setCurrentRecord(null,true,parms);
      return;
    }
    var oldIndex = this.records.indexOf(this.currentRecord);
    var index;
    var result = {};
    
    if(!this.currentRecord)
    {
      index = 0;
    }
    else
    {
      UtilActions.getGridInfos(this.groupAlias,result,this.formDataSources.formModule.instanceUUId);
      if(result.linesOnScreen)
        index = result.verticalScrollPosition;
      else
        index = oldIndex;
      
      index -= (result.linesOnScreen?Math.ceil(result.linesOnScreen):10);
    }

    if(index<0)index=0;
    this.setCurrentRecord(this.records[index]);
  }

  scrollEndNextPage()
  {
    if(!this.currentQuery)
    {
      alert("scrollEndNextPage but currentQuery is null");return;
    }
    if(this.currentQuery.toEnd==true)
      return;
    this.executeQueryAutoSaveStop("NextPage",null,true);
  }

  rpc_dsExecuteQuery_result(arg,data)
  {
    if(data.status != 0)
    {
      Warning.show({text:data.msg?data.msg:data.message});
      return;
    }
    var ac = data.result;
    for(let kk = 0;kk<ac.length;kk++)
    {
      let dsItem = ac[kk];
      for(let key in dsItem)
      {
        // for(let i in this.dataSetQueryTable.allQueryFields){
        //   if((this.dataSetQueryTable.allQueryFields[i].fieldAliasName && this.dataSetQueryTable.allQueryFields[i].fieldAliasName == key)
        //   ||StringUtil.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[i].fieldName) == key){
        //     dsItem[this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName] = dsItem[key];
        //     delete dsItem[key];
        //   }
        // }
        dsItem[this.groupAlias+"."+StringUtil.convertToFirstLowerCase(key)] = dsItem[key];
        delete dsItem[key];

      }

    }
    if(this.currentQuery.direction=="Last")
    {
      if(ac)
      {
        ac = ac.reverse();
      }
    }
    let type = arg.type;let onlyFetch = false;let tasks = null;
    var record;
    var mainAlias;var length;var i;var _recId;
    
    if(type=="FetchAll")
    {
      this.records = ac;
      this.resetMapRecId();
      this.currentQuery.toEnd = true;
    }
    else
    {
      if(this.currentQuery.needRefresh==true)
      {
        this.records = ac;
        this.resetMapRecId();
        if(!ac || ac.length<this.dataPageSize)
        {
          this.currentQuery.toEnd = true;
        }
      }
      else
      {
        if(this.currentQuery.direction=="First")
        {
          if(ac)
          {
            /*mainAlias = this.groupAlias;
            length = ac.length;
            for (i=0; i<length; i++)
            {
              record = ac[i];
              _recId = record[mainAlias+".recId"];
              if(this.mapRecId.hasOwnProperty(_recId))
              {
                this.replaceRecord(record);
              }
              else
              {
                this.records.push(record);
              }
              this.mapRecId[_recId] = record;
              this.recordsBak[_recId] = Object.assign({},record);
            }*/
            if(type == "NextPage")
              this.records.push.apply(this.records,ac);
            //else
             // alert("暂不支持该种查询");
          }
          
          if(!ac || ac.length<this.dataPageSize)
          {
            this.currentQuery.toEnd = true;
          }
        }
        else if(this.currentQuery.direction=="Last")
        {
          if(ac)
          {
            mainAlias = this.groupAlias;
            length = ac.length;
            for (i=length-1; i>=0; i--)
            {
              record = ac[i];
              _recId = record[mainAlias+".recId"];
              if(this.mapRecId.hasOwnProperty(_recId))
              {
                this.replaceRecord(record);
              }
              else
              {
                this.records.unshift(record);
              }
              this.mapRecId[_recId] = record;
              this.recordsBak[_recId] = Object.assign({},record);
            }
            
          }
          
          if(!ac || ac.length<this.dataPageSize)
          {
            this.currentQuery.toEnd = true;
          }
        }
      }
    }
    let hasSelectedRecords = false;
   
    RecordsActions.recordsCmp(this.records,this.groupAlias,this,hasSelectedRecords);
      
    if(!hasSelectedRecords)
    {
      if(this.currentQuery.needRefresh==true)
      {
        var _needFocus = false;
        if(this.isGlobalForehandGroup())
          _needFocus = true;
        
        if(this.currentQuery.direction=="First")
          this.local_recordFirst(_needFocus);
        else
          this.local_recordLast(_needFocus);
      }
      else
      {
        if(onlyFetch==false)
        {
          if(this.currentQuery.direction=="First")
          {
            if(type=="First")
            {
              this.local_recordFirst();
            }
            else if(type=="Next")
            {
              this.local_recordNext();  
            }
            else if(type=="NextPage")
            {
              this.local_recordNextPage();
            }
            else if(type=="Last" || type=="Prev" || type=="PrevPage")
            {
              throw new Error("direction First not support type rpc Last/Prev/PrevPage");
            }
            
          }
          else
          {
            if(type=="Last")
            {
              this.local_recordLast();
            }
            else if(type=="Prev")
            {
              this.local_recordPrev();
            }
            else if(type=="PrevPage")
            {
              this.local_recordPrevPage();
            }
            else if(type=="First" || type=="Next" || type=="NextPage")
            {
              throw new Error("direction Last not support type rpc First/Next/NextPage");
            }
            
            
          }
        }
        else
        {
          if(type=="PrevPage")
          {
            alert(type);
          }
        }
      }
    }
     
    //alert("设置needRefresh");
    if(this.currentQuery.needRefresh==true)
      this.currentQuery.needRefresh = false;
    this.after_rpc_result_executeQuery(onlyFetch,tasks);
  }

  rpc_result_executeQuery(data,type,onlyFetch,tasks)
  {
      this.aggreateTableFields = [];this.aggreateDimTableFiels = [];
      var result = data.result;
      var userInfos = window.parent.window.userInfos;
      //万能视图
      if(!userInfos)userInfos = {daoMaxListSize:6000};
      
      if(result.recordCounts>=userInfos.daoMaxListSize)
      {
        Warning.show({text:"本次记录获取条数已达管理员设置的上限"+userInfos.daoMaxListSize+"条，请与管理员联系"});
      }

      if(result.maxCounts!=-1)
      {
        this.currentQuery.lastIndex = result.maxCounts;
      }
      
      //RecordsUtil.getOneLevelDatas(result,this.groupAlias);
      this.formatFormDataSourceGroupResult(result);
      var ac = result.dataResult;
      
      //this.dataProvider = ac;
      if(!this.currentQuery.hasOwnProperty("needRefresh"))
        throw new Error("miss @needRefresh");
      this.updateQueryRemove();
      var record;
      var mainAlias;
      var length;
      var i;
      var _recId;
      
      
      if(this.currentQuery.direction=="Last")
      {
        if(ac)
        {
          ac = ac.reverse();
        }
      }
      
      if(type=="FetchAll")
      {
        this.records = ac;
        this.resetMapRecId();
        this.currentQuery.toEnd = true;
      }
      else
      {
        if(this.currentQuery.needRefresh==true)
        {
          this.records = ac;
          this.resetMapRecId();
          if(!ac || ac.length<this.dataPageSize)
          {
            this.currentQuery.toEnd = true;
          }
        }
        else
        {
          if(this.currentQuery.direction=="First")
          {
            if(ac)
            {
              mainAlias = this.groupAlias;
              length = ac.length;
              for (i=0; i<length; i++)
              {
                record = ac[i];
                _recId = record[mainAlias+".recId"];
                if(this.mapRecId.hasOwnProperty(_recId))
                {
                  this.replaceRecord(record);
                }
                else
                {
                  this.records.push(record);
                }
                this.mapRecId[_recId] = record;
                this.recordsBak[_recId] = Object.assign({},record);
              }
            }
            
            if(!ac || ac.length<this.dataPageSize)
            {
              this.currentQuery.toEnd = true;
            }
          }
          else if(this.currentQuery.direction=="Last")
          {
            if(ac)
            {
              mainAlias = this.groupAlias;
              length = ac.length;
              for (i=length-1; i>=0; i--)
              {
                record = ac[i];
                _recId = record[mainAlias+".recId"];
                if(this.mapRecId.hasOwnProperty(_recId))
                {
                  this.replaceRecord(record);
                }
                else
                {
                  this.records.unshift(record);
                }
                this.mapRecId[_recId] = record;
                this.recordsBak[_recId] = Object.assign({},record);
              }
              
            }
            
            if(!ac || ac.length<this.dataPageSize)
            {
              this.currentQuery.toEnd = true;
            }
          }
        
        }
      }
      //let hasSelectedRecords = false;
      /*if(tasks)
      {
        for(let i = 0;i<tasks.length;i++)
        {
          let _task = tasks[i];
          if(_task.cmd == "selectRecords")
          {
            hasSelectedRecords = true;
            break;
          }
        }
      }*/

      RecordsActions.recordsCmp(this.records,this.groupAlias,this,false);
      
      
        if(this.currentQuery.needRefresh==true)
        {
          var _needFocus = false;
          if(this.isGlobalForehandGroup())
            _needFocus = true;
          
          if(this.currentQuery.direction=="First")
            this.local_recordFirst(_needFocus,{activeRecord:true});
          else
            this.local_recordLast(_needFocus,{activeRecord:true});
        }
        else
        {
          if(onlyFetch==false)
          {
            if(this.currentQuery.direction=="First")
            {
              if(type=="First")
              {
                this.local_recordFirst(true,{activeRecord:true});
              }
              else if(type=="Next")
              {
                this.local_recordNext({activeRecord:true});  
              }
              else if(type=="NextPage")
              {
                this.local_recordNextPage({activeRecord:true});
              }
              else if(type=="Last" || type=="Prev" || type=="PrevPage")
              {
                throw new Error("direction First not support type rpc Last/Prev/PrevPage");
              }
              else
              {
                this.local_recordFirst(true,{activeRecord:true});
              }
              
            }
            else
            {
              if(type=="Last")
              {
                this.local_recordLast(true,{activeRecord:true});
              }
              else if(type=="Prev")
              {
                this.local_recordPrev({activeRecord:true});
              }
              else if(type=="PrevPage")
              {
                this.local_recordPrevPage({activeRecord:true});
              }
              else if(type=="First" || type=="Next" || type=="NextPage")
              {
                throw new Error("direction Last not support type rpc First/Next/NextPage");
              }
              else
              {
                this.local_recordFirst(true,{activeRecord:true});
              }
              
            }
          }
          else
          {
            if(type=="PrevPage")
            {
              alert(type);
            }
          }
        }
      
     
      //alert("设置needRefresh");
      if(this.currentQuery.needRefresh==true)
        this.currentQuery.needRefresh = false;
      this.after_rpc_result_executeQuery(onlyFetch,tasks,result);
  }

  after_rpc_result_executeQuery(onlyFetch,tasks,result)
  {
    //升序向上 降序向下
    // this.groupAlias this.currentQuery
    //解析currentQuery数据结构 A字段要asc B字段要desc {A:asc,B:desc}
    //通知到所有GongqiHeaderCell

    var arg={};
    var itemArray=[];
    //itemArray=
    if(window.isDataSetView && !this.forLookup ){
      for(let j = 0;j<this.dataSetQueryTable.queryOrderBy.length;j++){
        if(this.dataSetQueryTable.aliasName.indexOf("_") != -1){
          let key = this.dataSetQueryTable.aliasName.substring(this.dataSetQueryTable.aliasName.lastIndexOf("_")+1).toLowerCase()+"."+this.dataSetQueryTable.queryOrderBy[j].fieldName.toLowerCase();
          arg[key] = this.dataSetQueryTable.queryOrderBy[j].orderBy;
        }else{
          arg[this.dataSetQueryTable.aliasName.toLowerCase()+"."+this.dataSetQueryTable.queryOrderBy[j].fieldName.toLowerCase()] = this.dataSetQueryTable.queryOrderBy[j].orderBy;
        }
      }
    }else{
      QueryUtil.getAllOrderByItems(this.currentQuery.QueryTable,itemArray,false)
      if(itemArray.length>0){
        for(var i=0;i<itemArray.length;i++){
          var item=itemArray[i];
          if(item.hasOwnProperty('sorting')){
            var Field=(item.queryTableAlias+'.'+GOTUtil.getPropertyValue(item,'Field')).toLowerCase();
            var OrderBy=GOTUtil.getPropertyValue(item,'OrderBy');
            arg[Field]=OrderBy;
          }
        }
        if(!arg[Field]){
          var Field=(itemArray[0].queryTableAlias+'.'+GOTUtil.getPropertyValue(itemArray[0],'Field')).toLowerCase();
          var OrderBy=GOTUtil.getPropertyValue(itemArray[0],'OrderBy');
          arg[Field]=OrderBy;
        }
      }
    }
    QueryActions.updateSortDirection(this.groupAlias,arg);
    UtilActions.updateFetchAllIcon(this.groupAlias,this.currentQuery.toEnd,this.formDataSources.formModule.instanceUUId);
    if(!tasks)tasks = [];
    if(result && result.commandResult && result.commandResult.tasks)
    {
      tasks = result.commandResult.tasks.concat(tasks);
    }
    if(tasks)
    {
      let task = tasks.shift();
      if(task)
        CommandResolver.doResolveTask(task,this.formDataSources.formModule,tasks);
    }
    // pivot 分析 获取数据集数据
    if(this.records){
      window.parent.window.osDataSetViewRecords = this.records;
    }

    let strac =  JSON.stringify(this.records);
    let jsonac = JSON.parse(strac);
    if(window.isDataSetView){
      for(let kk = 0;kk<jsonac.length;kk++)
      {
        let dsItem = jsonac[kk];
        for(let k in dsItem)
        {
          for(let i in this.dataSetQueryTable.allQueryFields){
            if((this.dataSetQueryTable.allQueryFields[i].fieldAliasName && this.groupAlias+"."+this.dataSetQueryTable.allQueryFields[i].fieldAliasName == k)
            ||(this.groupAlias+"."+StringUtil.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[i].fieldName)) == k){
              dsItem[this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName] = dsItem[k];
              if(this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.indexOf(this.groupAlias) == -1){
                delete dsItem[k];
              }
            }
          }  
        }
      }
    }
    if(window.parent.window.dataSetPreviewFordataset ||window.parent.window.dataSet){
      if(window.parent.window.dataSetPreviewFordataset){
        window.parent.window.dataSetPreviewDataSet = DataSetUtil.strDataSet(window.parent.window.dataSetPreviewFordataset,jsonac);
      }
      if(window.parent.window.dataSet){
        window.parent.window.dataSetPreviewDataSet = DataSetUtil.strDataSet(window.parent.window.dataSet,jsonac)
      }
    }
  }
	 
  //10000多条数据 多层转换成单层结构 耗时1.5秒 在现代浏览器中 +操作符最快
	rpcExecuteQuery(formDataSourceGroupResult)
	{
    
		var finalDatas = RecordsUtil.getOneLevelDatas(formDataSourceGroupResult,this.groupAlias);
    //alert("数据转换耗时"+(new Date().getTime()-now));
    this.records = finalDatas;
		RecordsActions.recordsCmp(finalDatas,this.groupAlias,this);
    var initCurrentRecord = finalDatas.length>0?finalDatas[0]:null;
    this.setCurrentRecord(initCurrentRecord);
	}

  initCurrentQuery()
  {
    var formQueryCopy = JSON.parse(JSON.stringify(this.formQuery));
    this.reSetCurrentQuery(formQueryCopy);
  }

  reSetCurrentQuery(xml = null)
  {
    if(window.isDataSetView && !this.forLookup)
    {
      this.reSetDataSetExecuteQuery(xml,this.dataSetQueryTable);
    }
    if(xml != null)
    {
      this.currentQuery = xml;
    }
    else
    {
      if(this.formQuery==null)
        this.formQuery = JSON.parse(JSON.stringify(this.baseQuery));
      
      this.currentQuery = JSON.parse(JSON.stringify(this.formQuery));
    }

    this.currentQuery.direction = this.startPosition;
    if(this.mainSource.isTempTable)
      this.currentQuery.toEnd = true;
    else
      this.currentQuery.toEnd = false;
    
    this.currentQuery.needRefresh = true;
    
    if(this.currentQuery.hasOwnProperty("lastIndex"))
    {
      delete this.currentQuery.lastIndex;
    }
  }
  reSetDataSetExecuteQuery(xml,query){
    // if(!query)return;
    // for(let i in query.queryWhere){
    //   query.queryWhere.splice(0,query.queryWhere.length)
    // }
    // if(query.queryJoins.length>0){
    //   for(let h in query.queryJoins){
    //     this.reSetDataSetExecuteQuery(xml,query.queryJoins[h]);
    //   }
    // }
    if(!query)return;
    this.dataSetQueryTable =JSON.parse(this.initDataSetQueryTable);
  }

  reSetDataSetExecuteSort(xml,query){
    // if(!query)return;
    // this.dataSetQueryTable = JSON.parse(this.initDataSetQueryTable);
    if(!query)return;
    for(let i in query.queryOrderBy){
      query.queryOrderBy.splice(0,query.queryOrderBy.length)
    }
    if(query.queryJoins.length>0){
      for(let h in query.queryJoins){
        this.reSetDataSetExecuteSort(xml,query.queryJoins[h]);
      }
    }
  }

  reSetDataSetQuery(xml,query){
    if(!query)return;
    this.dataSetQueryTable = JSON.parse(this.initDataSetQueryTable);
    // for(let i in query.queryWhere){
    //   query.queryWhere.splice(0,query.queryWhere.length)
    // }
    // if(query.queryJoins.length>0){
    //   for(let h in query.queryJoins){
    //     this.reSetDataSetExecuteQuery(xml,query.queryJoins[h]);
    //   }
    // }
    // for(let j in query.queryOrderBy){
    //   query.queryOrderBy.splice(0,query.queryOrderBy.length)
    // }
  }

  initFormQuery()
  {
    var key = this.formDataSources.formModule.props.formId + "_" + this.mainSource.id + "." + (this.forLookup?"FormLookup":window.menuItemId);
    //alert(key + this.forLookup);
    var obj = QueryUtil.getQueryList(key);
    if(obj)
    {
      this.formQuery = typeof(obj)=="string"?JSON.parse(obj):obj;//JSON.stringify(obj));
      this.fromDefaultSavedQuery = true;
    }
    else
    {
      this.formQuery = JSON.parse(JSON.stringify(this.baseQuery));
    }
    
    var topQT = this.formQuery.QueryTable;
    topQT.tempTable = this.mainSource.isTempTable;
    var autoJoinParent = true;
    if(!this.forLookup)
    {
      if(this.linkGroup && window.argCaller)
      {
        var autoJoinParentArg = window.argCaller.autoJoinParentArg;
        if(autoJoinParentArg && this.linkGroup.groupAlias == autoJoinParentArg.autoJoinParentAlias)
          autoJoinParent = autoJoinParentArg.autoJoinParent;
      }
    }
    if(this.linkGroup && autoJoinParent)
    {
      var joinQueryTable = {name:"A_QueryTable",id:"1",Properties:{Table:{V:""},Alias:{V:""},UserUpdate:{V:true},Output:{V:true},Status:{V:"Open"}},
                            QueryRelation:{Properties:{Auto:{V:false},JoinMode:{V:"None"},Relation1N:{V:"ManyToOne"}},Items:[]},
                            QueryFields:{Properties:{Auto:{V:true}},Fields:[]},QueryGroupBy:{name:"GroupBy"},QueryOrderBy:{name:"OrderBy",Items:[]},
                            QueryWhere:{name:"Where",Items:[]},QueryAggregations:{name:"Aggregations",Items:[]},QueryJoins:{name:"Joins",Items:[]}};    
      topQT.QueryJoins.Items.push(joinQueryTable);
      joinQueryTable.name = "Auto_JoinParent";
      var nextInnerId = this.formQuery.nextInnerId;
      joinQueryTable.id = nextInnerId;
      joinQueryTable.tempTable = this.linkGroup.mainSource.isTempTable;
      nextInnerId ++ ;
      this.formQuery.nextInnerId = nextInnerId;
      var pTable = joinQueryTable.Properties.Table;
      pTable.refentityid = this.linkGroup.mainSource.tableId;
      pTable.V = this.linkGroup.mainSource.tableName;
      joinQueryTable.Properties.Alias.V = "Auto_JoinParent";
      joinQueryTable.Properties.Output.V = "false";
      var parentWindow = window.parent.window;
      if(parentWindow.serverDebug)
        joinQueryTable.Properties.Status.V = "Lock";
      else
        joinQueryTable.Properties.Status.V = "Hide";
      
      var queryRelation = joinQueryTable.QueryRelation;
      queryRelation.Properties.JoinMode.V = "ExistJoin";
      queryRelation.Properties.Relation1N.V = "ManyToOne";
     
      var relationItems  = this.mainSource.xml.FormDataSourceRelation;
      if(relationItems.length>0)
      {
        for(let i = 0;i<relationItems.length;i++)
        {
          var relationItem = relationItems[i];

          var rtemp = {
              name:"A_QueryRelationItem",id:"2",
              Properties:{
                Field:{V:""},ParentField:{V:""},FieldValue:{V:""},RelatedValue:{V:""}
              }
          }

          rtemp.id = relationItem.id;
          QueryUtil.setQueryRelationByFormRelation(rtemp, relationItem, this.mainSource.xml);
          queryRelation.Items.push(rtemp);

          if(rtemp.Properties.Field.V != "" && rtemp.Properties.ParentField.V != "")
          {
            var rtemp2 = JSON.parse(JSON.stringify(rtemp));
            
            var sDataField;
            var pFieldForDataField = rtemp2.Properties.Field;
            sDataField = pFieldForDataField.V;
            sDataField = sDataField.substr(0,1).toLowerCase() + sDataField.substring(1);
            rtemp2.dataField = sDataField;
            
            var pField = rtemp2.Properties.ParentField;
            pField.V = "";
            delete pField.refentityid;
            delete pField.refinnerid;
            
            queryRelation.Items.push(rtemp2);
          }
        }
      }
      else  //auto relation 
      {
        //by  current table   join table
        //
        // A Delayed join B A即this上的relationItems必定存在
        this.formQuery = QueryUtil.consQueryByQuery(this.formQuery);
        //throw new Error("FormDataSource无FormDataSourceRelationItem");
      }
    
      this.updateFormQueryByLinkGroup(this.linkGroup.currentRecord, this.linkGroup.mainSource.alias);
      
    }
  }

  updateFormQueryByLinkGroup(_linkRecord, _linkAlias)
  {
    
    var joinQueryTable = GOTUtil.getQueryTableByName(this.formQuery,"Auto_JoinParent");
    if(joinQueryTable!=null)
    {
      
      var list = GOTUtil.getQueryRelationItemByProperty(joinQueryTable.QueryRelation,"dataField");
      for(let i = 0;i<list.length;i++)
      {
        let item = list[i];
        if(_linkRecord==null)
        {
          item.Properties.FieldValue.V = "#null#";
        }
        else
        {
          var s = _linkRecord[_linkAlias+"."+item.dataField];
          //TODO 如果是数字的 则认为肯定不是空
          if(typeof(s)=="number" || s!="")
            item.Properties.FieldValue.V = s;
          else
            item.Properties.FieldValue.V = "#null#";
        }
      }
    }
  }
  //如果传入record 如果是当前group 则以传入record为准 否则以指定的group为准
  anyRecordValue(field,value = null ,record = null)
  {
    var index = 0;
    var group = this;
    while(field.charAt(index) == ".")
    {
      if(index == 0)
      {
        index ++ ;
        continue;
      }
      group = group.linkGroup;
      if(!group)
        return value;
      record = group.currentRecord;
      index ++;
    }
    if(!record)
      record = group.currentRecord;
    if(!record)
      return null;
    field = field.substr(index);
    if(field.indexOf(".") != -1)
    {
      field = StringUtil.convertToEachFirstLowerCase(field.substr(index));
      field = StringUtil.convertToFirstUpperCase(field);
    }
    else
    {
      field = group.groupAlias + "." + StringUtil.convertToFirstLowerCase(field);
    }
    
    return record[field];
  }

  lockedRecNew = false;
  lockedFieldFalsed = false;
    
  setAliasList(list, queryTable)
  {
    if(GOTUtil.getPropertyValue(queryTable, "Output")==true)
    {
      list.push(queryTable.name);
      for(var i=0;i<queryTable.QueryJoins.length;i++)
      {
        var qt = queryTable.QueryJoins[i];
        this.setAliasList(list, qt);
      }
    }
  }
  
  getEmptyValueByFieldType(fieldType)
  {
    if(fieldType=="String")
    {
      return "";
    }
    else if(fieldType=="Long")
    {
      return 0;
    }
    else if(fieldType=="Decimal")
    {
      return 0.00;
    }
    else if(fieldType=="Date" || fieldType == "DateTime")
    {
      return "";
    }
    else if(fieldType=="Time")
    {
      return "00:00:00";
    }
    else if(fieldType=="Boolean")
    {
      return false;
    }
    else if(fieldType=="Enum")
    {
      return 0;
    }
    else
    {
      throw new Error("fieldType undefined");
    }
  } 

  initAliasList()
  {
    this.aliasList = [];
    this.setAliasList(this.aliasList, this.baseQuery.QueryTable);
    
    this.aliasListEmptyObject = {};
    
    for(let i=0;i<this.aliasList.length;i++)
    {
      var aliasName = this.aliasList[i];
      for(let k=0;k<this.sources.length;k++)
      {
        var fds = this.sources[k];
        if(fds.alias==aliasName)
        {
          var obj = {};
          this.aliasListEmptyObject[aliasName] = obj;
          var fields = fds.xml.FormDataSourceFields;
          var tmpComponentName;var tmpComponent;
          for(var j=0;j<fields.length;j++)
          {
            var field = fields[j];
            var fieldType = field.type;
            var fieldName = StringUtil.convertToFirstLowerCase(field.name);
            if(fieldName.indexOf(".")!=-1)
            {
              var _arr = fieldName.split(".");
              var cName = _arr[0];
              var fName = StringUtil.convertToFirstLowerCase(_arr[1]);
              if(tmpComponentName!=cName)
              {
                tmpComponentName = cName;
                tmpComponent = {};
                obj[tmpComponentName] = tmpComponent;
              }
              
              tmpComponent[fName] = this.getEmptyValueByFieldType(fieldType);
              
            }
            else
            {
              if(fieldType=="Component")
              {
                //什么都不做
              }
              else
              {
                obj[fieldName] = this.getEmptyValueByFieldType(fieldType); 
              }
            }
            
          }
          
        }
      }
    }
  }

  isCurrentRecordLocked(record = null)
  {  
    return false;   
    this.lockedRecNew = false;
    if(this.lockedFieldFalsed)
      return false;
    
    if(record == null)
      record = this.currentRecord;

    var lockFieldValue = this.mainSource.xml.Properties.LockField?this.mainSource.xml.Properties.LockField.Value:"";
    if(lockFieldValue == "")
      return false;
    var lockField = StringUtil.trimThrough(lockFieldValue);
    var conA;var field;var value;var recordValue;var lockNew = false;var result = false;
    
    try
    {
      if(lockField.charAt(0) == "(")
      {
        var num = lockField.charAt(1);
        if(num == "2")
        {
          lockNew = true;
        }
        
        lockField = lockField.substr(3);
      }
      
      var _arr = lockField.split("|");
      for(var i = 0;i<_arr.length;i++)
      {
        var con = _arr[i];
        if(con.indexOf("&gt;=") != -1)
        {
          conA = con.split("&gt;=");
          field = conA[0];
          if(field.charAt(0) != "." && record == null)
            continue;
          var isParent = field.charAt(0) == ".";
          value = conA[1];
          recordValue = this.anyRecordValue(field,value,record);
          if((recordValue!=undefined&&recordValue!=null) && recordValue >= value)
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
          else if((recordValue==undefined||recordValue==null) && isParent)
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
        }
        else if(con.indexOf("&lt;=") != -1)
        {
          conA = con.split("&lt;=");
          field = conA[0];
          if(field.charAt(0) != "." && !record)
            continue;
          isParent = field.charAt(0) == ".";
          value = conA[1];
          recordValue = this.anyRecordValue(field,value,record);
          if((recordValue != null && recordValue != undefined) && recordValue <= value)
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
          else if((recordValue == undefined || recordValue == null) && isParent)
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
        }
        else if(con.indexOf("=") != -1)
        {
          conA = con.split("=");
          field = conA[0];
          if(field.charAt(0) != "." && !record)
            continue;
          isParent = field.charAt(0) == ".";
          value = conA[1];
          recordValue = this.anyRecordValue(field,value,record);
          if(
            (recordValue!=undefined&&record!=null) && 
            (
              recordValue == value
              || ((recordValue == true || recordValue == "1") && (value == "true" || value == "1"))
              || ((recordValue == false || recordValue == "0") && (value == "false" || value == "0"))
            )
          )
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
          else if((recordValue == null || recordValue == undefined) && isParent)
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
          
        }
        else if(con.indexOf("&lt;&gt;") != -1)
        {
          conA = con.split("&lt;&gt;");
          field = conA[0];
          if(field.charAt(0) != "." && record == null)
            continue;
          isParent = field.charAt(0) == ".";
          value = conA[1];
          recordValue = this.anyRecordValue(field,value,record);
          if(recordValue != null && recordValue!=undefined && recordValue != value)
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
          else if((recordValue == null || recordValue == undefined) && isParent)
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
        }
        else if(con.indexOf("&gt;") != -1)
        {
          conA = con.split("&gt;");
          field = conA[0];
          if(field.charAt(0) != "." && record == null)
            continue;
          isParent = field.charAt(0) == ".";
          value = conA[1];
          recordValue = this.anyRecordValue(field,value,record);
          if((recordValue!=undefined&&recordValue!=null) && recordValue > value)
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
          else if((recordValue==undefined&&recordValue==null) && isParent)
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
          
        }
        else if(con.indexOf("&lt;") != -1)
        {
          conA = con.split("&lt;");
          field = conA[0];
          if(field.charAt(0) != "." && record == null)
            continue;
          isParent = field.charAt(0) == ".";
          value = conA[1];
          recordValue = this.anyRecordValue(field,value,record);
          if((recordValue!=undefined&&recordValue!=null) && recordValue < value)
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
          else if((recordValue!=undefined&&recordValue!=null) && isParent)
          {
            result = true;
            if(lockNew)
              this.lockedRecNew = true;
            break;
          }
        }
              
      }
      
   }catch(e)
    {
     Warning.show({text:this.mainSource.alias + ":填写正确的LockedField"});
     lockedFieldFalsed = true;
   }
    
    return result;
  }

  formatFormDataSourceGroupResult(result,from)
  {
    //行列转置 - 此处判断有无动态列 有动态列则通知DataGrid 并把参数传过去 更改column 
    let dynamicColumnFieldName;
    if(from == "save" || from == "modified" || from=="refresh")
    {
      if(this.dynamicColumnsPre)
      {
        result.dynamicColumns = this.dynamicColumnsPre;
        if((from == "modified" || from=="refresh") && result.dataResult && this.currentRecord)
        {
          for(let dynamicSource in result.dynamicColumns)
          {
            let dynamicSourceObj = result.dynamicColumns[dynamicSource];
            for(let i = 0;i<result.dataResult.length;i++)
            {
              let record = result.dataResult[i];
              var record2  = record[dynamicSource];
              if(typeof(record2) == "undefined" || record2 == undefined)
              {
                record2 = record;
              }
              if(record2)
              {
                //let dynamicArr = dynamicSourceObj["Sources"];
                for(let secondKey in dynamicSourceObj)
                {
                  let dynamicArr = dynamicSourceObj[secondKey];
                  for(let k = 0;k<dynamicArr.length;k++)
                  {
                    let dynamicObj = dynamicArr[k];
                    let recordKey = dynamicSource+"."+dynamicObj.dataKey;
                    if(this.currentRecord[this.groupAlias+".recId"] ==record2["recId"] ){
                      record2[dynamicObj.dataKey] = this.currentRecord[recordKey];
                    }
                  }
                }
            
              }
            }
          }
        }
      }
    }
    if(result.dynamicColumns)
    {
      let isEmpty = true;
      for(let key in result.dynamicColumns)
      {
        isEmpty = false;
        let singleColumn = result.dynamicColumns[key];
        for(let key2 in singleColumn)
        {
          dynamicColumnFieldName = key2;
          UtilActions.dynamicColumns({key:key,origColumn:key2,dynamicColumns:singleColumn[key2]});
        }
      }
      if(isEmpty == false)
        this.dynamicColumnsPre = result.dynamicColumns;
    }
    //标准格式 result.result -->ArrayCollection [index][aliasName.fieldName]
    
    //flag_validateFieldNameFirstChar = false;
    
    if(!result || !result.dataResult || (Array.isArray(result.dataResult) && result.dataResult.length==0))
      return;
    
    if(result.dataResult && Array.isArray(result.dataResult))
    {
      if(!result.groupAlias)
      {
        var _tmp = result.dataResult;
        if(_tmp.length!=0)
        {
          result.groupAlias = this.groupAlias;
          result.aliasList = [];
          result.aliasList.push(this.mainSource.alias);
        }
        else
        {
          return;
        }
      }
    }
    
    if(!result.aliasList)
    {
      result.dataResult = null;
      return;
    }
    
    var aliasListLength = result.aliasList.length;
    if(result.recordCounts<=0 || aliasListLength<=0)
    {
      result.dataResult = null;
      return;
    }
    
    var type; //0 Array   1 Object      
    if(Array.isArray(result.dataResult))
    {
      type = 0;
      var resultAC = result.dataResult;
    }
    else
    {
      type = 1;
      var resultObject = result.dataResult;
      
    }
    
    var ac;var fieldName;var groupObject;var aliasObject;var index;var strAlias;
    
    
    //if(aliasListLength==0 && result.recordCounts>0) //这种是新增的，对应于后台不指定groupAlias，直接传List<Map<String,Object>>的情况。 事实上只用于lookup_方法的返回，以后要考虑是否从FormDataSourceGroup中拆出来
    //{
    //  
    //}
    //上面这种为新增的
    //由于至少存在RecId RecVersion，所以不可能只有(一条记录、一个alias、一个字段)，所以只要下面三种情况即可
    //else
    if(aliasListLength==1 && result.recordCounts==1)
    {
      //[fieldName]
      //[0][fieldName]
      ac = [];
      
      if(type==0)
      {
        groupObject = this.formatSingleRecord(result.groupAlias, resultAC[0],dynamicColumnFieldName);
      }
      else
      {
        if(!resultObject.hasOwnProperty("recId"))
          resultObject = resultObject[this.groupAlias];
        
        groupObject = this.formatSingleRecord(result.groupAlias, resultObject,dynamicColumnFieldName);
      }
      
      this.fillEmptyObject(groupObject);
      
      ac.push(groupObject);
      result.dataResult = ac;
    }
    else if(aliasListLength==1 && result.recordCounts>1)
    {
      //[index][fieldName]
      ac = [];
      
      for(index=0; index<result.recordCounts; index++)
      {
        groupObject = {};
        if(type==0)
        {
          groupObject = this.formatSingleRecord(result.groupAlias, resultAC[index],dynamicColumnFieldName);
        }
        else
        {
          groupObject = this.formatSingleRecord(result.groupAlias, resultObject[index],dynamicColumnFieldName);
        }
        
        this.fillEmptyObject(groupObject);
        
        ac.push(groupObject);
      }
      result.dataResult = ac;
    }
    else if(aliasListLength>1 && result.recordCounts==1)
    {
      ac = [];
      groupObject = {};
      if(type==0)
      {
        for(index=0; index<aliasListLength; index++)
        {
          strAlias = result.aliasList[index];
          
          var tmp = resultAC[0][index];
          if(!tmp)
            tmp = resultAC[0][strAlias];
          
          let _newRecord = this.formatSingleRecord(strAlias, tmp,dynamicColumnFieldName);
          this.copyRecord(_newRecord,groupObject)
        }
        
      }
      else
      {
        for(index=0; index<aliasListLength; index++)
        {
          strAlias = result.aliasList[index];
          if(resultObject.hasOwnProperty(0))
          {
            tmp = resultObject[0][index];
            if(tmp==null)
              tmp = resultObject[0][strAlias];
          }
          else
          {
            tmp = resultObject[index];
            if(tmp==null)
              tmp = resultObject[strAlias];
          }
          
          let _newRecord = this.formatSingleRecord(strAlias, tmp,dynamicColumnFieldName);
          this.copyRecord(_newRecord,groupObject);
        }
        
      }
      
      this.fillEmptyObject(groupObject);
      
      ac.push(groupObject);
      
      result.dataResult = ac;
    }
    else if(aliasListLength>1 && result.recordCounts>1)
    {
      ac = [];
      
      for(let indexOut=0; indexOut<result.recordCounts; indexOut++)
      {
        groupObject = {};
        if(type==0)
        {
          for(index=0; index<aliasListLength; index++)
          {
            strAlias = result.aliasList[index];
            
            tmp = resultAC[indexOut][index];
            if(tmp==null)
              tmp = resultAC[indexOut][strAlias];
            let _newRecord = this.formatSingleRecord(strAlias, tmp, dynamicColumnFieldName);
            this.copyRecord(_newRecord,groupObject);
          }
          
        }
        else
        {
          for(index=0; index<aliasListLength; index++)
          {
            strAlias = result.aliasList[index];
            
            tmp = resultObject[indexOut][index];
            if(tmp==null)
              tmp = resultObject[indexOut][strAlias];
            let _newRecord = this.formatSingleRecord(strAlias, tmp, dynamicColumnFieldName);
            this.copyRecord(_newRecord,groupObject);
          }
          
        }
        
        this.fillEmptyObject(groupObject);
        ac.push(groupObject);
      }
      result.dataResult = ac;
    }
  }

  getFieldNameNew(fieldName)
  {
    var _fieldNameNew;
    var firstChar = fieldName.charCodeAt(0);
    if(firstChar>=65 && firstChar<=90)  // A..Z
    {
      _fieldNameNew = String.fromCharCode(firstChar+32) + fieldName.substring(1);
    }
    else
    {
      _fieldNameNew = fieldName;
    }
    return _fieldNameNew;
  }

  fixFieldNameFirstChar(record)
  {
    for(var key in record)
    {
      var firstChar = key.charCodeAt(0);
      if(firstChar>=65 && firstChar<=90)  // A..Z
      {
        record[this.getFieldNameNew(key)] = record[key];
        delete record[key];        
      }
    }
    
  }

  addRecordTempDataMethodField(record,alias)
  {
    var tempDataMethodField = this.getTempDataMethodField();
    var value = "";
    var _recId = record["recId"];
    for(let key in this.tempDataMethodField)
    {
      let _field = tempDataMethodField[key];
      let index = _field.indexOf(".");
      let datasource = _field.substring(0,index);
      if(datasource == alias)
      {
          let subfield = _field.substr(index+1);
          if(record.hasOwnProperty(subfield) && record[subfield] != null)
            continue;
          if(this.mapRecId.hasOwnProperty(_recId))
          {
            var orgObj = this.mapRecId[_recId];
            value = orgObj[datasource+"."+subfield];   
          }
          else
          {
            var type = this.tempDataMethodFieldType[key];
            if(type=="LongEditor")
              value = 0;
            else if(type=="DecimalEditor")
            {
              let controlKey = "ctrl_"+StringUtil.convertToFirstUpperCase(subfield);
              let controls = FormItemUtil.formItemControls;
              let control = controls[controlKey];
              let numDecimals = control.getProperty_NumOfDecimals();
              value = numDecimals>0?"0.":"0";
              for(let i = 0;i<numDecimals;i++)
              {
                value+="0";
              }
              
              //value =  "0.00";
            }
            else if(type=="TimeEditor")
              value = "00:00:00";
            else if(type=="BooleanEditor")
              value = false;
            else if(type=="EnumEditor")
              value = 0;
            else
              value = "";  
          }
          
          record[subfield] = value;
        }
    }
  }

  formatSingleRecord(_alias, record, dynamicColumnFieldName)
  {
    if(!record)
      return null;
    
    if(!record.hasOwnProperty("recId") || !record.hasOwnProperty("recVersion"))
    {
      if(record.hasOwnProperty(this.groupAlias))
      {
        record = record[this.groupAlias];
      }
      else
      {
        //非标准格式的record，按原样返回 ， TODO 什么时候发生？
        //alert("存在非标准格式的记录:" + record.toString());
        return record;
      }
    }
    
    
    this.fixFieldNameFirstChar(record);
    
    this.addRecordTempDataMethodField(record,_alias);
    
    var fieldName;var fieldValue;var fieldType;var _recordNew = {};var _fieldNameNew;
    
    var _fds
    for(let i in this.sources)
    {
      var tf = this.sources[i];
      if(tf.alias == _alias)
      {
        _fds = tf;
        break;
      }
    }
    if(_fds==null)
    {
      throw new Error("没有找到对应的FormDataSource");
    }
    if(dynamicColumnFieldName && _fds.xml.Properties.PivotSource){
      let pivotSourceEntityid = _fds.xml.Properties.PivotAggregateColumn.refentityid;
      let pivotSourceName =  _fds.xml.Properties.PivotSource.Value;
      for(let i in this.sources)
      {
        var tf = this.sources[i];
        if(tf.alias == pivotSourceName || tf.tableId == pivotSourceEntityid)
        {
          _fds = tf;
          break;
        }
      }
    }
    
    if(_fds.isTempTable==true)
    {
      //new
      if(record["recId"] == -1)
      {
        record["recId"] = tmpRecId++;
        record["recVersion"] = 0;
      }
    }
    
    for(fieldName in record)
    {
      _fieldNameNew = this.getFieldNameNew(fieldName);
      
      fieldType = _fds.fieldType[_fieldNameNew];
      if(!fieldType)
      {
        if(dynamicColumnFieldName && _fieldNameNew.indexOf('alias_') !=-1)
        {
          fieldType = _fds.fieldType[StringUtil.convertToFirstLowerCase(dynamicColumnFieldName)];
        }
        if(!fieldType)//插件内部节点带点 
        {
          fieldType = _fds.fieldType[StringUtil.convertToEachFirstLowerCase(_fieldNameNew)];
        }
      }
      if(dynamicColumnFieldName && !fieldType){
        for(let i in this.sources)
        {
          var tf = this.sources[i];
          if(tf.alias == _alias)
          {
            _fds = tf;
            break;
          }
        }
        fieldType = _fds.fieldType[_fieldNameNew];
        if(!fieldType)
        {
          if(_fieldNameNew)
          {
            fieldType = _fds.fieldType[StringUtil.convertToFirstLowerCase(_fieldNameNew)];
          }
          if(!fieldType)//插件内部节点带点 
          {
            fieldType = _fds.fieldType[StringUtil.convertToEachFirstLowerCase(_fieldNameNew)];
          }
        }
      }

      if(!fieldType)
        continue;
        
      fieldValue = record[fieldName];
      
      if(fieldType=="Long" || fieldType=="Decimal")
      {
        if(dynamicColumnFieldName && (fieldValue == null||fieldValue == ""))
          fieldValue = "";
        //TODO处理数字长度
         if(fieldType == "Decimal")
         {
            let _decimalValue = fieldValue+"";
            if(!_decimalValue)_decimalValue = "0";
            let numDecimals = _fds.fieldNumOfDecimals[_fieldNameNew];
            if(!numDecimals)numDecimals = 2;
            let indexdot = _decimalValue.indexOf(".");
            if(indexdot == -1)
            {
              _decimalValue+=".";
              for(let i = 0;i<numDecimals;i++)
              {
                _decimalValue+="0";
              }
            }
            else
            {
              let nowDecimalNum = _decimalValue.length-(indexdot+1);
              if(nowDecimalNum < numDecimals)
              {
                for(let i = 0;i<(numDecimals-nowDecimalNum);i++)
                {
                  _decimalValue+="0";
                }
              }
            }
            
            if(numDecimals == "0")
              _decimalValue = _decimalValue.substr(0,_decimalValue.length-1);
            
            _recordNew[_alias+"."+_fieldNameNew] = _decimalValue;
         } 
         else
         {
            _recordNew[_alias+"."+_fieldNameNew] = fieldValue; 
         }
      }
      else if(fieldType == "Component")
      {
        var _oNameNew;var fieldValueNew = {};
        for(var oName in fieldValue)
        {
          if(oName == "class")
            continue;
          _oNameNew = this.getFieldNameNew(oName);
          
          var oValue = fieldValue[oName];
          
          if(!oValue)
          {
            oValue = "";
          }

          _recordNew[_alias+"."+_fieldNameNew+"."+_oNameNew] = oValue;
        }
      }
      /*else if(fieldType=='Date'&&fieldValue=='1970-01-01'){
        fieldValue='';
        _recordNew[_alias+"."+_fieldNameNew] = fieldValue;
      }*/
        
      else
      {
        _recordNew[_alias+"."+_fieldNameNew] = fieldValue;
      }
    }
    
    if(this.mainSource.isAggreateTable == true)
    {
      if(this.aggreateTableFields.length==0)
      {
        for(var key in _recordNew)
        {
          if(key.indexOf(".")==-1)
          {
            this.aggreateTableFields.push(key);
          }
          else
          {
            var tfarray = key.split(".");
            this.aggreateTableFields.push(tfarray[1]);
            if(tfarray.length == 3)
            {
              this.aggreateDimTableFiels.push(tfarray[2]);
            }
            
            
          }
        }
      }
      this.completeRecordField(_recordNew,_fds,_alias);
    }

    return _recordNew;
  }

  completeRecordField(record,source,_alias)
  {
    var sourcexml = source.xml;
    var formdatasourcefields = sourcexml.FormDataSourceFields;
    
    for(let i in formdatasourcefields)
    {
      var sourcefield = formdatasourcefields[i];
      var key2 = StringUtil.convertToEachFirstLowerCase(sourcefield.name);
      var type = sourcefield.type;
      key2 = _alias+"."+key2;
      if(!record.hasOwnProperty(key2))
      {
        if(type == GongqiDataType.TypeComponentLabel)
        {
          record[key2] = {};
        }
        else
        {
          var finalvalue = null;
          if(type == GongqiDataType.TypeStringLabel)
          {
            finalvalue = "";
          }
          else if(type ==  GongqiDataType.TypeEnumLabel)
          {
            finalvalue = 0;
          }
          else if(type == GongqiDataType.TypeBooleanLabel)
          {
            finalvalue = false;
          }
          else if(type == GongqiDataType.TypeLongLabel || type == GongqiDataType.TypeDecimalLabel)
          {
            finalvalue = 0; 
          }
          else if(type == GongqiDataType.TypeDateLabel)
          {
            finalvalue = "";
          }
          else if(type == GongqiDataType.TypeTimeLabel)
          {
            finalvalue = "";
          }
          record[key2] = finalvalue;
        }
       
      }
      
    }
    
  }
    
  fillEmptyObject(groupObject)
  {
    var length = this.aliasList.length;
    if(length<=1)
      return;
    
    for(var i=0; i<length; i++)
    {
      var alias = this.aliasList[i];

      var has = false;
      for(var key in groupObject)
      {
        if(key.indexOf(alias) > -1)
        {
          has = true;
          break;
        }
      }

      if(!has)
      {
        this.copyRecord(this.aliasListEmptyObject[alias],groupObject);
      }
    }
  }

  copyRecord(baseRecord,toRecord)
  {
    if(toRecord==null)
      return null;
    for(var key in baseRecord)
    {
      if(!toRecord.hasOwnProperty(key))
        toRecord[key] = baseRecord[key];
    }
  }

  getExportSettingTitle(settingdoc,_key)
  {
    var settingNode0 = settingdoc.childNodes[0];
    var _fileName = settingNode0.attributes.fileName.nodeValue;
    var _title = "导出预览 来自设置"+_fileName;
    var defaultSetting = FormDataSources.getUserDefaultExportList(_key);
    if(defaultSetting)
    {
      var defaultSettingDoc = (new DOMParser()).parseFromString(defaultSetting,"application/xml");
      var defaultSettingNode0 = defaultSettingDoc.childNodes[0];
      var defaultFileName = defaultSettingNode0.attributes.fileName.nodeValue;
      if(defaultFileName==_fileName)
      {
        _title+="(默认)";
      }
    }
    return _title;
  }

  doExport(filter,isPivot = false,flag=null)
  {
    if(!this.getAuthorityFinal("test",FormDataSourceAuthorityType.Export,this.currentRecord))
      return;
    /*if(!this.getAuthorityByXML(FormDataSourceAuthorityType.exportStr))
      return;*/
    var _showTableName = true;
    var columns = null;
    var key;
    if(window.formId.indexOf(".") == -1 && window.menuItemId.indexOf(".") == -1)
    {
      key = window.formId + "_" + this.mainSource.xml.id  + (window.menuItemId?"."+window.menuItemId:"");
    }
    else
    {
      key = window.formId + "_" + this.mainSource.xml.id  + (window.menuItemId?"&"+window.menuItemId:"");
    }
    if(flag=='drop'){
      window.parent.window.toolbarExportDrop(key)
      return;
    }
    
    var _title = null;
    if(!isPivot)
    {
      //var setting = FormDataSources.userExportList;//((window.parent && window.parent.window)?window.parent.window.userExportList:{});
      
      var settingXML = FormDataSources.getUserDefaultExportList(key);
      if(settingXML)
      {
        var settingdoc = (new DOMParser()).parseFromString(settingXML,"application/xml");
        var settingdocNode0 = settingdoc.childNodes[0];
        _showTableName = (settingdocNode0.attributes.showTableName.nodeValue)=="true"?true:false;
        _title = this.getExportSettingTitle(settingdoc,key);
        //columns = this.consOnedimensionalGridColBySetting(FormDataSources.userExportList[key]);
        columns = this.consOnedimensionalGridColBySetting(settingdocNode0);
      }
      else
      {
        columns = this.consOnedimensionalGridColByView(null,filter,isPivot);
      }
    }
    else
    {
      columns = this.consOnedimensionalGridColByView(null,filter,isPivot);
      _title = "数据分析设置";
    }
    
    let _records = this.records;
    if(this.mainSource.isTempTable == true && this.tempRecordsFilter)
    {
      _records = this.tempRecordsFilter;
    }

    var ac = this.convertToOnedimensional(_records,filter);

    var extrals = this.getExtralExportFields(columns,filter);
    
    let strac =  JSON.stringify(ac);
    let jsonac = JSON.parse(strac);
    if(window.isDataSetView){
      for(let kk = 0;kk<jsonac.length;kk++)
      {
        let dsItem = jsonac[kk];
        for(let k in dsItem)
        {
          //导出时 如果是Enum 类型 取值存在 问题  如果是Date 日期类型 先转为String
          for(let j in columns){
            let sht = k.substring(k.lastIndexOf(".")+1,k.length);
            let shtc = columns[j].dataField.substring(columns[j].dataField.lastIndexOf(".")+1,columns[j].dataField.length);
            if(columns[j].fieldType == "Enum" && sht == shtc){
              for(let ii in this.dataSetQueryTable.allQueryFields){
                if((this.dataSetQueryTable.allQueryFields[ii].fieldAliasName && this.groupAlias+"."+this.dataSetQueryTable.allQueryFields[ii].fieldAliasName == k)
                ||(this.groupAlias+"."+StringUtil.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[ii].fieldName)) == k){
                  var newFieldValue = "";
                  var table = GOT.getTable(this.dataSetQueryTable.allQueryFields[ii].refEntityId);
                  if(table){
                    var tableField = GOT.getTableField(table,this.dataSetQueryTable.allQueryFields[ii].refInnerId);
                    if(tableField){
                      var enumId = tableField.Properties.Extends.refentityid;
                      var enumItem = GOT.getEnum(enumId);
                      if(enumItem){
                        for(let ein in enumItem.EnumItems){
                          let its = enumItem.EnumItems[ein];
                          if(dsItem[k]== its.Properties.Value.V || dsItem[k]== (its.Properties.Value.V+"")){
                            newFieldValue = its.Properties.Label.V?its.Properties.Label.V:its.Properties.Label.Value;
                            break;
                          }
                        }
                      }
                    }
                  }
                  dsItem[k] = newFieldValue;
                }
            }
            }
            if(columns[j].fieldType == "Decimal" && dsItem[k]!=null && dsItem[k]!='null'){
                if(this.groupAlias+"."+columns[j].normalHeaderText == k){
                  dsItem[k] = FormItemDecimalDisplay.getDisplayText(dsItem[k],columns[j].showZero,
                    columns[j].numOfDecimals?columns[j].numOfDecimals:2,columns[j].thousandSeperator,{});
                }
              }
              if(columns[j].fieldType == "Decimal" && dsItem[k]!=null && dsItem[k]!='null'){
                if(dsItem[k].indexOf(',') != -1){
                  dsItem[k] = dsItem[k].replace(/,/g, "");
                }
              }
          }
          for(let i in this.dataSetQueryTable.allQueryFields){
            if((this.dataSetQueryTable.allQueryFields[i].fieldAliasName && this.groupAlias+"."+this.dataSetQueryTable.allQueryFields[i].fieldAliasName == k)
            ||(this.groupAlias+"."+StringUtil.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[i].fieldName)) == k){
              if(dsItem[k] == null || dsItem[k] == 'null'){
                dsItem[k]='';
              }
              if(window.parent.window.dataSet ){
                let dcolumns =  window.parent.window.dataSet.dataColumn.columns;
                for(let col in dcolumns){
                  if(col == this.dataSetQueryTable.allQueryFields[i].fieldAliasName || col == this.dataSetQueryTable.allQueryFields[i].fieldName){
                    if(dcolumns[col].dataType =="Date" && dcolumns[col].displayFormat){
                      dsItem[k] = FormItemDateDisplay.getDisplayText2( dsItem[k],dcolumns[col].displayFormat.toUpperCase());
                    }
                    if(dcolumns[col].dataType =="Time" && dcolumns[col].displayFormat){
                      dsItem[k] = FormItemTimeDisplay.getDisplayText2( dsItem[k],dcolumns[col].displayFormat.toUpperCase());
                    }
                    if(dcolumns[col].dataType =="Decimal" && dcolumns[col].displayFormat){
                      dsItem[k] = FormItemDecimalDisplay.getDisplayText2( dsItem[k],dcolumns[col].displayFormat.toUpperCase());
                    }
                  }
                }
              }
              dsItem[this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName] = dsItem[k];
              let dataSource = this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.substring(0,this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.indexOf("."))
              dsItem[dataSource+"."+this.dataSetQueryTable.allQueryFields[i].fieldAliasName] = dsItem[k];
              if(this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.indexOf(this.groupAlias) == -1){
                // delete dsItem[k];
              }
            }
          } 
        }
      }
      ac =jsonac;
      extrals=[];
    }
    if(window.isDataSetView){
      for(let j in columns){
        let col = columns[j];
        col.dataField = this.mainSource.alias+'.'+col.dataField.substring(col.dataField.lastIndexOf('.')+1);
      }
    }
    
    /*if(this.linkGroup && this.linkGroup.currentRecord)
    {
      var headerColumns = this.linkGroup.consOnedimensionalGridColByView();
      var headerAc = this.linkGroup.convertToOnedimensional([this.linkGroup.currentRecord],filter);
    }*/
    
    //TODO 打开export//columns extrals ac key this _showTableName isPivot
    
   // ReactDOM.render(<ExportTable columns={columns} extrals={extrals} ac={ac} key={key} showTableName={_showTableName} isPivot={isPivot} group={this}/>,
   //     window.parent.window.document.getElementById('exportModal'));

    var htmlarg = {columns:columns,extrals:extrals,ac:ac,key:key,showTableName:_showTableName,isPivot:isPivot,group:this};
    ReactDOM.render( <ExportTable htmlarg={htmlarg} initExport={flag} />,document.getElementById('exportModal'));
    // window.parent.window.htmlarg = {columns:columns,extrals:extrals,ac:ac,key:key,showTableName:_showTableName,isPivot:isPivot,group:this};
    // window.parent.$("#exportModal").load("export/export.html");
  }

  convertValue(value,key)
  {
    var cacheValue = this.fieldCache[key];
    if(cacheValue == null)
    {
      cacheValue = this.fieldCache[key.replace(".","-")];
    }
    if(!cacheValue)
      return null;
    if(typeof(cacheValue) === "string")
    {
      return new String(value).replace(/[\n\r]+/g," ");
    }
    else if(Array.isArray(cacheValue))
    {
      for(let i = 0;i<cacheValue.length;i++)
      {
        let obj = cacheValue[i];
        if(obj.value == value)
          return obj.label;
      }
    }
    else 
    {
      return cacheValue[value];
    }
    
    return null;
  }

  //传入到后台导出的数据均为字符串 后台导出EXCEL时根据数据类型做强制转换
  convertToOnedimensional1(ac,filter = null)
  {
    var newAc = [];
    var tempObj = {};
    for(let i = 0;i<ac.length;i++)
    {
      var item = ac[i];
      for(var key in item)
      {
        var fieldValue = item[key];
        var keyarr = key.split(".");
        var table = keyarr[0];
       
        var value = fieldValue;
        var df = key;var oddf = key;
        if(filter!=null && filter.indexOf(df)!=-1)
        {
          cacheValue = "";  
        }
        else
        {
          var cacheValue = this.convertValue(value,oddf);
        }

        oddf = oddf.replace(/[\.]/g,'-');

        if(cacheValue != null)
          tempObj[oddf] = cacheValue+"";
        else
          tempObj[oddf] = value+"";
        
      }
      newAc.push(tempObj);
      tempObj = {};
    }
    return newAc;
  }


  convertToOnedimensional(ac,filter = null)
  {
    var newAc = [];
    var tempObj = {};
    for(let i = 0;i<ac.length;i++)
    {
      var item = ac[i];
      for(var key in item)
      {
        var fieldValue = item[key];
        var keyarr = key.split(".");
        var table = keyarr[0];
       
        var value = fieldValue;
        var df = key;var oddf = key;
        if(filter!=null && filter.indexOf(df)!=-1)
        {
          cacheValue = "";  
        }
        else
        {
          var cacheValue = this.convertValue(value,oddf);
        }
        if(cacheValue != null)
          tempObj[oddf] = cacheValue+"";
        else
          tempObj[oddf] = value+"";
        
      }
      newAc.push(tempObj);
      tempObj = {};
    }
    return newAc;
  }



  consOnedimensionalGridColBySetting(settingdoc)
  {
    
    if(this.sources.length > 1)
      var isNeedTableName = true;
    else 
      isNeedTableName = false;
    
    var columns = [];var childNodes = settingdoc.children;var map = {};
    for(let i=0;i<childNodes.length;i++)
    {
      var xml = childNodes[i];
      var formItemId = xml.attributes.formItemId?xml.attributes.formItemId.nodeValue:"";
      var fdsfId = xml.attributes.fdsfId?xml.attributes.fdsfId.nodeValue:"";
      var isDataMethod = (xml.attributes.isDataMethod.nodeValue)=="true"?true:false;
      var selected = (xml.attributes.selected.nodeValue) == "true"?true:false;
      var result = this.getExportColumnInfo(fdsfId,formItemId,isDataMethod,isNeedTableName);
      if(result)
      {
        if(result.oneddatafield && map[result.oneddatafield]==true)
        {
          continue;
        }
        map[result.oneddatafield]=true;
        this.addDataGridColumn(columns,result.formItemId,result.isDataMethod,result.oneddatafield,result.fdsfId,result.label,result.totalLabel,result.sourceName,selected,result.fieldType);
      }
        
    }
    return columns;
  }

  consOnedimensionalGridColByView(_group,filter = null,isPivot = false)
  {
    if(!_group)
      _group = this;
    
    if(_group.sources.length > 1)
      var isNeedTableName = true;
    else 
      isNeedTableName = false;
    
    var columns = [];
    var focusSequenceList = window.formModuleInstance.focusController.focusableItemsQue1;
    var map = {};
    for(let i=0;i<focusSequenceList.length;i++)
    {
      var xml = focusSequenceList[i];
      var formItem = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,xml.id));
      
      //TODO 如果是 数据集 区分不同数据源 item
      if(window.isDataSetView){
        this.dataSetQueryTable.allQueryFields = [];
        this.getAllQueryFieldssForDataSetView(this.dataSetQueryTable);

        for(let k in this.dataSetQueryTable.allQueryFields){
          if((this.dataSetQueryTable.allQueryFields[k].fieldAliasName && this.dataSetQueryTable.allQueryFields[k].fieldAliasName == formItem.dataSource_Field)
          ||StringUtil.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[k].fieldName) == formItem.dataSource_Field){
            formItem.dataField = this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName;
            formItem.dataSource_Alias = this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName.substr(0,this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName.lastIndexOf("."));
            if(this.dataSetQueryTable.allQueryFields[k].type=="Expression"){
              let fileName =StringUtil.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[k].fieldName);
              let expAlisa = this.dataSetQueryTable.allQueryFields[k].dataSourceFliedName.replace(fileName,'');
              formItem.dataSource_Alias = expAlisa.replace('.','');
              formItem._expression=true;
            }
            var tableXML = GOT.getTable(this.dataSetQueryTable.allQueryFields[k].refEntityId);
            var tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
            formItem.comDataSetLabel = tableLabel;
          }
        }

      }

      if(formItem.group == _group && 
        xml.type && xml.type.indexOf("Editor")!=-1 && 
        formItem.dataSource_Alias!="" &&　
        formItem.dataSource_Field != "" 
      )
      {
              //TODO_YL 行列转置聚合的字段列 不作为输出列 
        let flaga = false;
        if(this.dynamicColumnsPre && window.formModuleInstance.focusController.focusableItemsQue){
          for(let j in window.formModuleInstance.focusController.focusableItemsQue){
            if(window.formModuleInstance.focusController.focusableItemsQue[j].id==formItem.xml.parentId){
              let  dynamicol =  GOTUtil.getProperty(window.formModuleInstance.focusController.focusableItemsQue[j],"DynamicColumn");
              if(formItem && dynamicol && formItem.innerId == dynamicol.innerid){
                flaga=true;
                break;
              }
            };
          }
        }
        if(flaga){
          continue;
        }
        if(isPivot)
        {
          if(formItem.classAlias == "FormItemTimeEditorControl")
            continue;
          if(formItem.classAlias == "FormItemStringEditorControl" && formItem.isDataAnlysFilter())
            continue;
        }
        var fe = formItem;
        if(filter && filter.indexOf(fe.getDataField())!=-1)continue;
        var oneddatafield;
        if(fe.dataSource_Field.indexOf(".")==-1)
        {
          oneddatafield = fe.dataSource_Alias + "." + StringUtil.convertToFirstLowerCase(fe.dataSource_Field);
        }
        else
        {
          var _array = fe.dataSource_Field.split(".");
          if(_array.length>3){
            oneddatafield = fe.dataSource_Alias + "." + StringUtil.convertToFirstLowerCase(fe.dataSource_Field);
          }else{
            oneddatafield = fe.dataSource_Alias + "." + StringUtil.convertToFirstLowerCase(_array[0]) + "." +StringUtil.convertToFirstLowerCase(_array[1]);
          }
          
        }
        if(fe._expression){
          oneddatafield= fe.dataSource_Alias+'.'+fe.dataSource_Field;
        }
        if(map[oneddatafield] == true)
          continue;
        map[oneddatafield] = true;
        let dataSourceFieldXML;
        if(!fe.isDataMethodField)
        {
          var fieldObj = this.getFormDataSourceField(fe.dataSource_Field,fe.dataSource_Alias);
          dataSourceFieldXML = fieldObj.field;
          if(dataSourceFieldXML == null)
            continue;
          this.saveFieldCache(dataSourceFieldXML,oneddatafield); 
        }
        else
        {
          dataSourceFieldXML = null;
        }
        if(!fe.getProperty_Visible_Final())
          continue;
        var _type = fe.xml.type;
        var _fieldType = _type.substr(0,_type.length-"Editor".length);
        var gc = {};
        gc.formItemId = fe.xml.id;
        gc.isDataMethod = fe.isDataMethodField;
        gc.fdsfId = dataSourceFieldXML==null?"":dataSourceFieldXML.id;
        gc.dataField = oneddatafield;
        gc.fieldType = _fieldType;
        if(_fieldType == "Decimal"){
          gc.numOfDecimals = fe.getProperty_NumOfDecimals();
        }
        var _label = formItem.getProperty_Label(false);var _totalLabel;
        if(isNeedTableName)
        {
          var sourceName = formItem.dataSource_Alias;

          for(let i = 0;i<_group.sources.length;i++)
          {
            var source = _group.sources[i];
            if(source.alias == sourceName)
              break;
          }
          if(!window.isDataSetView){
            if(source.alias != sourceName)
              continue;
              var tableName = GOTUtil.getPropertyValue(source.xml,"Table");
              var tableXML = GOT.getTable(tableName);
              var tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
              _totalLabel = tableLabel + "." + _label;
          }else{
            _totalLabel = formItem.comDataSetLabel+"."+_label;
          }
        }
        else
        {
          _totalLabel = _label;
        }
        gc.headerText = _label;
        gc.totalHeaderText = _totalLabel;
        gc.normalHeaderText = _label;
        gc.selected = true;
        columns.push(gc);
      }
    }

    if(this.dynamicColumnsPre ){
      for(let key in this.dynamicColumnsPre){
        let cls = this.dynamicColumnsPre[key];
        for(let i in cls){
          let cols = cls[i];
          for(let j in cols){
            let col = cols[j];
            let gc = {};
            gc.formItemId = "";
            gc.isDataMethod = true;
            gc.fdsfId = ""
            gc.dataField = key+"."+StringUtil.convertToFirstLowerCase(col.dataKey);
            gc.fieldType = "String";
            gc.normalHeaderText=col.columnLabel;
            gc.selected=true;
            gc.totalHeaderText=col.columnLabel;
            gc.dataKey =col.dataKey;
            
            gc.isDynmicColumn=true;
            columns.push(gc);
          }
          
        }
      }
    }
    
    return columns;
  }


  getFormDataSourceField2(_name,table,_group)
  {
    if(!_group)
      _group = this;
    var _name1 = StringUtil.convertToEachFirstLowerCase(_name);
    var _name2 = StringUtil.convertToEachFirstUpperCase(_name);
    var result = null;
    for(let i=0;i<_group.sources.length;i++)
    {
      var formDataSource = _group.sources[i];
      if(formDataSource.xml.name == table || GOTUtil.getPropertyValue(formDataSource.xml,"Table") == table)
      {
        result = GOT.getFormDataSourceField(formDataSource.xml,_name1,_name2);
        if(result)
          return result;
      }
    }
    
    return result;
  }


  getFormDataSourceField(_name,table,_group,parms = {})
  {
    if(!_group)
      _group = this;
    var _name1 = StringUtil.convertToEachFirstLowerCase(_name);
    var _name2 = StringUtil.convertToEachFirstUpperCase(_name);
    if(_name.split('.').length>3){
      _name1 = _name;
      _name2 = _name;
    }
    var result = null;
    for(let i=0;i<_group.sources.length;i++)
    {
      var formDataSource = _group.sources[i];
      if(formDataSource.xml.name == table || GOTUtil.getPropertyValue(formDataSource.xml,"Table") == table)
      {
        var result = GOT.getFormDataSourceField(formDataSource.xml,_name1,_name2,parms.ingoreCase);
        if(result)
        {
          var au = AuthorityUtil.getXmlType2SCacheItem(window.menuItemId,result.id,"visible"); 
          if(!au["result"]||
            GOTUtil.getFinalValue(result,window.formXML,"Visible") == "false"
          )
          {
            result = null;
          }  
        }
        
        return {field:result,dataSource:formDataSource.xml};
      }
    }
    
    return result;
  }

  saveFieldCache(field,key)
  {
    if(this.fieldCache.hasOwnProperty(key))
      return;
    var type = field.type;
    if(type == "Enum")
    {
      var extendsPro = field.Properties.Field;
      if(extendsPro.hasOwnProperty("refentityid"))
      {
        var table = GOT.getTable(extendsPro.refentityid);
        var tableField = GOT.getTableField(table,extendsPro.refinnerid);
        this.fieldCache[key] = GOTUtil.getDataSourceByTableField(tableField);
      }
    }
    else if(type == "Boolean")
    {
      var textTrueLabel = GOTUtil.getFinalValue(field,window.formXML,"TextTrue");
      textTrueLabel = textTrueLabel == ""?"是":textTrueLabel;
      var textFalseLabel = GOTUtil.getFinalValue(field,window.formXML,"TextFalse");
      textFalseLabel = textFalseLabel == ""?"否":textFalseLabel;
      this.fieldCache[key] = {"true":textTrueLabel,"false":textFalseLabel};
    }
    else
    {
      this.fieldCache[key] = type;
    }
  }
   
  getFormDataSourceFieldById(_id)
  {
    for(let i = 0;i<this.sources.length;i++)
    {
      let formDataSource = this.sources[i];
      let formDataSourceFields = formDataSource.xml.FormDataSourceFields;
      for(let k = 0;k<formDataSourceFields.length;k++)
      {
        let formDataSourceField = formDataSourceFields[k];
        if(formDataSourceField.id == _id)
          return {field:formDataSourceField,dataSource:formDataSource.xml};
      }
    }
    
    return null;
  } 

  //仅在通过setting获取columnInfo的时候才被调用
  getExportColumnInfo(fdsfId,formItemId,isDataMethod,isNeedTableName)
  {
    if(fdsfId == "" && formItemId != "" && isDataMethod)
    {
      var fe = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,formItemId));
      if(fe == null)
        return null;
      var oneddatafield = fe.getDataField();
      /*if(fe.dataSource_Field.indexOf(".")==-1)
      {
        oneddatafield = fe.dataSource_Alias + "-" + StringHelper.convertToFirstLowerCase(fe.dataSource_Field);
      }
      else
      {
        var _array:Array = fe.dataSource_Field.split(".");
        oneddatafield = fe.dataSource_Alias + "-" + StringHelper.convertToFirstLowerCase(_array[0]) + "-" + StringHelper.convertToFirstLowerCase(_array[1]);
      }*/
      if(!fe.isDataMethodField)
      {
        var fieldObj = this.getFormDataSourceField(fe.dataSource_Field,fe.dataSource_Alias);
        var dataSourceFieldXML = fieldObj.field;
        this.saveFieldCache(dataSourceFieldXML,oneddatafield); 
      }
      if(!fe.getProperty_Visible_FinalWithOutUserSet())
        return null;
      var _type = fe.xml.type;
      var _fieldType = _type.substr(0,_type.length-"Editor".length);
      var _label = fe.getProperty_Label(false);
      if(isNeedTableName)
      {
        var sourceName = fe.dataSource_Alias;
        for(let i=0;i<this.sources.length;i++)
        {
          var source = this.sources[i];
          if(source.alias == sourceName)
            break;
        }
        if(window.isDataSetView){
          let sali=source.alias;
          if(source.alias.indexOf('.') != -1 && sourceName.indexOf('.') ==-1){
            sali=source.alias.substring(source.alias.lastIndexOf('.')+1);
          }
          if(sali != sourceName  && fe.ExpressionGroupAlisa != sali){}
            // return null;
        }else{
          if(source.alias != sourceName )
            return null;
        }
        var tableName = GOTUtil.getPropertyValue(source.xml,"Table");
        var tableXML = GOT.getTable(tableName);
        var tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
        var totalLabel = tableLabel + "." + _label;
      }
      else
      {
        totalLabel = _label;
      }
      return {formItemId:formItemId,isDataMethod:true,oneddatafield:oneddatafield,fdsfId:"",label:_label,totalLabel:totalLabel,sourceName:fe.dataSource_Alias,fieldType:_fieldType};
    }
    else if(fdsfId != "" && formItemId == "")
    {
      var obj = this.getFormDataSourceFieldById(fdsfId);
      if(!obj)
        return null;
      var fdsf = obj.field;var fds = obj.dataSource;var fdsn = fdsf.name;var fdsna = fdsn.split(".");
      oneddatafield = fds.name;
      for(let i=0;i<fdsna.length;i++)
      {
        let s = fdsna[i];
        oneddatafield+=("."+StringUtil.convertToFirstLowerCase(s));
      }
      this.saveFieldCache(fdsf,oneddatafield);
      var au = AuthorityUtil.getXmlType2SCacheItem(window.menuItemId,fdsfId,"visible"); 
      if(!au["result"]||
        GOTUtil.getFinalValue(fdsf,this.formDataSources.formModule.formXML,"Visible") == "false"
      )
      {
        return null;
      }
      _label = GOTUtil.getFinalValue(fdsf,this.formDataSources.formModule.formXML,"Label");
      if(isNeedTableName)
      {
        tableName = GOTUtil.getPropertyValue(fds,"Table");
        tableXML = GOT.getTable(tableName);
        tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
        totalLabel = tableLabel + "." + _label;
      }
      else
      {
        totalLabel = _label;
      }
      return {formItemId:"",isDataMethod:false,oneddatafield:oneddatafield,fdsfId:fdsfId,label:_label,totalLabel:totalLabel,sourceName:fds.name,fieldType:fdsf.type};
    }
    else if(fdsfId != "" && formItemId != "")
    {
      fe = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,formItemId));
      
      if(!fe || !fe.getProperty_Visible_FinalWithOutUserSet())
        return null;

      var obj = this.getFormDataSourceFieldById(fdsfId);
      if(!obj)
        return null;
      fdsf = obj.field;
      var au = AuthorityUtil.getXmlType2SCacheItem(window.menuItemId,fdsfId,"visible"); 
      if(!au["result"]||
        GOTUtil.getFinalValue(fdsf,"Visible") == "false"
      )
      {
        return null;
      }
      _label = fe.getProperty_Label(false);
      if(isNeedTableName)
      {
        sourceName = fe.dataSource_Alias;
        for(let i = 0;i<this.sources.length;i++)
        {
          var source = this.sources[i];
          if(source.alias == sourceName)
            break;
        }
        if(source.alias != sourceName)
          return null;
        tableName = GOTUtil.getPropertyValue(source.xml,"Table");
        tableXML = GOT.getTable(tableName);
        tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
        totalLabel = tableLabel + "." + _label;
      }
      else
      {
        totalLabel = _label;
      }
      oneddatafield = fe.dataSource_Alias + "." + StringUtil.convertToEachFirstLowerCase(fe.dataSource_Field);//.replace(".","-");
      this.saveFieldCache(fdsf,oneddatafield);
      return {formItemId:formItemId,isDataMethod:false,oneddatafield:oneddatafield,fdsfId:fdsfId,label:_label,totalLabel:totalLabel,sourceName:fe.dataSource_Alias,fieldType:fdsf.type};
    }
    return null;
  }

  addDataGridColumn(columns,formItemId,isDataMethod,oneddatafield,fdsfId,_label,_totalLabel,sourceName,_selected,_fieldType)
  {
    var gc = {};
    gc.formItemId = formItemId;
    gc.isDataMethod = isDataMethod;
    gc.fdsfId = fdsfId;
    gc.fieldType = _fieldType;
    
    if(_fieldType == "Decimal")
    {
      let tmpNumOfDecimals = 2;
      if(formItemId)
      {
        var formItem = FormItemUtil.getFormItemControl(FormItemUtil.getFormItemControlKey(window.menuItemId,window.formId,formItemId));
        if(formItem)
        {
          gc.numOfDecimals = formItem.getProperty_NumOfDecimals();
        }
      }
      else if(fdsfId)
      {
        let form = GOT.getForm(window.formId);
        if(form)
        {
          let formDataSourceField;
          for(let i in form.FormDataSources.DataSources)
          {
            var formDataSource = form.FormDataSources.DataSources[i];
            
            for(let k = 0;k<formDataSource.FormDataSourceFields.length;k++)
            {
              let item = formDataSource.FormDataSourceFields[k];
              if(item && item.id == fdsfId)
              {
                formDataSourceField = item;
                break;
              }
            }
            if(formDataSourceField)
              break; 
          }
          if(formDataSourceField && form)
            tmpNumOfDecimals = GOTUtil.getFinalValue(formDataSourceField,form,"NumOfDecimals");
          if(!tmpNumOfDecimals)tmpNumOfDecimals = 2;
        }
      }
      gc.numOfDecimals = tmpNumOfDecimals;  
    }
    gc.dataField = oneddatafield;
    gc.totalHeaderText = _totalLabel;
    gc.normalHeaderText = _label;
    gc.selected = _selected;
    gc.visible = _selected;
    gc.headerText = _label;
    
    columns.push(gc);
  }

  getExtralExportFields(columns,filter = null)
  {
    if(!this.records || this.records.length == 0)
      return null;
    var isNeedTableName = this.sources.length>1;
    var result = [];

    var mapLabel;var mapVisible;var mapSort;
    for(let i = 0;i<this.sources.length;i++)
    {
      let formDataSource = this.sources[i];
      var tableLabel = "";var fieldLabel = "";
      var table = formDataSource.alias;
      var formDataSourceFields = formDataSource.xml.FormDataSourceFields;
      mapLabel = mapVisible = mapSort = null;
      let dimAdjustFormDataSourceField = this.formDataSources.formModule.dimAdjustFormDataSourceField;
      if(dimAdjustFormDataSourceField)
      {
        if(dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapLabel && dimAdjustFormDataSourceField.mapLabel.hasOwnProperty(table))
        {
          mapLabel = dimAdjustFormDataSourceField.mapLabel[table];  
        }
        
        if(dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapVisible && dimAdjustFormDataSourceField.mapVisible.hasOwnProperty(table))
        {
          mapVisible = dimAdjustFormDataSourceField.mapVisible[table];
        }
        
        if(dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapSort && dimAdjustFormDataSourceField.mapSort.hasOwnProperty(table))
        {
          mapSort = dimAdjustFormDataSourceField.mapSort[table];
        }
        
      }
      var mapSortDemi = {};var mapSortCpy = {};
      for(var cmp in mapSort)
      {
        var arrayItemsCpy = [];
        
        var cmpaitems = mapSort[cmp];
        
        for(let kk = 0;kk<cmpaitems.length;kk++)
        {
          arrayItemsCpy[kk] = cmp+"."+cmpaitems[kk];
          mapSortDemi[arrayItemsCpy[kk]] = true;
        }
        mapSortCpy[cmp] = arrayItemsCpy;
      }
      var array = [];
      for(let j = 0;j<formDataSourceFields.length;j++)
      {
        let formDataSourceField = formDataSourceFields[j];
        let _name = formDataSourceField.name;
        if(window.isDataSetView == true && _name == "CreatedDate")
          break;
        if(formDataSourceField.type=="Component" && _name.indexOf(".") == -1)
        {
          if(mapSortCpy && mapSortCpy.hasOwnProperty(_name))
          {
            var dataTypeArrayItems = mapSortCpy[_name];
            for(let k = 0;k<dataTypeArrayItems.length;k++)
            {
              let dataTypeArrayItem = dataTypeArrayItems[k];

              let arrayItemDataSourceField = null;
              for(let n = 0;n<formDataSourceFields.length;n++)
              {
                if(formDataSourceFields[n].name == dataTypeArrayItem)
                {
                  arrayItemDataSourceField = formDataSourceFields[n];break;
                }
              }               
              if(arrayItemDataSourceField)
              {
                array.push(arrayItemDataSourceField);
              }
              else
              {
                Warning.show("跟拒二次开发中的mapSort中的名称未能找到对应的FormDataSourceField:"+ dataTypeArrayItem  +" 请确认二次开发是否有误");
              }
            }
          }
          continue;
          
        }
        if(_name.indexOf(".")!=-1 && mapSortDemi.hasOwnProperty(_name))
          continue;
        array.push(formDataSourceField);
      }
      
      for(let j = 0;j<array.length;j++)
      {
        let formDataSourceField = array[j];
        let _name = formDataSourceField.name;          
        if(mapVisible && mapVisible.hasOwnProperty(_name) && mapVisible[_name] == false)
          continue;
          
        let origdataSourceField = StringUtil.convertToEachFirstLowerCase(_name);
        let dataSourceField = origdataSourceField;//.replace(".","-");
        let _dataField = table+"-"+dataSourceField;
        let _recDataField = table+"."+dataSourceField;
        if(filter && filter.indexOf(_recDataField)!=-1)continue;
        var flag = false;
        for(let k = 0;k<columns.length;k++)
        {
          let column = columns[k];
          if(column.dataField == _dataField || column.dataField == _recDataField)
          {
            flag = true;
            break;
          }
        }
        if(!flag)
        {
          var fe = this.findItemByDataField(_recDataField);
          var _label;var _totalLabel;
          if(!fe)
          {
            if(formDataSourceField)
            {
              _label = (mapLabel&&mapLabel.hasOwnProperty(_name))?mapLabel[_name]:GOTUtil.getFinalValue(formDataSourceField,window.formXML,"Label");
              if(isNeedTableName)
              {
                var fds = formDataSource.xml;
                var tableName = GOTUtil.getPropertyValue(fds,"Table");
                var tableXML = GOT.getTable(tableName);
                tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
                _totalLabel = tableLabel + "." + _label;
              }
              else
              {
                _totalLabel = _label;
              }
              let obj = {label:_label,selected:true,dataField:table+"."+dataSourceField,totalLabel:_totalLabel,fdsfId:formDataSourceField.id,formItemId:"",isDataMethod:false,fieldType:formDataSourceField.type};
              if(obj.fieldType == "Decimal")
                obj.numOfDecimals = GOTUtil.getFinalValue(formDataSourceField,this.formDataSources.formModule.props.xml,"NumOfDecimals");
              result.push(obj);
            }
          }
          else
          {
            if(fe.getProperty_Visible_FinalWithOutUserSet())
            {
              _label = (mapLabel&&mapLabel.hasOwnProperty(_name))?mapLabel[_name]:fe.getProperty_Label(false);

              if(isNeedTableName)
              {
                var sourceName = fe.dataSource_Alias;
                for(let i = 0;i<this.sources.length;i++)
                {
                  var source = this.sources[i];
                  if(source.alias == sourceName)
                    break;
                }
                if(source.alias != sourceName)
                  continue;
                tableName = GOTUtil.getPropertyValue(source.xml,"Table");
                tableXML = GOT.getTable(tableName);
                tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
                _totalLabel = tableLabel + "." + _label;
              }
              else
              {
                _totalLabel = _label;
              }
              let obj = {
                    label:_label,selected:true,dataField:table+"."+dataSourceField,totalLabel:_totalLabel,
                    fdsfId:formDataSourceField?formDataSourceField.id:"",formItemId:fe.innerId,isDataMethod:fe.isDataMethodField,fieldType:_fieldType
                  };
              var _type = fe.xml.type;
              var _fieldType = _type.substr(0,_type.length-"Editor".length);
              if(fe.classAlias == "FormItemDecimalEditorControl")
                obj.numOfDecimals = fe.getProperty_NumOfDecimals();
              result.push(obj);
            }
            
            
          }
        }
      }
    }

    for(let key in FormItemUtil.formItemControlsForFor)
    {
      let fe = FormItemUtil.formItemControlsForFor[key];
      
      if(fe && fe.isDataMethodField)
      {
        let _dataField = fe.dataSource_Alias + "-" + fe.dataSource_Field;
        let _dataField1 = fe.dataSource_Alias + "." + fe.dataSource_Field;
        let flag = false;
        for(let i = 0;i<columns.length;i++)
        {
          let column = columns[i];
          if(column.dataField == _dataField || column.dataField == _dataField1)
          {
            flag = true;
            break;
          }
        }
        
        if(!flag)
        {
          let _type = fe.xml.type;
          let _fieldType = _type.substr(0,_type.length-"Editor".length);
          let _label = fe.getProperty_Label(false);
          let source;
          if(isNeedTableName)
          {
            let sourceName = fe.dataSource_Alias;
            for(let i = 0;i<this.sources.length;i++)
            {
              source = this.sources[i];
              if(source.alias == sourceName)
                break;
            }
            if(source.alias != sourceName)
              continue;
            tableName = GOTUtil.getPropertyValue(source.xml,"Table");
            tableXML = GOT.getTable(tableName);
            tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
            _totalLabel = tableLabel + "." + _label;
          }
          else
          {
            _totalLabel = _label;
          }
          let obj2 = {label:_label,selected:true,dataField:_dataField1,totalLabel:_totalLabel,fdsfId:"",formItemId:fe.innerId,isDataMethod:true,fieldType:_fieldType};
          if(fe.classAlias == "FormItemDecimalEditorControl")
            obj2.numOfDecimals = fe.getProperty_NumOfDecimals();
          result.push(obj2);
        }
      }
    }
    
    return result;
  }

  getExtralExportFields1(columns,filter = null)
  {
    if(!this.records || this.records.length == 0)
      return null;
    var isNeedTableName = this.sources.length>1;
    var result = [];

    var mapLabel;var mapVisible;var mapSort;
    for(let i = 0;i<this.sources.length;i++)
    {
      let formDataSource = this.sources[i];
      if(this.mainSource.isAggreateTable && formDataSource != this.mainSource)
        continue;
      var tableLabel = "";var fieldLabel = "";
      var table = formDataSource.alias;
      var formDataSourceFields = formDataSource.xml.FormDataSourceFields;
      mapLabel = mapVisible = mapSort = null;
      let dimAdjustFormDataSourceField = this.formDataSources.formModule.dimAdjustFormDataSourceField;
      if(dimAdjustFormDataSourceField)
      {
        if(dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapLabel && dimAdjustFormDataSourceField.mapLabel.hasOwnProperty(table))
        {
          mapLabel = dimAdjustFormDataSourceField.mapLabel[table];  
        }
        
        if(dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapVisible && dimAdjustFormDataSourceField.mapVisible.hasOwnProperty(table))
        {
          mapVisible = dimAdjustFormDataSourceField.mapVisible[table];
        }
        
        if(dimAdjustFormDataSourceField && dimAdjustFormDataSourceField.mapSort && dimAdjustFormDataSourceField.mapSort.hasOwnProperty(table))
        {
          mapSort = dimAdjustFormDataSourceField.mapSort[table];
        }
        
      }
      var mapSortDemi = {};var mapSortCpy = {};
      for(var cmp in mapSort)
      {
        var arrayItemsCpy = [];
        
        var cmpaitems = mapSort[cmp];
        
        for(let kk = 0;kk<cmpaitems.length;kk++)
        {
          arrayItemsCpy[kk] = cmp+"."+cmpaitems[kk];
          mapSortDemi[arrayItemsCpy[kk]] = true;
        }
        mapSortCpy[cmp] = arrayItemsCpy;
      }
      var array = [];
      for(let j = 0;j<formDataSourceFields.length;j++)
      {
        let formDataSourceField = formDataSourceFields[j];
        let _name = formDataSourceField.name;
        if(formDataSourceField.type=="Component" && _name.indexOf(".") == -1)
        {
          if(mapSortCpy && mapSortCpy.hasOwnProperty(_name))
          {
            var dataTypeArrayItems = mapSortCpy[_name];
            for(let k = 0;k<dataTypeArrayItems.length;k++)
            {
              let dataTypeArrayItem = dataTypeArrayItems[k];

              let arrayItemDataSourceField = null;
              for(let n = 0;n<formDataSourceFields.length;n++)
              {
                if(formDataSourceFields[n].name == dataTypeArrayItem)
                {
                  arrayItemDataSourceField = formDataSourceFields[n];break;
                }
              }               
              if(arrayItemDataSourceField)
              {
                array.push(arrayItemDataSourceField);
              }
              else
              {
                Warning.show("跟拒二次开发中的mapSort中的名称未能找到对应的FormDataSourceField:"+ dataTypeArrayItem  +" 请确认二次开发是否有误");
              }
            }
          }
          continue;
          
        }
        if(_name.indexOf(".")!=-1 && mapSortDemi.hasOwnProperty(_name))
          continue;
        array.push(formDataSourceField);
      }
      
      for(let j = 0;j<array.length;j++)
      {
        let formDataSourceField = array[j];
        let _name = formDataSourceField.name;          
        if(mapVisible && mapVisible.hasOwnProperty(_name) && mapVisible[_name] == false)
          continue;
          
        let origdataSourceField = StringUtil.convertToEachFirstLowerCase(_name);
        let dataSourceField = origdataSourceField.replace(".","-");
        let _dataField = table+"-"+dataSourceField;
        let _recDataField = table+"."+dataSourceField;
        if(filter && filter.indexOf(_recDataField)!=-1)continue;
        var flag = false;
        for(let k = 0;k<columns.length;k++)
        {
          let column = columns[k];
          if(column.dataField == _dataField || column.dataField == _recDataField)
          {
            flag = true;
            break;
          }
        }
        if(!flag)
        {
          var fe = this.findItemByDataField(_recDataField);
          var _label;var _totalLabel;
          if(!fe)
          {
            if(formDataSourceField)
            {
              _label = (mapLabel&&mapLabel.hasOwnProperty(_name))?mapLabel[_name]:GOTUtil.getFinalValue(formDataSourceField,window.formXML,"Label");
              if(isNeedTableName)
              {
                var fds = formDataSource.xml;
                var tableName = GOTUtil.getPropertyValue(fds,"Table");
                var tableXML = GOT.getTable(tableName);
                tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
                _totalLabel = tableLabel + "." + _label;
              }
              else
              {
                _totalLabel = _label;
              }
              let obj = {label:_label,selected:true,dataField:table+"-"+dataSourceField,totalLabel:_totalLabel,fdsfId:formDataSourceField.id,formItemId:"",isDataMethod:false,fieldType:formDataSourceField.type};
              if(obj.fieldType == "Decimal")
                obj.numOfDecimals = GOTUtil.getFinalValue(formDataSourceField,this.formDataSources.formModule.props.xml,"NumOfDecimals");
              result.push(obj);
            }
          }
          else
          {
            if(fe.getProperty_Visible_FinalWithOutUserSet())
            {
              _label = (mapLabel&&mapLabel.hasOwnProperty(_name))?mapLabel[_name]:fe.getProperty_Label(false);

              if(isNeedTableName)
              {
                var sourceName = fe.dataSource_Alias;
                for(let i = 0;i<this.sources.length;i++)
                {
                  var source = this.sources[i];
                  if(source.alias == sourceName)
                    break;
                }
                if(source.alias != sourceName)
                  continue;
                tableName = GOTUtil.getPropertyValue(source.xml,"Table");
                tableXML = GOT.getTable(tableName);
                tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
                _totalLabel = tableLabel + "." + _label;
              }
              else
              {
                _totalLabel = _label;
              }
              let obj = {
                    label:_label,selected:true,dataField:table+"-"+dataSourceField,totalLabel:_totalLabel,
                    fdsfId:formDataSourceField?formDataSourceField.id:"",formItemId:fe.innerId,isDataMethod:fe.isDataMethodField,fieldType:_fieldType
                  };
              var _type = fe.xml.type;
              var _fieldType = _type.substr(0,_type.length-"Editor".length);
              if(fe.classAlias == "FormItemDecimalEditorControl")
                obj.numOfDecimals = fe.getProperty_NumOfDecimals();
              result.push(obj);
            }
            
            
          }
        }
      }
    }

    for(let key in FormItemUtil.formItemControlsForFor)
    {
      let fe = FormItemUtil.formItemControlsForFor[key];
      
      if(fe && fe.isDataMethodField)
      {
        let _dataField = fe.dataSource_Alias + "-" + fe.dataSource_Field;
        let _dataField1 = fe.dataSource_Alias + "." + fe.dataSource_Field;
        let flag = false;
        for(let i = 0;i<columns.length;i++)
        {
          let column = columns[i];
          if(column.dataField == _dataField || column.dataField == _dataField1)
          {
            flag = true;
            break;
          }
        }
        
        if(!flag)
        {
          let _type = fe.xml.type;
          let _fieldType = _type.substr(0,_type.length-"Editor".length);
          let _label = fe.getProperty_Label(false);
          let source;
          if(isNeedTableName)
          {
            let sourceName = fe.dataSource_Alias;
            for(let i = 0;i<this.sources.length;i++)
            {
              source = this.sources[i];
              if(source.alias == sourceName)
                break;
            }
            if(source.alias != sourceName)
              continue;
            tableName = GOTUtil.getPropertyValue(source.xml,"Table");
            tableXML = GOT.getTable(tableName);
            tableLabel = GOTUtil.getFinalValue(tableXML,tableXML,"Label");
            _totalLabel = tableLabel + "." + _label;
          }
          else
          {
            _totalLabel = _label;
          }
          let obj2 = {label:_label,selected:true,dataField:_dataField,totalLabel:_totalLabel,fdsfId:"",formItemId:fe.innerId,isDataMethod:true,fieldType:_fieldType};
          if(fe.classAlias == "FormItemDecimalEditorControl")
            obj2.numOfDecimals = fe.getProperty_NumOfDecimals();
          result.push(obj2);
        }
      }
    }
    
    return result;
  }

  findItemByDataField(df)
  {
    for(var key in FormItemUtil.formItemControlsForFor)
    {
      var formItemControl = FormItemUtil.formItemControlsForFor[key];
      if(formItemControl.classAlias.indexOf("Editor")!=-1 && formItemControl.group == this &&  formItemControl.getDataField() == df)
      {
        return formItemControl;
      }
    }
    return null;
  }

  clearTempRecord()
  {
    if(this.mainSource.isTempTable == false)
      return;
    this.records = [];
    if(this.tempRecordsFilter)this.tempRecordsFilter = null;
    RecordsActions.recordsCmp(this.records,this.groupAlias,this);
  }

  deleteTempRecords(_queryTable)
  {
    if(this.mainSource.isTempTable == true && _queryTable)
    {
      var mainAlias = this.mainSource.alias;var locateNextRecId = "";var flag = 0;
      
      let thisRecords = this.tempRecordsFilter?this.tempRecordsFilter:this.records;

      var length = thisRecords.length;var _records = [];var recIds = [];var next;var pre;var dontLocate = false;
      
      for(let i = 0;i<thisRecords.length;i++)
      {
        let record = thisRecords[i];
        if(this.analysisSingleRecord(record,_queryTable) == true)
        {
          let __recId = record[mainAlias+".recId"];
          recIds.push(__recId);
          _records.push(record);
        }
      }
      //_records是被删除的记录
      if(thisRecords.indexOf(this.currentRecord)==-1)
      {
        dontLocate = true;
      }
      
      for(let i = 0;i<_records.length;i++)
      { 
        let record = _records[i];
        var index = thisRecords.indexOf(record);
        if(!locateNextRecId && !dontLocate)
        {
          if(index>0)
          {
            pre = thisRecords[index-1];//getItemAt(index-1)[mainAlias];
          }
          else
          {
            pre = null;
          }
          
          if(pre != null)
          {
            var preRecId = pre[mainAlias+".recId"];
            if(recIds.indexOf(preRecId) == -1)
              locateNextRecId = preRecId;
          }
          
          if(!locateNextRecId)
          {
            if(index<length-1)
            {
              next = thisRecords[index+1];
            }
            else
            {
              next = null;
            }
            
            if(next)
            {
              var nextRecId = next[mainAlias+".recId"];
              if(recIds.indexOf(nextRecId) == -1)
                locateNextRecId = nextRecId;
            }
          }
        }
        
        thisRecords.splice(index,1);
        //this.dataProvider.removeItemAt(index);
        length --;
        flag++;
      }

      if(this.tempRecordsFilter)
      {
        for(let i = 0;i<recIds.length;i++)
        {
          let deletedrecId = recIds[i];
          let deletedRecord = this.mapRecId[deletedrecId];
          if(deletedRecord)
          {
            let deletedIndex = this.records.indexOf(deletedRecord);
            if(deletedIndex>-1)
              this.records.splice(deletedIndex,1);
          }
        }
      }

      //dataProvider.refresh();
      RecordsActions.recordsCmp(thisRecords,this.groupAlias,this);
      if(dontLocate == false)
      {
        var located = false;
        if(!locateNextRecId)
        {
          this.setCurrentRecord(null);
          located = true;
        }
        else
        {
          for(let i = 0;i<thisRecords.length;i++)
          {
            var r = thisRecords[i];
            let _locateNextRecId = r[this.mainSource.alias+".recId"]
            if(_locateNextRecId==locateNextRecId)
            {
              this.setCurrentRecord(r);
              located = true;
              break;
            }
          }
        }
        
        if(located == false)
        {
          if(thisRecords.length>0)
            this.setCurrentRecord(thisRecords[0]);
          else
            this.setCurrentRecord(null);
        }
      }
      
      /*var revent:FormRecordEvent = new FormRecordEvent(FormRecordEvent.RECORD_OPR,true);
      revent.info = "删除成功:" + flag.toFixed() + "条记录";
      revent.oprType = RecordOprType.del;
      this.formDataSources.formModule.dispatchEvent(revent);*/
    }
  }

  addTempRecords(ac)
	{
    if(ac == null || this.mainSource.isTempTable == false)
      return;
    
    var fdsgr = new FormDataSourceGroupResult();
    fdsgr.aliasList = [];fdsgr.aliasList.push(this.groupAlias);fdsgr.groupAlias = this.groupAlias;fdsgr.recordCounts = ac.length;fdsgr.dataResult = ac;
    
    this.formatFormDataSourceGroupResult(fdsgr);
    var isFirst = false;
    if(!this.records)
    {
      this.records = [];
    }
    
    if(this.records.length == 0)
    {
      isFirst = true;
    }
    
    var newRecords = fdsgr.dataResult;
   
    for(let i = 0;i<newRecords.length;i++)
    {
      let item = newRecords[i];
      var _recId = item[this.groupAlias+".recId"];
      this.mapRecId[_recId] = item;
      this.recordsBak[_recId] = Object.assign({},item);
    }
    
    this.records = this.records.concat(newRecords);
    //如果已有被用户筛选过的记录(在临时表上进行过查询器查询) 此为最高优先级
    //如果没有筛选过 又有默认查询条件 则默认查询条件第一次起作用 二者均使用同一变量this.tempRecordsFilter
    if(this.tempRecordsFilter && this.tempRecordsFilter.length>0)
    {
      var _analysisSingleRecord = this.analysisSingleRecord.bind(this);
      let _queryTable = this.getCurrentQueryTable();
      _queryTable.queryRelations = null;
      let _recordsFilter = newRecords.filter(
                  function(item)
                  {
                    return _analysisSingleRecord(item,_queryTable,false);
                  }
      );
      this.tempRecordsFilter = this.tempRecordsFilter.concat(_recordsFilter);
    }
    else if(this.hasTempDefaultQuery)
    {
      var _analysisSingleRecord = this.analysisSingleRecord.bind(this);
      let _queryTable = this.getCurrentQueryTable();
      _queryTable.queryRelations = null;
      let _recordsFilter = newRecords.filter(
                  function(item)
                  {
                    return _analysisSingleRecord(item,_queryTable,false);
                  }
      );
      if(!this.tempRecordsFilter)this.tempRecordsFilter = [];
      this.tempRecordsFilter = this.tempRecordsFilter.concat(_recordsFilter);
    }
    let _records = this.tempRecordsFilter?this.tempRecordsFilter:this.records;
    RecordsActions.recordsCmp(_records,this.groupAlias,this);
    if(isFirst)
    {
      this.setCurrentRecord(this.records.length>0?this.records[0]:null);
    }

  }

  refreshTempRecordPartly(ac)
  {
    if(ac == null || this.mainSource.isTempTable == false)
      return;
    //alert(ac.length); 
    var fdsgr = new FormDataSourceGroupResult();
    fdsgr.aliasList = [];fdsgr.aliasList.push(this.groupAlias);fdsgr.groupAlias = this.groupAlias;fdsgr.recordCounts = ac.length;fdsgr.dataResult = ac;
    
    this.formatFormDataSourceGroupResult(fdsgr);
    var isFirst = false;
    if(!this.records)
    {
      this.records = [];
    }
    var origIndex = -1;
    if(this.records.length == 0)
    {
      isFirst = true;
    }
    else
    {
      origIndex = this.tempRecordsFilter?this.tempRecordsFilter.indexOf(this.currentRecord)
                                        :this.records.indexOf(this.currentRecord);
    }
    
    var newRecords = fdsgr.dataResult;
   
    for(let i = 0;i<newRecords.length;i++)
    {

      let item = newRecords[i];
      this.replaceRecord3(item);
      var _recId = item[this.groupAlias+".recId"];
      this.mapRecId[_recId] = item;
      this.recordsBak[_recId] = Object.assign({},item);
    }
    
    //this.records = newRecords.concat();
    let _records = (this.tempRecordsFilter?this.tempRecordsFilter:this.records);
    RecordsActions.recordsCmp(_records,this.groupAlias,this,true);
    if(isFirst)
    {
      this.setCurrentRecord(_records.length>0?_records[0]:null);
    }
    else
    {
      if(origIndex == -1)origIndex = 0;
      this.setCurrentRecord(_records.length>origIndex?_records[origIndex]:null);
    }
  }
  
  refreshTempRecord(ac)
  {
    if(ac == null || this.mainSource.isTempTable == false)
      return;
    
    var fdsgr = new FormDataSourceGroupResult();
    fdsgr.aliasList = [];fdsgr.aliasList.push(this.groupAlias);fdsgr.groupAlias = this.groupAlias;fdsgr.recordCounts = ac.length;fdsgr.dataResult = ac;
    
    this.formatFormDataSourceGroupResult(fdsgr);
    var isFirst = false;
    if(!this.records)
    {
      this.records = [];
    }
    
    if(this.records.length == 0)
    {
      isFirst = true;
    }
    
    var newRecords = fdsgr.dataResult;
   
    for(let i = 0;i<newRecords.length;i++)
    {
      let item = newRecords[i];
      var _recId = item[this.groupAlias+".recId"];
      this.mapRecId[_recId] = item;
      this.recordsBak[_recId] = Object.assign({},item);
    }
    
    this.records = newRecords;
    RecordsActions.recordsCmp(this.records,this.groupAlias,this);
    if(isFirst)
    {
      this.setCurrentRecord(this.records.length>0?this.records[0]:null);
    }

    return;
    if(ac == null || this.mainSource.isTempTable == false)
      return;
    //alert(ac.length); 
    var fdsgr = new FormDataSourceGroupResult();
    fdsgr.aliasList = [];fdsgr.aliasList.push(this.groupAlias);fdsgr.groupAlias = this.groupAlias;fdsgr.recordCounts = ac.length;fdsgr.dataResult = ac;
    
    this.formatFormDataSourceGroupResult(fdsgr);
    var isFirst = false;
    if(!this.records)
    {
      this.records = [];
    }
    
    if(this.records.length == 0)
    {
      isFirst = true;
    }

    
    var newRecords = fdsgr.dataResult;
   
    for(let i = 0;i<newRecords.length;i++)
    {

      let item = newRecords[i];

      /*var ac = this.records;
      if(!ac)
        throw new Error("ac==null");
      
      var mainAlias = this.groupAlias;
      var recId = record[mainAlias+".recId"];
      if(!this.mapRecId.hasOwnProperty(recId))
        throw new Error("mapRecId中不存在" + recId);
      
      var origRecord = this.mapRecId[recId];
      if(replaceAttr)
      { 
        if(origRecord==null)
        {
          alert("origRecord null");
        }
        else if(record==null)
        {
          alert("record null when replaceRecord");
        }
        else
        {
          this.replaceRecordValue(record,origRecord);
        }
      }
      else
      {
        var index = ac.indexOf(origRecord);
        if(index==-1)
          alert("index==-1  " + recId);
        ac[index] = record;
      }*/

      this.replaceRecord3(item);
      var _recId = item[this.groupAlias+".recId"];
      this.mapRecId[_recId] = item;
      this.recordsBak[_recId] = Object.assign({},item);
    }


    
    //this.records = newRecords.concat();
    RecordsActions.recordsCmp(this.records,this.groupAlias,this,true);
    if(isFirst)
    {
      this.setCurrentRecord(this.records.length>0?this.records[0]:null);
    }
  }

  /*refreshTempRecord(ac)
	{
    let that = this;
    setTimeout(

      function()
      {
        that.refreshTempRecord2(ac);
      },
      2000
    );
  }*/
  
  anyRecordValue2(field,value = null ,record = null)
  {
    var index = 0;
    var group = this;
    while(field.charAt(index) == ".")
    {
      if(index == 0)
      {
        index ++ ;
        continue;
      }
      group = group.linkGroup;
      if(!group)
        return value;
      index ++;
    }
    if(!record)
      record = group.currentRecord;
    if(!record)
      return null;
    field = field.substr(index);
    if(field.indexOf(".") != -1)
    {
      if(field.indexOf(".")>2){
        field = group.groupAlias+"."+StringUtil.convertToFirstLowerCase(field);
      }else{
        field = StringUtil.convertToEachFirstLowerCase(field.substr(index));
        field = StringUtil.convertToFirstUpperCase(field);
      }
    }
    else
    {
      field = group.groupAlias + "." + StringUtil.convertToFirstLowerCase(field);
    }
    
    return record[field];
  }

  analysisConditionSingleRecord(item,jca)
  {
    
    if(!jca)return true;
    if(!item)item = this.currentRecord;
    if(!item && jca.isNull == true)return true;
    if(!item)return false;
    if(!jca.getSqlWhereStr)
      jca.getSqlWhereStr = RecordConditionTask.getSqlWhereStr;
    var ws = jca.getSqlWhereStr();
    if(ws == "")
      return true;
    var wsa = ws.split(" ");
    var wsr = "";
    for(let i = 0;i<wsa.length;i++)
    {
      let s = wsa[i];
      if(s.indexOf("=") == -1)
      {
        wsr += s;
      }
      else
      {
        var fn = StringUtil.convertToFirstLowerCase(s.substring(0,s.indexOf("=")));
        var fv = s.substr(s.indexOf("=")+1);
        
        if(fn.indexOf(".") != 0)
          continue;
        var value = this.anyRecordValue2(fn,null,item);
        
        if(fv.indexOf(".") == 0)
          fv = this.anyRecordValue2(fv,null,item);
        
        if(RecordsUtil.analysisValue(value,fv))
          //(String(item[groupAlias][fn]) == fv)
        {
          wsr+="1";
        }
        else
        {
          wsr+="0";
        }
      }
      
    }
    
    return StringUtil.evalLEString(StringUtil.trimThrough(wsr));
  
  }


  analysisConditionSingleRecord1(item,recordCondition,isFloat = false)
  {
    if(recordCondition == null)
      return true;
    if(item == null)
      item = this.currentRecord;
  
    if(item == null)
      return false;
    if(!recordCondition.getSqlWhereStr)
      recordCondition.getSqlWhereStr = RecordCondition.getSqlWhereStr;
    var ws = recordCondition.getSqlWhereStr();
    if(ws == "")
      return true;
    var wsa = ws.split(" ");
    var wsr = "";
    for(let i = 0;i<wsa.length;i++)
    {
      let s = wsa[i];
      if(s.indexOf("=") == -1)
      {
        wsr += s;
      }
      else
      {
        var fn = StringUtil.convertToFirstLowerCase(s.substring(0,s.indexOf("=")));
        var fv = s.substr(s.indexOf("=")+1);
        
        if(fn.indexOf(".") != 0)
          continue;
        var value = this.anyRecordValue2(fn,null,item);
        
        if(fv.indexOf(".") == 0)
          fv = this.anyRecordValue2(fv,null,item);
        
        if(isFloat)
        {
          if(value.indexOf(".")!=-1)
          {
            value = StringUtil.trimRight(String(value),"0");
            if(value.charAt(value.length-1)==".")
              value = value.substr(0,value.length-1);
          }
          if(fv.indexOf(".")!=-1)
          {
            fv = StringUtil.trimRight(fv,"0");
            if(fv.charAt(fv.length-1)==".")
              fv = fv.substr(0,fv.length-1);
          }
        }
        
        if(RecordsUtil.analysisValue(value,fv))
        {
          wsr+="1";
        }
        else
        {
          wsr+="0";
        }
      }
      
    }
    
    return StringUtil.evalLEString(StringUtil.trimThrough(wsr));
  }

  findValue(dataField,filterValue)
  {
    if(window.isDataSetView){
      this.dataSetQueryTable.queryAllFields =[];
      this.getQueryFiledAllItemsForDataSetView(this.dataSetQueryTable);
      this.queryFilterForSetData(dataField,"","",this.dataSetQueryTable,filterValue); 
    }else{
      QueryUtil.findOrCreateWhereItem(dataField,this.currentQuery,filterValue);
      this.reSetCurrentQuery(this.currentQuery);
    }
    this.executeQueryAutoSaveStop(null);
  }

  setFieldModifiedNewValue(records,record,aliasName,fieldName,componentItemName,newValue)
  {
    for(let i = 0;i<records.length;i++)
    {
      let item = records[i];
      let itemRecId = item[aliasName]['recId'];
      let baseRecId = record[aliasName+'.recId'];
      if(itemRecId == baseRecId)
      {
        //let newValueField = componentItemName?(aliasName+"."+fieldName+"."+componentItemName):(aliasName+"."+fieldName);
        if(componentItemName)
        {
          item[aliasName][fieldName][componentItemName] = newValue;
        }
        else
        {
          item[aliasName][fieldName] = newValue;
        }
        
        break;
      }
    }
  }

  doFieldModifiedRemote(aliasName,fieldName,componentItemName,oldValue,newValue,dataField,record,component,extralParms = {})
  {
    console.log("doFieldModifiedRemote");
    let fullFieldName;
    let fullFieldName2;
    let result = true;
    var methodName = "";
    var dataSourceFieldHasDot = false;
    //插件内部节点带点
    if(extralParms.formDataSourceField)
    {
      var ns = "";var fieldName2 = "";
      let dataSourceFieldId = extralParms.formDataSourceField.id;
      if(dataSourceFieldId.indexOf(".") != -1)
      {
        let arr = dataSourceFieldId.split(".");
        arr.pop();
        ns = arr.join(".");var ns2 = arr.join("_");
        let dataSourceFieldName = extralParms.formDataSourceField.name;
        if(dataSourceFieldName)
        {
          let trueFieldName = dataSourceFieldName.substr(ns.length+1);
          fullFieldName2 = ns+"."+trueFieldName;
          fullFieldName = ns2+"$"+StringUtil.replaceAll(trueFieldName, ".","_");
          dataSourceFieldHasDot = true;
        }
      }
    }
    if(!dataSourceFieldHasDot)//FormDataSourceField不带点号 按原逻辑处理
    {
      if(componentItemName==null)
        fullFieldName = StringUtil.convertToFirstUpperCase(fieldName);
      else
        fullFieldName = StringUtil.convertToFirstUpperCase(fieldName) + "." + StringUtil.convertToFirstUpperCase(componentItemName);
      methodName = aliasName + ".modifiedField_"+StringUtil.replaceAll(fullFieldName, ".","_");
    }
    else//FormDataSourceField带点号 又是另外一种逻辑
    {
      methodName = aliasName + ".modifiedField_"+fullFieldName;
      fullFieldName = fullFieldName2;
    }
   
    if(fullFieldName==null)
    {
      alert("fullFieldName null");
    }
    if(!record)
    record = this.currentRecord;
    var args = [oldValue,newValue,record,null,null];
		LayerManager.executeLayerMethod(this.formDataSources.formModule,this.formDataSources.currentGroup,"modifiedField_"+StringUtil.replaceAll(fullFieldName, ".","_"),args);
   var mi = FormResourceUtil.getCommandArgMethodInfo(methodName,this.formDataSources.formModule.menuItemId,this.formDataSources.formModule.formId);
    if(mi)
    {
      var arg = new FormDataSourceGroupArg();
      arg.argType = 0;
      arg.groupAlias = this.groupAlias;
      arg.aliasList = [];
      arg.arg = {};
      if(!record)
        record = this.currentRecord;
      arg.arg[0] = RecordsUtil.getSecondaryRecord1(record,this.mainSource.alias,StringUtil.convertToFirstLowerCase(fieldName),StringUtil.convertToFirstLowerCase(componentItemName),newValue);
      arg.aliasList.push(this.mainSource.alias);
      arg.recordCounts = 1;
      let extparms = {};
      if(extralParms.dynamicColumn == true)
        extparms.ignoreFetchOption = true;
      var commandArg = CommandResolver.getSendCmd(this.formDataSources.formModule, this.groupAlias, mi,extparms);
      if(extralParms.dynamicColumn == true&&commandArg)
        commandArg.argObject = extralParms.dynamicKey;
      
      if(commandArg && commandArg.mapGroups)
      {
        try
        {
          for(var key in commandArg.mapGroups)
          {
            if(key == this.groupAlias)
            {
              var gi = commandArg.mapGroups[key];
              if(gi)
              {
                if(gi.selectedRecords)
                {
                  this.setFieldModifiedNewValue(gi.selectedRecords,record,aliasName,
                    fieldName,componentItemName,newValue);
                }
                if(gi.allRecords)
                {
                  this.setFieldModifiedNewValue(gi.allRecords,record,aliasName,
                    fieldName,componentItemName,newValue);
                }
              }
            }
          }
        }
        catch(e)
        {
          
        }
        
      }
      let _editorName = extralParms.editorName;
     
      let _rpc_fault_doFieldModifield = this.rpc_fault_doFieldModified.bind(this);
      let _rpc_result_doFieldModified = this.rpc_result_doFieldModified.bind(this);
      this.fullFieldName = fullFieldName;
      let _that=this;
      ServiceHelper.addTokenWithCommand({
        command:CommandHelper.createFormInstance(this.formDataSources.formModule.formName,"doFieldModified")
        .appendArg(_editorName?_editorName:"","String")
        .appendArg(fullFieldName, "String")
        .appendArg(oldValue+"","Object")
        .appendArg(newValue+"","Object")
        .appendArg(commandArg, "CommandArg")
        .appendArg(arg, "FormDataSourceGroupArg"),
        resultFunction:function(data)
        {
          //TODO存在modifiedField之后刷新DataGrid的情况并且与自动保存存在冲突 所以延迟500ms解决同步问题
          //setTimeout(function(){_rpc_result_doFieldModified(data,record);},200);
          _rpc_result_doFieldModified(data,record,_that.fullFieldName);
          //TODO此处不知道为何会返回false 导致调用者不返回新值 但是根据 1.回送值 2.自动保存 3.执行modified二次开发的顺序 此处不对  所以改为true
          result = true;
        },
        //resultFunction:this.rpc_result_doFieldModified.bind(this),
        faultFunction:function(faultEvent)
        {
          _rpc_fault_doFieldModifield(faultEvent,oldValue,newValue,component);
          result = false;
        }//,sync:extralParms.async?false:true
      });
    }
    return result;
  }

  rpc_fault_doFieldModified(faultEvent,oldValue,newValue,component)
  {
    var faultString;
    if(faultEvent && faultEvent.successButNot0)
    {
       faultString = faultEvent.errText;
       //Warning.show({text:data.errText,title:"画面初始查询失败"});
    }
    else
    {
      faultString = "可能是网络错误 请检查网络是否正常";
       //Warning.show({text:"请检查网络是否正常或联系管理员",title:"变更值失败"});
    }

    //var faultString = faultEvent;
    if(component && typeof(component.restoreValue) == "function")
    {
      component.restoreValue(oldValue);
    }
    //record[dataField] = oldValue;
    Warning.show({text:
      "变更值失败：" + oldValue + " -> " + newValue 
      + "<br/>" + "现已恢复到：" + oldValue
      + "<br/>" + "错误原因为：" + faultString,title:"此次操作未能成功"});
  }

  rpc_result_doFieldModified(data,record,itemName=null)
  {
    if(!this.records)
      return;
    var result = data.result;
    if(!result.dataResult)
      return;
    
    var obj = result.dataResult.length>0?result.dataResult[0]:null;
    if(!obj)
      return;
    
    this.formatFormDataSourceGroupResult(result,"modified");
    
    if(result.dataResult)
    {
      if(!record)record = this.currentRecord;
      var currentIndex = this.records.indexOf(record);
      var flag = this.local_fieldModified(result.dataResult,itemName);
      /*TODO 为何？if(currentIndex!=-1)
      {
        this.currentRecord = this.dataProvider.getItemAt(currentIndex);
      }
      if(result.autoSaveRecord)
      {
        doDelayRecordSave();
      }
      else
      {
        inFieldModified = false;
        if(saveDelay)
        {
          saveDelay = false;
          callBackFunCache = null;
          callBacFunCacheArgs = null;
        }
      }*/
      CommandResolver.resolve(result.commandResult.tasks,this.formDataSources.formModule,this);
    }
    else
    {
      alert("字段修改失败，返回null");
    }
    
  
  }
    
  local_fieldModified(ac,fullitemName=null)
  {
    var mainAlias = this.mainSource.alias;
    var flag = 0;
    var recordCounts = 1;
    
    var record = ac[0];
 
    /*if(record["NumberSequenceTable.maxNum"] == 0 || record["NumberSequenceTable.minNum"] == 0)
    {
      alert("后台返回没改");
    }*/
    var mainAlias = this.groupAlias;
    var recId = record[mainAlias+".recId"];
    if(!this.mapRecId.hasOwnProperty(recId))
      throw new Error("mapRecId中不存在" + recId);
    
    var origRecord = this.mapRecId[recId];
    
    if(origRecord==null)
    {
      alert("origRecord null");
    }
    else if(record==null)
    {
      alert("record null when replaceRecord");
    }
    else
    {
      //console.log("发生modifiedField------"+recId);
      for (var itemName in record)
      {
        var item = record[itemName];
        let oldValue = origRecord[itemName]; 
        let changed =  oldValue != item;
        origRecord[itemName] = item;
        if(changed){
          RecordsActions.RecordFieldChanged(origRecord,itemName,oldValue,item,null);
        }else if(itemName.substring(itemName.lastIndexOf(".")+1) == StringUtil.convertToFirstLowerCase(fullitemName)){
          RecordsActions.RecordFieldChanged(origRecord,itemName,oldValue,item,null);
        }
      }

     

      //TODO innerJoin LeftJoin的关联更改 如果后台没有关联就返回的 现有记录的关联字段置为空
      if(record)
      {
        for(var origItemName in origRecord)
        {
          if(!record.hasOwnProperty(origItemName))
          {
            let oldValue = origRecord[origItemName];
            origRecord[origItemName] = "";
            if(oldValue)
              RecordsActions.RecordFieldChanged(origRecord,origItemName,oldValue,"",null);
          }
        }
      }
      
    }
    return flag;
  }

  checkDataSourceField2FormItem(dataSourceField,formDataSource)
  {
    for(let key in FormItemUtil.formItemControlsForFor)
    {
      let formItem = FormItemUtil.formItemControlsForFor[key];
      if(formItem.type && formItem.type.indexOf("Editor")!=-1)
      {
        var ext = GOTUtil.getPropertyValue(formItem.xml,"Extends");
        var ds = GOTUtil.getPropertyValue(formItem.xml,"DataSource");
        
        if(ext && ds && ext == dataSourceField.name && ds == formDataSource.xml.name)
        {
          if(formItem.getProperty_Visible_Final())
            return true;  
          else
            return false;
        }
      }
    }
    return false;
  }

  getFormDataSourcesExpInnerJoin(_group = null)
  {
    if(_group == null)
      _group = this;
    var dataSourceFields = [];
    let _parentWindow = window.parent.window;
    for(let i = 0;i<_group.sources.length;i++)
    {
      let formDataSource = _group.sources[i];
      let notComponentFields = GOTUtil.getNotComponentFormDataSourceFields(formDataSource.xml);
      for(let k = 0;k<notComponentFields.length;k++)
      {
        let xml = notComponentFields[k];
        var au = AuthorityUtil.getXmlType2SCacheItem(window.menuItemId,xml.id,"visible");
        if(!au["result"]||GOTUtil.getFinalValue(xml,this.formDataSources.formModule.props.xml,"Visible") == false)
        {
          continue;
        }
        
        if(!_parentWindow.userInfos.isAdmin && formDataSource != this.mainSource)
        {
          if(!this.checkDataSourceField2FormItem(xml,formDataSource))
            continue;
        }
        
        dataSourceFields.push(xml);
      } 
      
    }
    
    return dataSourceFields;
  }

  getDataMethodFormItem(_dataField)
  {
    for(let key in FormItemUtil.formItemControlsForFor)    
    {
      let item  = FormItemUtil.formItemControlsForFor[key];
      if(item.classAlias.indexOf("Editor")!=-1)
      {
        if(item.dataField == _dataField)
          return item;
      }
    }
    return null;
  }

  getAggregateFormDataSourcesExpInnerJoin(_group = null)
  {
    if(!_group)
      _group = this;
    var dataSourceFields = [];
    for(let i = 0;i<_group.sources.length;i++)
    {
      let formDataSource = _group.sources[i];
      for(let k = 0;k<formDataSource.xml.FormDataSourceFields.length;k++)
      {
        let xml = formDataSource.xml.FormDataSourceFields[k];
        let field = StringUtil.convertToFirstLowerCase(xml.name);
        if(this.aggreateTableFields.indexOf(field) == -1)
        {
          continue;
        }
        let au = AuthorityUtil.getXmlType2SCacheItem(this.formDataSources.formModule.menuItemId,
                  xml.id,"visible");

        if(!au["result"]||
          GOTUtil.getFinalValue(xml,window.formXML,"Visible") == "false"
        )
        {
          continue;
        }

        if(formDataSource != this.mainSource)
        {
          if(!this.checkDataSourceField2FormItem(xml,formDataSource))
            continue;
        }

        dataSourceFields.push(xml);

      }
    }
    return dataSourceFields;
  }

  showCurRecTotalAggreateTable(filter=null)
  {
    if(!this.currentRecord)
      return;
    var data = this.currentRecord;
    var dataSourceFields = this.getAggregateFormDataSourcesExpInnerJoin();
    var dataSourceFieldsCollection = dataSourceFields;
    var dataProvider = [];
    var dataMethodFields = [];
    var cacheValue = "";
    for(var key in data)
    {
      var value = data[key];
      var keyarr = key.split(".");
      var table = keyarr[0];
      var fieldLabel = ""; var fieldName = "";
      if(keyarr.length == 2)
      {
        let labelsuffix = "";
        var dataSourceField = StringUtil.convertToFirstUpperCase(keyarr[1]);
        if(dataSourceField.indexOf("Aggregate_Sum_")==0)
        {
          dataSourceField = dataSourceField.substr(14); labelsuffix = "(合计)";
        }
        else if(dataSourceField.indexOf("Aggregate_Avg_")==0)
        {
          dataSourceField = dataSourceField.substr(14); labelsuffix= "(平均值)";
        }
        else if(dataSourceField.indexOf("Aggregate_Max_")==0)
        {
          dataSourceField = dataSourceField.substr(14); labelsuffix = "(最大值)";
        }
        else if(dataSourceField.indexOf("Aggregate_Min_")==0)
        {
          dataSourceField = dataSourceField.substr(14); labelsuffix = "(最小值)";
        }
        else if(dataSourceField.indexOf("Aggregate_Count_")==0)
        {
          dataSourceField = dataSourceField.substr(16); labelsuffix = "(计数)";
        }
        else if(dataSourceField.indexOf("Aggregate_Distinct_")==0)
        {
          dataSourceField = dataSourceField.substr(19); labelsuffix = "(不同值)";
        }
        else if(dataSourceField.indexOf("Aggregate_CountDistinct_")==0)
        {
          dataSourceField = dataSourceField.substr(24); labelsuffix = "(不同值计数)"
        }
        else if(dataSourceField.indexOf("Aggregate_Const_")==0)
        {
          dataSourceField = dataSourceField.substr(16); labelsuffix = "(约束)";
        }
        
        var resultObject = this.getFormDataSourceField(dataSourceField,table); 
        var dataSourceFieldXML = resultObject?resultObject.field:null;
        if(dataSourceFieldXML == null)
        {
          let _dataField = key;
          var formItemEditor =  this.getDataMethodFormItem(_dataField);
          if(formItemEditor != null)
            dataMethodFields.push({chLabel:formItemEditor.getProperty_Label(),enLabel:keyarr[1],fvalue:value});
          continue;
        }
        if(dataSourceFieldXML.type == "Component")
          continue;
        var childIndex = dataSourceFieldsCollection.indexOf(dataSourceFieldXML);
        if(childIndex == -1)
          continue;
        
        fieldLabel = GOTUtil.getFinalValue(dataSourceFieldXML,window.formXML,"Label")+labelsuffix;
        fieldName = dataSourceFieldXML.name;
        
        var fieldpXML = GOTUtil.getProperty(dataSourceFieldXML,"Field");
        var filterKey = fieldpXML.refentityid + fieldpXML.refinnerid;
        if(filter!=null && filter.indexOf(filterKey)!=-1)
        {
          cacheValue = "";	
        }
        else
        {
          this.saveFieldCache(dataSourceFieldXML,table+"-"+key);
          cacheValue = this.convertValue(value,table+"-"+key);
        }
        
        dataProvider[childIndex] = {chLabel:fieldLabel,enLabel:fieldName,fvalue:cacheValue};
      }
      else if(keyarr.length == 3)
      {
        var compDataSourceFieldName = StringUtil.convertToFirstUpperCase(keyarr[1]);
        var compDataSourceFieldXML = this.getFormDataSourceField(compDataSourceFieldName,table); 
        
        if(compDataSourceFieldXML == null)
          continue;
        
        //var compDataSourceFieldLabel = GOTHelper.getFinalValue(compDataSourceFieldXML,window.formXML,"Label");
        var okey = keyarr[2];
       
        if(this.aggreateDimTableFiels.indexOf(okey)==-1)
          continue;
        var ovalue = value;
        dataSourceField = StringUtil.convertToFirstUpperCase(keyarr[1])+"."+StringUtil.convertToFirstUpperCase(keyarr[2]);   
        compDataSourceFieldName = key.substr(0,1).toUpperCase() + key.substr(1);
        
        var labelsuffix = "";
        if(dataSourceField.indexOf("Aggregate_Sum_")==0)
        {
          dataSourceField = dataSourceField.substr(14); labelsuffix = "(合计)";
        }
        else if(dataSourceField.indexOf("Aggregate_Avg_")==0)
        {
          dataSourceField = dataSourceField.substr(14); labelsuffix= "(平均值)";
        }
        else if(dataSourceField.indexOf("Aggregate_Max_")==0)
        {
          dataSourceField = dataSourceField.substr(14); labelsuffix = "(最大值)";
        }
        else if(dataSourceField.indexOf("Aggregate_Min_")==0)
        {
          dataSourceField = dataSourceField.substr(14); labelsuffix = "(最小值)";
        }
        else if(dataSourceField.indexOf("Aggregate_Count_")==0)
        {
          dataSourceField = dataSourceField.substr(16); labelsuffix = "(计数)";
        }
        else if(dataSourceField.indexOf("Aggregate_Distinct_")==0)
        {
          dataSourceField = dataSourceField.substr(19); labelsuffix = "(不同值)";
        }
        else if(dataSourceField.indexOf("Aggregate_CountDistinct_")==0)
        {
          dataSourceField = dataSourceField.substr(24); labelsuffix = "(不同值计数)"
        }
        else if(dataSourceField.indexOf("Aggregate_Const_")==0)
        {
          dataSourceField = dataSourceField.substr(16); labelsuffix = "(约束)";
        }
        dataSourceFieldXML = this.getFormDataSourceField(dataSourceField,table); 
        
        if(dataSourceFieldXML == null)
        {
          continue;
        }
        childIndex = dataSourceFieldsCollection.indexOf(dataSourceFieldXML);
        if(childIndex == -1)
          continue;
        fieldLabel = GOTUtil.getFinalValue(dataSourceFieldXML,window.formXML,"Label") + labelsuffix;
        fieldName = dataSourceFieldXML.name;
        fieldpXML = GOTUtil.getProperty(dataSourceFieldXML,"Field");
        filterKey = fieldpXML.refentityid + fieldpXML.refinnerid;
        if(filter!=null && filter.indexOf(filterKey)!=-1)
        {
          cacheValue = "";	
        }
        else
        {
          this.saveFieldCache(dataSourceFieldXML,table+"-"+key+"-"+okey);
          cacheValue = this.convertValue(ovalue,table + "-"+key+"-" + okey);
        }
        
        dataProvider[childIndex] = {chLabel:fieldLabel,enLabel:fieldName,fvalue:cacheValue};
          
      }
    }
    return {dataMethodFields:dataMethodFields,dataProvider:dataProvider};
  }

  showCurRecTotal(filter = null,parms={})
  {
    var result;
    if(this.mainSource.isAggreateTable)
        result = this.showCurRecTotalAggreateTable(filter);
    else
        result = this.getRecTotalDataProvider(filter);
    if(!result)
      return;
    var dataMethodFields = result.dataMethodFields;
    var dataProvider = result.dataProvider;
    
    var _title = "详细信息 ";
    var _table = GOT.getTable(this.mainSource.tableId);
    var _tableNameLabel = GOTUtil.getFinalValue(_table,_table,"Label");
    _title+=_tableNameLabel;
    var _parentWindow = window.parent.window;
    if(_parentWindow.userInfos.isAdmin)
    {
      _title+=(" "+this.mainSource.tableName);
    }
    //TODO 使用concat？
    if(dataMethodFields.length>0)
    {
      var fdataProvider = [];
      for(let i in dataProvider)
      {
        let _item = dataProvider[i];
        fdataProvider.push(_item);
      }
      for(let i in dataMethodFields)
      {
        let _item = dataMethodFields[i];
        fdataProvider.push(_item);
      }
      var fdataProvider = fdataProvider;
      var tableName = this.mainSource.tableName;
      var self = this;
      var title = _title;
      // ReactDOM.render(<CurrentRecordInfo fdataProvider={fdataProvider} tableName={tableName} self={self} title={title}/>,document.getElementById('currentRecordInfoModal'));
      //  $("#currentRecordInfoModal").css("display","flex");
      CurrentRecordInfo.show(fdataProvider,tableName,self,title,parms);
    }
    else
    {
      fdataProvider = [];
      for(let i in dataProvider)
      {
        let _item = dataProvider[i];
        fdataProvider.push(_item);
      }
      var fdataProvider = fdataProvider;
      var tableName = this.mainSource.tableName;
      var self = this;
      var title = _title;
      // ReactDOM.render(<CurrentRecordInfo fdataProvider={fdataProvider} tableName={tableName} self={self} title={title}/>,document.getElementById('currentRecordInfoModal'));
      // $("#currentRecordInfoModal").css("display", "flex");
      CurrentRecordInfo.show(fdataProvider,tableName,self,title,parms);
    }

    console.log(fdataProvider);
  } 
  



  getRecTotalDataProvider(filter = null)
  {
    if(!this.currentRecord)
      return null;
    
    var data = this.currentRecord;
    var dataSourceFields = this.getFormDataSourcesExpInnerJoin(); 
    
    var dataSourceFieldsCollection = dataSourceFields;
    var dataProvider = [];
    var formXML = this.formDataSources.formModule.props.xml;
    var dataMethodFields = [];
    
    var mapLabel = null; var mapVisible = null; var mapSort = null;
    if(this.formDataSources.formModule.dimAdjustFormDataSourceField)
    {
      var dimAdjustFormDataSourceField = this.formDataSources.formModule.dimAdjustFormDataSourceField;
      mapLabel = dimAdjustFormDataSourceField.mapLabel;
      mapVisible = dimAdjustFormDataSourceField.mapVisible;
      mapSort = dimAdjustFormDataSourceField.mapSort;
      
    }
    for(var key in data)
    {
      var table = "";
      var fieldLabel = "";
      var fieldName = ""; 
      var tempResult;
      
      var keyarr = key.split(".");
     
      var value = data[key];
      table = keyarr[0];
      //插件内部节点带点 如果包含.号 如果大于3个点 则认为是带点号字段 并且找FormDataSourceField的时候要忽略大小写
      //跟普通字段处理方式一样
      if(keyarr.length==2 || keyarr.length>3)
      {
        var dataSourceField;
        if(keyarr.length == 2)
        {
          dataSourceField = StringUtil.convertToFirstUpperCase(keyarr[1]);
          tempResult = this.getFormDataSourceField(dataSourceField,table);
        }
        else
        {
          let firstdotIndex = key.indexOf(".");
          let keyarr1 = key.substr(firstdotIndex+1);
          dataSourceField = StringUtil.convertToFirstUpperCase(keyarr1);
          tempResult = this.getFormDataSourceField(dataSourceField,table,null,{ingoreCase:true});
        }
        
        
        var dataSourceFieldXML = tempResult?tempResult.field:null;
        
        //如果没有找到dataSourceField 则考虑其为一个DataMethod
        if(!tempResult)
        {
          var _dataField = key;//this.groupAlias+"."+key;
          var formItemEditor = this.getDataMethodFormItem(_dataField);
          if(formItemEditor)
          {
            var _editorType = formItemEditor.xml.type;
            var _fieldType = _editorType.substring(0,_editorType.length-6);
            //shift刚好大致按照Form上的FormItem排布顺序
            dataMethodFields.unshift({chLabel:formItemEditor.getProperty_Label(),enLabel:keyarr[1],fvalue:value+'',dataField:_dataField,fieldType:_fieldType});
          }
          continue;
        }

        //如果找到dataSourceField但是由于某些原因其不可见
        if(!dataSourceFieldXML)
        {
          continue;
        }

        var childIndex = dataSourceFieldsCollection.indexOf(dataSourceFieldXML);
        if(childIndex == -1)
          continue;
        fieldName = dataSourceFieldXML.name;
        if(mapVisible && mapVisible.hasOwnProperty(table) && mapVisible[table].hasOwnProperty(fieldName))
        {
          if(mapVisible[table][fieldName] == false)
            continue;
        }
        if(mapLabel && mapLabel.hasOwnProperty(table) && mapLabel[table].hasOwnProperty(fieldName))
        {
          fieldLabel = mapLabel[table][fieldName];
        }
        else
        {
          fieldLabel = GOTUtil.getFinalValue(dataSourceFieldXML,formXML,"Label"); 
        }
        
        var fieldpXML = GOTUtil.getProperty(dataSourceFieldXML,"Field");
        var filterKey = fieldpXML.refentityid + fieldpXML.refinnerid;
        if(filter && filter.indexOf(filterKey)!=-1)
        {
          cacheValue = "";  
        }
        else
        {
          this.saveFieldCache(dataSourceFieldXML,table+"-"+keyarr[1]);
          var cacheValue = this.convertValue(value+"",table+"-"+keyarr[1]);
        }
        
        dataProvider[childIndex]={dataSourceEnLabel:table,
          chLabel:fieldLabel,enLabel:fieldName,fvalue:cacheValue,dataField:key,
          fieldType:dataSourceFieldXML.type};    
      }
      else if(keyarr.length==3)
      { 
        var compDataSourceFieldName = StringUtil.convertToFirstUpperCase(keyarr[1]);
        tempResult = this.getFormDataSourceField(compDataSourceFieldName,table); 
        var compDataSourceFieldXML = tempResult?tempResult.field:null;
        
        if(!compDataSourceFieldXML)
          continue;
        
        //var compDataSourceFieldLabel = GOTUtil.getFinalValue(compDataSourceFieldXML,formXML,"Label");
        
        var compDataSourceFieldName = compDataSourceFieldXML.name;
        
        var compDataSourceFieldNames = [];
        for(let i = 0;i<dataSourceFieldsCollection.length;i++)
        {
          let field = dataSourceFieldsCollection[i];
          var compFieldName = field.name;
          if(compFieldName.indexOf(".")!=-1 && compFieldName.indexOf(compDataSourceFieldName) == 0)
          {
            compDataSourceFieldNames.push(compFieldName);
          }
        }
        
       
        var ovalue = value;
        dataSourceField = StringUtil.convertToFirstUpperCase(keyarr[1]) + "." + StringUtil.convertToFirstUpperCase(keyarr[2]);
        tempResult = this.getFormDataSourceField(dataSourceField,table);
        dataSourceFieldXML = tempResult?tempResult.field:null;
        
        if(!dataSourceFieldXML)
        {
          continue;
        }
        childIndex = dataSourceFieldsCollection.indexOf(dataSourceFieldXML);
        if(childIndex == -1)
          continue;
        fieldName = dataSourceFieldXML.name;
        var helpArray = fieldName.split(".");
        var fieldCutName= helpArray.length>0?helpArray[1]:fieldName;
        if(mapVisible && mapVisible.hasOwnProperty(table) && mapVisible[table].hasOwnProperty(fieldName))
        {
          if(mapVisible[table][fieldName] == false)
            continue;
        }
        if(mapLabel && mapLabel.hasOwnProperty(table) && mapLabel[table].hasOwnProperty(fieldName))
        {
          fieldLabel = mapLabel[table][fieldName];
        }
        else
        {
          fieldLabel = GOTUtil.getFinalValue(dataSourceFieldXML,formXML,"Label"); 
        }
        
        fieldpXML = GOTUtil.getProperty(dataSourceFieldXML,"Field");
        filterKey = fieldpXML.refentityid + fieldpXML.refinnerid;
        if(filter && filter.indexOf(filterKey)!=-1)
        {
          cacheValue = "";  
        }
        else
        {
          this.saveFieldCache(dataSourceFieldXML,table+"-"+keyarr[1]+"-"+keyarr[2]);
          cacheValue = this.convertValue(value,table + "-"+keyarr[1]+"-" + keyarr[2]);
        }
        
        
        if(mapSort && mapSort.hasOwnProperty(table) && mapSort[table].hasOwnProperty(compDataSourceFieldName))
        {
          var newCompDataSourceFieldNames = mapSort[table][compDataSourceFieldName];
          if(newCompDataSourceFieldNames && newCompDataSourceFieldNames.length>0)
          {
            childIndex+=(newCompDataSourceFieldNames.indexOf(fieldCutName) - compDataSourceFieldNames.indexOf(fieldName));
          }
        }
        dataProvider[childIndex] = {chLabel:fieldLabel,enLabel:fieldName,fvalue:cacheValue,
          dataField:key,fieldType:dataSourceFieldXML.type,dataSourceEnLabel:table};
      }
        
      
    }
    return {dataMethodFields:dataMethodFields,dataProvider:dataProvider};
  }

  doWriteField(values,triggerModified=false)
  {
    if(!this.currentRecord)
      return;
    for(let field in values)
    {
      if(field)
      {
        let value = values[field];
        field = StringUtil.convertToEachFirstLowerCase(field);
        let fullField = this.groupAlias+"."+field;
        let oldValue = this.currentRecord[fullField];
        if(this.currentRecord.hasOwnProperty(fullField))
          this.currentRecord[fullField] = value;
        let arr = fullField.split(".");
        RecordsActions.RecordFieldChanged(this.currentRecord,fullField,oldValue,value,null);
        if(triggerModified)
        {
          this.doFieldModifiedRemote(this.groupAlias,arr[1],arr.length>2?arr[2]:null,oldValue,value,fullField,this.currentRecord);
        }
      }
      
    }
  }

  updateDataMethodFieldValue(arg)
  {
    for(let key in arg)
    {
      if(this.mapRecId.hasOwnProperty(key))
      {
        let valueo = arg[key];
        let record = this.mapRecId[key];
        for(let valuekey in valueo)
        {
          let value = valueo[valuekey];
          let _valuekey = this.groupAlias + "." + StringUtil.convertToEachFirstLowerCase(valuekey);
          if(this.tempDataMethodField.hasOwnProperty(_valuekey))
          {
            let field = this.tempDataMethodField[_valuekey];
           // let _field = this.groupAlias + "." + StringUtil.convertToEachFirstLowerCase(field);
            if(record.hasOwnProperty(field))
            {
              if(!value)
                value = "";
              record[field] = value;

              RecordsActions.RecordDataMethodFieldChanged(record,field);

            }
          }
        }
      }
    }
  }

  async findValueStepByStepPre(args)
  {
    let value = args.value;
    let dataField = args.dataField;
    let records = this.records;
    let fromIndex = args.fromIndex;
    let stepColumn = args.stepColumn;
    if(!fromIndex)fromIndex = stepColumn?{row:0}:0;
    if(this.tempRecordsFilter)records = this.tempRecordsFilter;
    if(stepColumn == true)fromIndex = fromIndex.row;
    if(!stepColumn)
    {
      for(var i = fromIndex-2;i>-1;i--)
      {
        let record = records[i];
        let dataValue = record[dataField]+"";
        
        dataValue = this.getEnumLabelByDataField(dataField,dataValue);

        if(dataValue.indexOf(value) != -1)
        {
          FocusActions.scrollToAndFocus({groupAlias:this.groupAlias,toIndex:i,fromIndex:fromIndex,dataField:dataField});
          return Math.max(i+1,0);
        }
      }
    }
    else
    { 
      for(var i = fromIndex;i>-1;i--)
      {
        let record = records[i];
        let dataValue = record[dataField]+"";
       
        let preDataField = args.fromIndex?args.fromIndex.dataField:null;let fromIndex2 = args.fromIndex?args.fromIndex.row:fromIndex;
        let keys = args.dataFields;
        let startIndex = (!preDataField|| i!=fromIndex2 ||keys.indexOf(preDataField)==-1)?keys.length-1:keys.indexOf(preDataField);
        if(i!=fromIndex2)
        {
          preDataField = null;
        }
        for(let k = startIndex-1;k>-1;k--)
        //for(let key in record)
        {
          let key = keys[k];
          if(key == preDataField)
            continue;
          
          dataValue = record[key]+"";
          dataValue = this.getEnumLabelByDataField(key,dataValue);
          if(dataValue.indexOf(value) != -1)
          {
            FocusActions.scrollToAndFocus({groupAlias:this.groupAlias,toIndex:i,fromIndex:fromIndex2,dataField:key});
            return {row:i,dataField:key};
          }
        }
      }
        
      
    }
   
    return 0;
  }

  async findValueStepByStep(args)
  {
    
    let value = args.value;
    let dataField = args.dataField;
    let records = this.records;
    let fromIndex = args.fromIndex;
    let stepColumn = args.stepColumn;
    if(!fromIndex)fromIndex = stepColumn?{row:0}:0;
    if(this.tempRecordsFilter)records = this.tempRecordsFilter;
    if(stepColumn == true)fromIndex = fromIndex.row;
    for(var i = fromIndex;i<records.length;i++)
    {
      let record = records[i];
      let dataValue = record[dataField]+"";
      dataValue = this.getEnumLabelByDataField(dataField,dataValue);
      if(!stepColumn)
      {
        if(dataValue.indexOf(value) != -1)
        {
          FocusActions.scrollToAndFocus({groupAlias:this.groupAlias,toIndex:i,fromIndex:fromIndex,dataField:dataField});
          return i+1;
        }
      }
      else
      {
        if(stepColumn == true)
        {
          let preDataField = args.fromIndex?args.fromIndex.dataField:null;let fromIndex2 = args.fromIndex?args.fromIndex.row:fromIndex;
          let keys = args.dataFields;
          let startIndex = (!preDataField|| i!=fromIndex2 ||keys.indexOf(preDataField)==-1)?0:keys.indexOf(preDataField);
          if(i!=fromIndex2)
          {
            preDataField = null;
          }
          for(let k = startIndex;k<keys.length;k++)
          //for(let key in record)
          {
            let key = keys[k];
            if(key == preDataField)
              continue;
            dataValue = record[key]+"";
            dataValue = this.getEnumLabelByDataField(key,dataValue);
            if(dataValue.indexOf(value) != -1)
            {
              FocusActions.scrollToAndFocus({groupAlias:this.groupAlias,toIndex:i,fromIndex:fromIndex2,dataField:key});
              return {row:i,dataField:key};
            }
          }
        }
      }
    }
    //如果都没找到 则应执行下一页查询
    await this.executeQueryAutoSaveStop("NextPage");
    if(stepColumn == true)
    {
      args.formIndex = {row:i+1};
    }
    else
    {
      args.fromIndex = i+1;
    }
    
    args.stackDeep++;
    return this.findValueStepByStep2(args);
  }

  findValueStepByStep2(args)
  {
    let value = args.value;
    let dataField = args.dataField;
    let records = this.records;
    let fromIndex = args.fromIndex;
    let stepColumn = args.stepColumn;
    if(!fromIndex)fromIndex = stepColumn?{row:0}:0;;
    if(this.tempRecordsFilter)records = this.tempRecordsFilter;
    if(stepColumn == true)fromIndex = fromIndex.row;
    for(var i = fromIndex;i<records.length;i++)
    {
      let record = records[i];
      let dataValue = record[dataField]+"";
      dataValue = this.getEnumLabelByDataField(dataField,dataValue);
      if(!stepColumn)
      {
        if(dataValue.indexOf(value) != -1)
        {
          FocusActions.scrollToAndFocus({groupAlias:this.groupAlias,toIndex:i,fromIndex:fromIndex,dataField:dataField});
          return i+1;
        }
      }
      else
      {
        let preDataField = args.fromIndex?args.fromIndex.dataField:null;let fromIndex2 = args.fromIndex?args.fromIndex.row:fromIndex;
        let keys = args.dataFields;
        let startIndex = (!preDataField|| i!=fromIndex2 || keys.indexOf(preDataField)==-1)?0:keys.indexOf(preDataField);
        if(i!=fromIndex2)
        {
          preDataField = null;
        }
        for(let k = startIndex;k<keys.length;k++)
        //for(let key in record)
        {
          let key = keys[k];
          if(key == preDataField)
            continue;
          dataValue = record[key]+"";
          dataValue = this.getEnumLabelByDataField(key,dataValue);
          if(dataValue.indexOf(value) != -1)
          {
            FocusActions.scrollToAndFocus({groupAlias:this.groupAlias,toIndex:i,fromIndex:fromIndex2,dataField:key});
            return {row:i,dataField:key};
          }
        }
      }
  
    }
    return -1;
  }

  getEnumLabelByDataField(dataField,dataValue)
  {
    let formItemControl = FormItemUtil.getFormItemControlByDataField(dataField);
    if(formItemControl && formItemControl.classAlias == "FormItemEnumEditorControl")
    {
      var _properties = GOTPropertiesUtil.getItemPropertyFinalValue(window.menuItemId,formItemControl.formId,formItemControl.innerId);
      var _dataProvider = _properties.DataProvider;
      if(_dataProvider)
      {
        for(let i = 0;i<_dataProvider.length;i++)
        {
          let enumItem = _dataProvider[i];
          if((enumItem.value+"") ==  (dataValue+""))
          {
            dataValue = enumItem.label;
          }
        }
      }
    }
    return dataValue;
  }


  getDataInfoForPrint () {
    var result = this.getRecTotalDataProvider();
    if (!result)
      return null;
    var dataMethodFields = result.dataMethodFields;
    var dataProvider = result.dataProvider;
    var printInfo = { billhead: { metadata: [], headdata: {} }, billbody: { metadata: [], bodydata: [] } ,dataForLuckySheet:[]};
    if (dataMethodFields.length > 0) {
      var fdataProvider = new ArrayList();
      for (var _item in dataProvider) {
        fdataProvider.addItem(dataProvider[_item]);
      }
      for (_item in dataMethodFields) {
        fdataProvider.addItem(dataMethodFields[_item]);
      }
    }
    else {
      fdataProvider = dataProvider;
    }

    for (var item in fdataProvider) {
      printInfo.billhead.metadata.push({ name: fdataProvider[item].enLabel, type: fdataProvider[item].fieldType });
      printInfo.billhead.headdata[fdataProvider[item].enLabel] = fdataProvider[item].fvalue;
    }
    var b={};
    for (var item in fdataProvider) {
      var a = fdataProvider[item].dataSourceEnLabel;
      b[a] = "";
    }
    for (var key in b) {
      var h =[];
      var c ={};
      for (var item in fdataProvider) {
        var a = fdataProvider[item].dataSourceEnLabel;
        if(a == key){
          c[fdataProvider[item].enLabel] = fdataProvider[item].fvalue;
        }
      }
      h.push(c);
      var g={};
      g[this.tableName] = {"records":h};
      printInfo.dataForLuckySheet.push(g);
    }


    var formDataSources = this.formDataSources;
    for (var key in formDataSources.groups) {
      var group = formDataSources.groups[key];
      if (group.linkType == 'Delayed' && group.linkGroup == this) {
        var bodyGroup = group;
        break;
      }
    }

    if (bodyGroup) {
      bodyGroup.getBillBodyInfoForPrint(printInfo.billbody,printInfo.dataForLuckySheet);
    }
    return printInfo;

  }


  getBillBodyInfoForPrint (billbody,dataForLuckySheet) {
    var result = this.getRecTotalDataProvider();
    if (!result)
      return;
    var dataMethodFields = result.dataMethodFields;
    var dataProvider = result.dataProvider;

    if (dataMethodFields.length > 0) {
      var fdataProvider = new ArrayList();
      for (var _item in dataProvider) {
        fdataProvider.addItem(dataProvider[_item]);
      }
      for (_item in dataMethodFields) {
        fdataProvider.addItem(dataMethodFields[_item]);
      }
    }
    else {
      fdataProvider = dataProvider;
    }

    for (var item in fdataProvider) {
      billbody.metadata.push({ name: fdataProvider[item].enLabel, type: fdataProvider[item].fieldType });
    }

    for (var record in this.records) {
      var bodydataItem = {};
      for (item in fdataProvider) {
        var dataField = fdataProvider[item].dataField;
        // bodydataItem[fdataProvider[item].enLabel] = this.getComplexRecordFinalValue(this.records[record], dataField).bind(this);
        bodydataItem[fdataProvider[item].enLabel] = this.records[record][dataField];
      }

      billbody.bodydata.push(bodydataItem);

    }

    var c={};
    for (var record in this.records) {
      var bodydataItem = {};
      for (item in fdataProvider) {
        c[fdataProvider[item].dataSourceEnLabel] ="";
      }
    }

    for(var key in c){
      var d =[];
      this.records.forEach((item)=>{
        var e ={};
        for (var key in item) {
            if(key.indexOf(".") != -1)
            var ke = key.substring(key.indexOf(".")+1);
             var ekey = ke.slice(0,1).toUpperCase()+ke.slice(1);
            e[ekey] = item[key];
          }
          d.push(e);
      })
      // for (var record in this.records) {
      //   var bodydataItem = {};
       
      //   for (item in fdataProvider) {
      //     if(fdataProvider[item].dataSourceEnLabel == key){
      //       e[fdataProvider[item].enLabel] = fdataProvider[item].fvalue;
      //     }
      //   }
      //   d.push(e);
      // }
      var h={};
      h[this.tableName] = {"records":d};
      dataForLuckySheet.push(h);
    }
  }

  dataSetExportBtn(){
    if(window.parent.window.dataSet){
      // window.parent.window.dataSet.dataRow = this.records;
      // var table = GOT.getTable(window.parent.window.dataSet.queryTable.tableId);
      // var name =table.Properties.Label.V;
      // var location = "root/desk";

      var dataSet = DataSetUtil.strDataSet(window.parent.window.dataSet,this.records);
      var suffix = ".ds";
      var content = {
        'title':"",
        'content':dataSet
      };
      window.parent.window.parent.window.saveFile(suffix, content);
    }
  }

  dataSetRecrods(){
    if(window.parent.dataSetPreview){
      window.parent.dataSetPreview.dataRows = this.records;
    }
  }


  doPivotExport(filter,isPivot = false,flag=null)
  {
    if(!this.getAuthorityFinal("test",FormDataSourceAuthorityType.Export,this.currentRecord))
      return;
    /*if(!this.getAuthorityByXML(FormDataSourceAuthorityType.exportStr))
      return;*/
    var _showTableName = true;
    var columns = null;
    var key;
    if(window.formId.indexOf(".") == -1 && window.menuItemId.indexOf(".") == -1)
    {
      key = window.formId + "_" + this.mainSource.xml.id  + (window.menuItemId?"."+window.menuItemId:"");
    }
    else
    {
      key = window.formId + "_" + this.mainSource.xml.id  + (window.menuItemId?"&"+window.menuItemId:"");
    }
    if(flag=='drop'){
      window.parent.window.toolbarExportDrop(key)
      return;
    }
    
    var _title = null;
    if(!isPivot)
    {
      //var setting = FormDataSources.userExportList;//((window.parent && window.parent.window)?window.parent.window.userExportList:{});
      
      var settingXML = FormDataSources.getUserDefaultExportList(key);
      if(settingXML)
      {
        var settingdoc = (new DOMParser()).parseFromString(settingXML,"application/xml");
        var settingdocNode0 = settingdoc.childNodes[0];
        _showTableName = (settingdocNode0.attributes.showTableName.nodeValue)=="true"?true:false;
        _title = this.getExportSettingTitle(settingdoc,key);
        //columns = this.consOnedimensionalGridColBySetting(FormDataSources.userExportList[key]);
        columns = this.consOnedimensionalGridColBySetting(settingdocNode0);
      }
      else
      {
        columns = this.consOnedimensionalGridColByView(null,filter,isPivot);
      }
    }
    else
    {
      columns = this.consOnedimensionalGridColByView(null,filter,isPivot);
      _title = "数据分析设置";
    }
    
    let _records = this.records;
    if(this.mainSource.isTempTable == true && this.tempRecordsFilter)
    {
      _records = this.tempRecordsFilter;
    }

    var ac = this.convertToOnedimensional(_records,filter);

    var extrals = this.getExtralExportFields(columns,filter);
    
    let strac =  JSON.stringify(ac);
    let jsonac = JSON.parse(strac);
    if(window.isDataSetView){
      for(let kk = 0;kk<jsonac.length;kk++)
      {
        let dsItem = jsonac[kk];
        for(let k in dsItem)
        {
          //导出时 如果是Enum 类型 取值存在 问题  如果是Date 日期类型 先转为String
          for(let j in columns){
            let sht = k.substring(k.lastIndexOf(".")+1,k.length);
            let shtc = columns[j].dataField.substring(columns[j].dataField.lastIndexOf(".")+1,columns[j].dataField.length);
            if(columns[j].fieldType == "Enum" && sht == shtc){
              for(let ii in this.dataSetQueryTable.allQueryFields){
                if((this.dataSetQueryTable.allQueryFields[ii].fieldAliasName && this.groupAlias+"."+this.dataSetQueryTable.allQueryFields[ii].fieldAliasName == k)
                ||(this.groupAlias+"."+StringUtil.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[ii].fieldName)) == k){
                  var newFieldValue = "";
                  var table = GOT.getTable(this.dataSetQueryTable.allQueryFields[ii].refEntityId);
                  if(table){
                    var tableField = GOT.getTableField(table,this.dataSetQueryTable.allQueryFields[ii].refInnerId);
                    if(tableField){
                      var enumId = tableField.Properties.Extends.refentityid;
                      var enumItem = GOT.getEnum(enumId);
                      if(enumItem){
                        for(let ein in enumItem.EnumItems){
                          let its = enumItem.EnumItems[ein];
                          if(dsItem[k]== its.Properties.Value.V || dsItem[k]== (its.Properties.Value.V+"")){
                            newFieldValue = its.Properties.Label.V?its.Properties.Label.V:its.Properties.Label.Value;
                            break;
                          }
                        }
                      }
                    }
                  }
                  dsItem[k] = newFieldValue;
                }
            }
            }
            if(columns[j].fieldType == "Decimal" && dsItem[k]!=null && dsItem[k]!='null'){
                if(this.groupAlias+"."+columns[j].normalHeaderText == k){
                  dsItem[k] = FormItemDecimalDisplay.getDisplayText(dsItem[k],columns[j].showZero,
                    columns[j].numOfDecimals?columns[j].numOfDecimals:2,columns[j].thousandSeperator,{});
                }
              }
              if(columns[j].fieldType == "Decimal" && dsItem[k]!=null && dsItem[k]!='null'){
                if(dsItem[k].indexOf(',') != -1){
                  dsItem[k] = dsItem[k].replace(/,/g, "");
                }
              }
          }
          for(let i in this.dataSetQueryTable.allQueryFields){
            if((this.dataSetQueryTable.allQueryFields[i].fieldAliasName && this.groupAlias+"."+this.dataSetQueryTable.allQueryFields[i].fieldAliasName == k)
            ||(this.groupAlias+"."+StringUtil.convertToFirstLowerCase(this.dataSetQueryTable.allQueryFields[i].fieldName)) == k){
              if(dsItem[k] == null || dsItem[k] == 'null'){
                dsItem[k]='';
              }
              if(window.parent.window.dataSet ){
                let dcolumns =  window.parent.window.dataSet.dataColumn.columns;
                for(let col in dcolumns){
                  if(col == this.dataSetQueryTable.allQueryFields[i].fieldAliasName || col == this.dataSetQueryTable.allQueryFields[i].fieldName){
                    if(dcolumns[col].dataType =="Date" && dcolumns[col].displayFormat){
                      dsItem[k] = FormItemDateDisplay.getDisplayText2( dsItem[k],dcolumns[col].displayFormat.toUpperCase());
                    }
                    if(dcolumns[col].dataType =="Time" && dcolumns[col].displayFormat){
                      dsItem[k] = FormItemTimeDisplay.getDisplayText2( dsItem[k],dcolumns[col].displayFormat.toUpperCase());
                    }
                    if(dcolumns[col].dataType =="Decimal" && dcolumns[col].displayFormat){
                      dsItem[k] = FormItemDecimalDisplay.getDisplayText2( dsItem[k],dcolumns[col].displayFormat.toUpperCase());
                    }
                  }
                }
              }
              dsItem[this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName] = dsItem[k];
              let dataSource = this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.substring(0,this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.indexOf("."))
              dsItem[dataSource+"."+this.dataSetQueryTable.allQueryFields[i].fieldAliasName] = dsItem[k];
              if(this.dataSetQueryTable.allQueryFields[i].dataSourceFliedName.indexOf(this.groupAlias) == -1){
                delete dsItem[k];
              }
            }
          } 
        }
      }
      ac =jsonac;
      extrals=[];
    }
    if(window.isDataSetView){
      for(let j in columns){
        let col = columns[j];
        col.dataField = this.mainSource.alias+'.'+col.dataField.substring(col.dataField.lastIndexOf('.')+1);
      }
    }

    var htmlarg = {columns:columns,extrals:extrals,ac:ac,key:key,showTableName:_showTableName,isPivot:isPivot,group:this};
    // ReactDOM.render( <ExportTable htmlarg={htmlarg} initExport={flag} />,document.getElementById('exportModal'));
    return htmlarg;
  }
  
}


// WEBPACK FOOTER //
// ./src/datasource/FormDataSourceGroup.js